export const playersData = {
    "olsen": {
        "displayName": "Robin Olsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-01-08"
    },
    "stiangregersen": {
        "displayName": "Stian Gregersen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Norway",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-05-17"
    },
    "bleonkurtulus": {
        "displayName": "Bleon Kurtulus",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2007-06-24"
    },
    "andrejuric": {
        "displayName": "Andrej Đurić",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Montenegro",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-09-21"
    },
    "yaniskarabelyov": {
        "displayName": "Yanis Karabelyov",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Bulgaria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-01-23"
    },
    "rosengren": {
        "displayName": "Otto Rosengren",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-05-16"
    },
    "diegogarcia": {
        "displayName": "Diego García",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-04-18"
    },
    "christiansen": {
        "displayName": "Anders Christiansen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1990-06-08"
    },
    "ekong": {
        "displayName": "Emmanuel Ekong",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-06-25"
    },
    "warrenkamanzi": {
        "displayName": "Warren Kamanzi",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Norway",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2000-11-11"
    },
    "mayckellahdo": {
        "displayName": "Mayckel Lahdo",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Forward",
        "number": 15,
        "dateofbirth": "2002-12-30"
    },
    "jensstryger": {
        "displayName": "Jens Stryger",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Denmark",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1991-02-21"
    },
    "jansson": {
        "displayName": "Pontus Jansson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1991-02-13"
    },
    "noahjohn": {
        "displayName": "Noah John",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2003-12-13"
    },
    "oscarsjostrand": {
        "displayName": "Oscar Sjöstrand",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2004-11-08"
    },
    "gabrielbusanello": {
        "displayName": "Gabriel Busanello",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Brazil",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1998-10-29"
    },
    "dahlin": {
        "displayName": "Johan Dahlin",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 27,
        "dateofbirth": "1986-09-08"
    },
    "jovanmilosavljevic": {
        "displayName": "Jovan Milosavljević",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2007-02-08"
    },
    "haksabanovic": {
        "displayName": "Sead Hakšabanović",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Montenegro",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-05-04"
    },
    "danielgujohnsen": {
        "displayName": "Daníel Guðjohnsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Iceland",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2006-03-01"
    },
    "adrianskogmar": {
        "displayName": "Adrian Skogmar",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2005-11-23"
    },
    "isaacassibu": {
        "displayName": "Isaac Assibu",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Ghana",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2008-01-14"
    },
    "busuladzic": {
        "displayName": "Kenan Busuladžić",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 40,
        "dateofbirth": "2007-02-06"
    },
    "viggojeppsson": {
        "displayName": "Viggo Jeppsson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2006-03-24"
    },
    "antonhoog": {
        "displayName": "Anton Höög",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2007-03-19"
    },
    "theodorlundbergh": {
        "displayName": "Theodor Lundbergh",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2008-08-21"
    },
    "williamnieroth": {
        "displayName": "William Nieroth",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2006-03-13"
    },
    "christianfruchtl": {
        "displayName": "Christian Früchtl",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-01-28"
    },
    "mellberg": {
        "displayName": "John Mellberg",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Sweden",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-07-30"
    },
    "diabate": {
        "displayName": "Soumaïla Diabaté",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Mali",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2004-11-22"
    },
    "umuttohumcu": {
        "displayName": "Umut Tohumcu",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2004-08-11"
    },
    "kitano": {
        "displayName": "Sōta Kitano",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Japan",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-08-13"
    },
    "haristabakovic": {
        "displayName": "Haris Tabaković",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1994-06-20"
    },
    "vertessen": {
        "displayName": "Yorbe Vertessen",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-01-08"
    },
    "kratzig": {
        "displayName": "Frans Krätzig",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2003-01-14"
    },
    "bartoszmazurek": {
        "displayName": "Bartosz Mazurek",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2007-01-03"
    },
    "nikolasveratschnig": {
        "displayName": "Nikolas Veratschnig",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-01-24"
    },
    "karimkonate": {
        "displayName": "Karim Konaté",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-03-21"
    },
    "edmundbaidoo": {
        "displayName": "Edmund Baidoo",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Ghana",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2006-01-30"
    },
    "timdrexler": {
        "displayName": "Tim Drexler",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2005-03-06"
    },
    "lainer": {
        "displayName": "Stefan Lainer",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1992-08-27"
    },
    "damirredzic": {
        "displayName": "Damir Redzic",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Hungary",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-03-23"
    },
    "johannesmoser": {
        "displayName": "Johannes Moser",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2008-01-16"
    },
    "filipmatijasevic": {
        "displayName": "Filip Matijašević",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2008-03-04"
    },
    "gaoussoudiakite": {
        "displayName": "Gaoussou Diakité",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Mali",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2005-09-26"
    },
    "schmid": {
        "displayName": "Dominik Schmid",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "1998-03-10"
    },
    "abubakrbarry": {
        "displayName": "Abubakr Barry",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Gambia",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2000-07-02"
    },
    "jesperlindstrm": {
        "displayName": "Jesper Lindstrøm",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2000-02-29"
    },
    "justinomoregie": {
        "displayName": "Justin Omoregie",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "2003-09-21"
    },
    "leandromorgalla": {
        "displayName": "Leandro Morgalla",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2004-09-13"
    },
    "enriqueaguilar": {
        "displayName": "Enrique Aguilar",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Switzerland",
        "position": "Forward",
        "number": 43,
        "dateofbirth": "2007-01-27"
    },
    "kevinboma": {
        "displayName": "Kévin Boma",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Togo",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-11-20"
    },
    "zawieschitzky": {
        "displayName": "Christian Zawieschitzky",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 52,
        "dateofbirth": "2007-05-02"
    },
    "chase": {
        "displayName": "Anrie Chase",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Japan",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2004-03-24"
    },
    "jonstankovic": {
        "displayName": "Jon Gorenc Stanković",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-01-14"
    },
    "albertvallci": {
        "displayName": "Albert Vallçi",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-07-02"
    },
    "rozga": {
        "displayName": "Filip Rózga",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-08-07"
    },
    "grgic": {
        "displayName": "Leon Grgić",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Croatia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2006-01-22"
    },
    "kiteishvili": {
        "displayName": "Otar Kiteishvili",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-03-26"
    },
    "kayombo": {
        "displayName": "Axel Kayombo",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "DR Congo",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2006-02-25"
    },
    "oumardiakite": {
        "displayName": "Oumar Diakité",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-12-20"
    },
    "gizomamageishvili": {
        "displayName": "Gizo Mamageishvili",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2003-01-15"
    },
    "szymonwodarczyk": {
        "displayName": "Szymon Włodarczyk",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Poland",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-01-05"
    },
    "emransoglo": {
        "displayName": "Emran Soglo",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "England",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2005-07-11"
    },
    "simonseidl": {
        "displayName": "Simon Seidl",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2002-09-04"
    },
    "jatta": {
        "displayName": "Seedy Jatta",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Norway",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2003-03-18"
    },
    "petarpetrovic": {
        "displayName": "Petar Petrović",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Serbia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2005-07-13"
    },
    "malic": {
        "displayName": "Arjan Malić",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2005-08-28"
    },
    "belminbeganovic": {
        "displayName": "Belmin Beganović",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2004-09-09"
    },
    "luisbalbo": {
        "displayName": "Luis Balbo",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Venezuela",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2006-03-28"
    },
    "jurgenheil": {
        "displayName": "Jürgen Heil",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "1997-04-04"
    },
    "geyrhofer": {
        "displayName": "Niklas Geyrhofer",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2000-02-11"
    },
    "lucaweinhandl": {
        "displayName": "Luca Weinhandl",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2009-01-11"
    },
    "jacobhodl": {
        "displayName": "Jacob Hödl",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2007-01-31"
    },
    "nelsonweiper": {
        "displayName": "Nelson Weiper",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 44,
        "dateofbirth": "2005-03-17"
    },
    "khudyakov": {
        "displayName": "Daniil Khudyakov",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 53,
        "dateofbirth": "2004-01-09"
    },
    "flekken": {
        "displayName": "Mark Flekken",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1993-06-13"
    },
    "facundomedina": {
        "displayName": "Facundo Medina",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-05-28"
    },
    "gutierrez": {
        "displayName": "Miguel Gutiérrez",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-07-27"
    },
    "quansah": {
        "displayName": "Jarell Quansah",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-01-29"
    },
    "bade": {
        "displayName": "Loïc Badé",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-04-11"
    },
    "equifernandez": {
        "displayName": "Equi Fernández",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-07-25"
    },
    "hofmann": {
        "displayName": "Jonas Hofmann",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1992-07-14"
    },
    "andrich": {
        "displayName": "Robert Andrich",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-09-22"
    },
    "moreira": {
        "displayName": "Afonso Moreira",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2005-03-19"
    },
    "maliktillman": {
        "displayName": "Malik Tillman",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "United States",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-06-16"
    },
    "terrier": {
        "displayName": "Martin Terrier",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-03-04"
    },
    "tapsoba": {
        "displayName": "Edmond Tapsoba",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-02-02"
    },
    "schick": {
        "displayName": "Patrik Schick",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1996-01-24"
    },
    "oermann": {
        "displayName": "Tim Oermann",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2003-10-06"
    },
    "lucasvazquez": {
        "displayName": "Lucas Vázquez",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1991-07-01"
    },
    "kenneteichhorn": {
        "displayName": "Kennet Eichhorn",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2009-07-27"
    },
    "moussadiaby": {
        "displayName": "Moussa Diaby",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-07-07"
    },
    "gueladoue": {
        "displayName": "Guéla Doué",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-10-17"
    },
    "victorboniface": {
        "displayName": "Victor Boniface",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2000-12-23"
    },
    "tella": {
        "displayName": "Nathan Tella",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1999-07-05"
    },
    "aleixgarcia": {
        "displayName": "Aleix García",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1997-06-28"
    },
    "blaswich": {
        "displayName": "Janis Blaswich",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1991-05-02"
    },
    "benseghir": {
        "displayName": "Eliesse Ben Seghir",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2005-02-16"
    },
    "maza": {
        "displayName": "Ibrahim Maza",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2005-11-24"
    },
    "kofane": {
        "displayName": "Christian Kofane",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Cameroon",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2006-05-19"
    },
    "lomb": {
        "displayName": "Niklas Lomb",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1993-07-28"
    },
    "montrellculbreath": {
        "displayName": "Montrell Culbreath",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2007-08-29"
    },
    "neuer": {
        "displayName": "Manuel Neuer",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-03-27"
    },
    "upamecano": {
        "displayName": "Dayot Upamecano",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-10-27"
    },
    "kim": {
        "displayName": "Kim Min-jae",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "South Korea",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-11-15"
    },
    "tah": {
        "displayName": "Jonathan Tah",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-02-11"
    },
    "kimmich": {
        "displayName": "Joshua Kimmich",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1995-02-08"
    },
    "gnabry": {
        "displayName": "Serge Gnabry",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-07-14"
    },
    "bischof": {
        "displayName": "Tom Bischof",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2005-06-28"
    },
    "kane": {
        "displayName": "Harry Kane",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-07-28"
    },
    "musiala": {
        "displayName": "Jamal Musiala",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-02-26"
    },
    "nbrown": {
        "displayName": "Nathaniel Brown",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 11,
        "dateofbirth": "2003-06-16"
    },
    "diaz": {
        "displayName": "Luis Díaz",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Colombia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-01-13"
    },
    "olise": {
        "displayName": "Michael Olise",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-12-12"
    },
    "davies": {
        "displayName": "Alphonso Davies",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Canada",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2000-11-02"
    },
    "ito": {
        "displayName": "Hiroki Itō",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Japan",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1999-05-12"
    },
    "boey": {
        "displayName": "Sacha Boey",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2000-09-13"
    },
    "ulreich": {
        "displayName": "Sven Ulreich",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "1988-08-03"
    },
    "laimer": {
        "displayName": "Konrad Laimer",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1997-05-27"
    },
    "saibari": {
        "displayName": "Ismael Saibari",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "2001-01-28"
    },
    "barandiaye": {
        "displayName": "Bara Sapoko Ndiaye",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2007-12-31"
    },
    "urbig": {
        "displayName": "Jonas Urbig",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2003-08-08"
    },
    "karl": {
        "displayName": "Lennart Karl",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2008-05-31"
    },
    "stanisic": {
        "displayName": "Josip Stanišić",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Croatia",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2000-04-02"
    },
    "alekspavlovic": {
        "displayName": "Aleksandar Pavlović",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2004-05-03"
    },
    "daviddaiber": {
        "displayName": "David Santos Daiber",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2007-01-10"
    },
    "kobel": {
        "displayName": "Gregor Kobel",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-12-06"
    },
    "anton": {
        "displayName": "Waldemar Anton",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-07-20"
    },
    "schlotterbeck": {
        "displayName": "Nico Schlotterbeck",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-12-01"
    },
    "bensebaini": {
        "displayName": "Ramy Bensebaini",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-04-16"
    },
    "jobebellingham": {
        "displayName": "Jobe Bellingham",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "England",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2005-09-23"
    },
    "nmecha": {
        "displayName": "Felix Nmecha",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-10-10"
    },
    "guirassy": {
        "displayName": "Serhou Guirassy",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Guinea",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1996-03-12"
    },
    "beier": {
        "displayName": "Maximilian Beier",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2002-10-17"
    },
    "chukwuemeka": {
        "displayName": "Carney Chukwuemeka",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-10-20"
    },
    "nwaneri": {
        "displayName": "Ethan Nwaneri",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "England",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2007-03-21"
    },
    "karetsas": {
        "displayName": "Konstantinos Karetsas",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Greece",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2007-11-19"
    },
    "sabitzer": {
        "displayName": "Marcel Sabitzer",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-03-17"
    },
    "fabiosilva": {
        "displayName": "Fábio Silva",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2002-07-19"
    },
    "gadou": {
        "displayName": "Joane Gadou",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2007-01-17"
    },
    "emrecan": {
        "displayName": "Emre Can",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1994-01-12"
    },
    "danielsvensson": {
        "displayName": "Daniel Svensson",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Sweden",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2002-02-12"
    },
    "veerman": {
        "displayName": "Joey Veerman",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1998-11-19"
    },
    "ryerson": {
        "displayName": "Julian Ryerson",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Norway",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1997-11-17"
    },
    "justinlerma": {
        "displayName": "Justin Lerma",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Ecuador",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2008-05-05"
    },
    "drewes": {
        "displayName": "Patrick Drewes",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1993-02-04"
    },
    "silasostrzinski": {
        "displayName": "Silas Ostrzinski",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2003-11-19"
    },
    "meyer": {
        "displayName": "Alexander Meyer",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1991-04-13"
    },
    "kauaprates": {
        "displayName": "Kauã Prates",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Defender",
        "number": 36,
        "dateofbirth": "2008-08-12"
    },
    "filippomane": {
        "displayName": "Filippo Mane",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Italy",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2005-03-08"
    },
    "samueleinacio": {
        "displayName": "Samuele Inácio",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Italy",
        "position": "Forward",
        "number": 40,
        "dateofbirth": "2008-04-02"
    },
    "mathisalbert": {
        "displayName": "Mathis Albert",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "United States",
        "position": "Forward",
        "number": 41,
        "dateofbirth": "2009-05-21"
    },
    "enzosantos": {
        "displayName": "Enzo dos Santos",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Luxembourg",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2009-01-28"
    },
    "konstantelias": {
        "displayName": "Giannis Konstantelias",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Greece",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2003-03-05"
    },
    "mussakaba": {
        "displayName": "Mussa Kaba",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 48,
        "dateofbirth": "2008-11-17"
    },
    "lucareggiani": {
        "displayName": "Luca Reggiani",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Italy",
        "position": "Defender",
        "number": 49,
        "dateofbirth": "2008-01-09"
    },
    "noahatubolu": {
        "displayName": "Noah Atubolu",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-05-25"
    },
    "eliasbaum": {
        "displayName": "Elias Baum",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-10-26"
    },
    "lilianbrassier": {
        "displayName": "Lilian Brassier",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-11-02"
    },
    "robinkoch": {
        "displayName": "Robin Koch",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-07-17"
    },
    "otavio": {
        "displayName": "Otávio",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-02-09"
    },
    "oscarhojlund": {
        "displayName": "Oscar Højlund",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-01-04"
    },
    "knauff": {
        "displayName": "Ansgar Knauff",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-01-10"
    },
    "chaibi": {
        "displayName": "Farès Chaïbi",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-11-28"
    },
    "burkardt": {
        "displayName": "Jonathan Burkardt",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-07-11"
    },
    "younesebnoutalib": {
        "displayName": "Younes Ebnoutalib",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-09-13"
    },
    "doan": {
        "displayName": "Ritsu Dōan",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Japan",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "1998-06-16"
    },
    "chandler": {
        "displayName": "Timothy Chandler",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "United States",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1990-03-29"
    },
    "onyedika": {
        "displayName": "Raphael Onyedika",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-04-19"
    },
    "keitakosugi": {
        "displayName": "Keita Kosugi",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Japan",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-03-18"
    },
    "gotze": {
        "displayName": "Mario Götze",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1992-06-03"
    },
    "ayoubeamaimouni": {
        "displayName": "Ayoube Amaimouni",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2004-11-30"
    },
    "lovearrhov": {
        "displayName": "Love Arrhov",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 31,
        "dateofbirth": "2008-05-17"
    },
    "grahl": {
        "displayName": "Jens Grahl",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1988-09-22"
    },
    "collins": {
        "displayName": "Nnamdi Collins",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2004-01-10"
    },
    "malikpimpong": {
        "displayName": "Malik Pimpong",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2008-01-01"
    },
    "jeremiahamaluze": {
        "displayName": "Jeremiaha Maluze",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2004-11-11"
    },
    "siljevic": {
        "displayName": "Amil Šiljević",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "2007-06-08"
    },
    "kauasantos": {
        "displayName": "Kauã Santos",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2003-04-11"
    },
    "uzun": {
        "displayName": "Can Uzun",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Turkey",
        "position": "Forward",
        "number": 42,
        "dateofbirth": "2005-11-11"
    },
    "jessicngankam": {
        "displayName": "Jessic Ngankam",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 44,
        "dateofbirth": "2000-07-20"
    },
    "nyland": {
        "displayName": "Ørjan Nyland",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Norway",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-09-10"
    },
    "abdoulkone": {
        "displayName": "Abdoul Koné",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-04-22"
    },
    "maximeesteve": {
        "displayName": "Maxime Estève",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-05-26"
    },
    "orban": {
        "displayName": "Willi Orbán",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Hungary",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1992-11-03"
    },
    "banzuzi": {
        "displayName": "Ezechiel Banzuzi",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "DR Congo",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-01-31"
    },
    "nusa": {
        "displayName": "Antonio Nusa",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Norway",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2005-04-17"
    },
    "ouedraogo": {
        "displayName": "Assan Ouédraogo",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-05-09"
    },
    "marcguiu": {
        "displayName": "Marc Guiu",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2006-01-04"
    },
    "brajangruda": {
        "displayName": "Brajan Gruda",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2004-05-31"
    },
    "bakayoko": {
        "displayName": "Johan Bakayoko",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-04-20"
    },
    "seiwald": {
        "displayName": "Nicolas Seiwald",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "2001-05-04"
    },
    "baumgartner": {
        "displayName": "Christoph Baumgartner",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1999-08-01"
    },
    "klostermann": {
        "displayName": "Lukas Klostermann",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1996-06-03"
    },
    "ridlebaku": {
        "displayName": "Ridle Baku",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-04-08"
    },
    "roccoreitz": {
        "displayName": "Rocco Reitz",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2002-05-29"
    },
    "elaynaoui": {
        "displayName": "Neil El Aynaoui",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2001-07-02"
    },
    "raum": {
        "displayName": "David Raum",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1998-04-22"
    },
    "lukeba": {
        "displayName": "Castello Lukeba",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2002-12-17"
    },
    "zingerle": {
        "displayName": "Leopold Zingerle",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1994-04-10"
    },
    "vandevoordt": {
        "displayName": "Maarten Vandevoordt",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "2002-02-26"
    },
    "gomis": {
        "displayName": "Tidiam Gomis",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2006-08-08"
    },
    "nkunku": {
        "displayName": "Christopher Nkunku",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1997-11-14"
    },
    "maksimovic": {
        "displayName": "Andrija Maksimović",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2007-06-05"
    },
    "finkgrafe": {
        "displayName": "Max Finkgräfe",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2004-03-04"
    },
    "henrichs": {
        "displayName": "Benjamin Henrichs",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "1997-02-23"
    },
    "romulo": {
        "displayName": "Rômulo",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Forward",
        "number": 40,
        "dateofbirth": "2002-02-08"
    },
    "sambakonate": {
        "displayName": "Samba Konaté",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2009-02-27"
    },
    "bredlow": {
        "displayName": "Fabian Bredlow",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-02"
    },
    "aldakhil": {
        "displayName": "Ameen Al-Dakhil",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-03-06"
    },
    "hendriks": {
        "displayName": "Ramon Hendriks",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-07-18"
    },
    "vagnoman": {
        "displayName": "Josha Vagnoman",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-12-11"
    },
    "stiller": {
        "displayName": "Angelo Stiller",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-04-04"
    },
    "mittelstadt": {
        "displayName": "Maximilian Mittelstädt",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "1997-03-18"
    },
    "tiagotomas": {
        "displayName": "Tiago Tomás",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2002-06-16"
    },
    "demirovic": {
        "displayName": "Ermedin Demirović",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-03-25"
    },
    "fuhrich": {
        "displayName": "Chris Führich",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-01-09"
    },
    "elkhannouss": {
        "displayName": "Bilal El Khannouss",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2004-05-10"
    },
    "jaquez": {
        "displayName": "Luca Jaquez",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2003-06-02"
    },
    "karazor": {
        "displayName": "Atakan Karazor",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1996-10-13"
    },
    "dzenanpejcinovic": {
        "displayName": "Dženan Pejčinović",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2005-02-15"
    },
    "leweling": {
        "displayName": "Jamie Leweling",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2001-02-26"
    },
    "stergiou": {
        "displayName": "Leonidas Stergiou",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-03-03"
    },
    "grischapromel": {
        "displayName": "Grischa Prömel",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1995-01-09"
    },
    "assignon": {
        "displayName": "Lorenz Assignon",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2000-06-22"
    },
    "zagadou": {
        "displayName": "Dan-Axel Zagadou",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-06-03"
    },
    "chabot": {
        "displayName": "Jeff Chabot",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1998-02-12"
    },
    "undav": {
        "displayName": "Deniz Undav",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1996-07-19"
    },
    "nartey": {
        "displayName": "Nikolas Nartey",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2000-02-22"
    },
    "jeltsch": {
        "displayName": "Finn Jeltsch",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2006-07-17"
    },
    "diehl": {
        "displayName": "Justin Diehl",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2004-11-27"
    },
    "mariusfunk": {
        "displayName": "Marius Funk",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1996-01-01"
    },
    "dennisseimen": {
        "displayName": "Dennis Seimen",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2005-12-01"
    },
    "jarzinhomalanga": {
        "displayName": "Jarzinho Malanga",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 43,
        "dateofbirth": "2006-07-10"
    },
    "sauer": {
        "displayName": "Leo Sauer",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Slovakia",
        "position": "Forward",
        "number": 44,
        "dateofbirth": "2005-12-16"
    },
    "drljaca": {
        "displayName": "Stefan Drljača",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 46,
        "dateofbirth": "1999-04-20"
    },
    "kolar": {
        "displayName": "Ondřej Kolář",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-10-17"
    },
    "chaloupek": {
        "displayName": "Štěpán Chaloupek",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-03-08"
    },
    "holes": {
        "displayName": "Tomáš Holeš",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1993-03-31"
    },
    "zima": {
        "displayName": "David Zima",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-11-08"
    },
    "ogbu": {
        "displayName": "Igoh Ogbu",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-02-08"
    },
    "oskarkubiak": {
        "displayName": "Oskar Kubiak",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-09-25"
    },
    "danijelsturm": {
        "displayName": "Danijel Šturm",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1999-01-04"
    },
    "chytil": {
        "displayName": "Mojmír Chytil",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1999-04-29"
    },
    "mubaraksuleiman": {
        "displayName": "Mubarak Suleiman",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2007-04-13"
    },
    "moses": {
        "displayName": "David Moses",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-01-20"
    },
    "provod": {
        "displayName": "Lukáš Provod",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1996-10-23"
    },
    "adonijaouanda": {
        "displayName": "Adonija Ouanda",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Canada",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2005-04-30"
    },
    "emmanuelayaosi": {
        "displayName": "Emmanuel Ayaosi",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2004-10-28"
    },
    "toumanidiakite": {
        "displayName": "Toumani Diakité",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2006-01-19"
    },
    "sadilek": {
        "displayName": "Michal Sadílek",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-05-31"
    },
    "chory": {
        "displayName": "Tomáš Chorý",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "1995-01-26"
    },
    "schranz": {
        "displayName": "Ivan Schranz",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1993-09-13"
    },
    "vlcek": {
        "displayName": "Tomáš Vlček",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-02-28"
    },
    "wiktornowak": {
        "displayName": "Wiktor Nowak",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2004-09-20"
    },
    "jakubmarkovic": {
        "displayName": "Jakub Markovič",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 35,
        "dateofbirth": "2001-07-13"
    },
    "davidjurasek": {
        "displayName": "David Jurásek",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2000-08-07"
    },
    "martinsuchomel": {
        "displayName": "Martin Suchomel",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-09-11"
    },
    "pavel_kaderabek": {
        "displayName": "Pavel Kadeřábek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1992-04-25"
    },
    "jakub_martinec": {
        "displayName": "Jakub Martinec",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-03-13"
    },
    "santiago_eneme": {
        "displayName": "Santiago Eneme",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Equatorial Guinea",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2000-09-29"
    },
    "tobiasguddal": {
        "displayName": "Tobias Guddal",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Norway",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-07-25"
    },
    "josimaralcocer": {
        "displayName": "Josimar Alcócer",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Costa Rica",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-07-07"
    },
    "magnus_kofod_andersen": {
        "displayName": "Magnus Kofod Andersen",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-05-10"
    },
    "karabec": {
        "displayName": "Adam Karabec",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-07-02"
    },
    "matej_rynes": {
        "displayName": "Matěj Ryneš",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 11,
        "dateofbirth": "2001-05-30"
    },
    "brunes": {
        "displayName": "Jonatan Braut Brunes",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Norway",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2000-08-07"
    },
    "emmanuel_uchenna": {
        "displayName": "Emmanuel Uchenna",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2003-05-18"
    },
    "john_mercado": {
        "displayName": "John Mercado",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Ecuador",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2002-06-03"
    },
    "andyirving": {
        "displayName": "Andy Irving",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2000-05-13"
    },
    "adamsevinsky": {
        "displayName": "Adam Ševínský",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2004-06-19"
    },
    "sivert_mannsverk": {
        "displayName": "Sivert Mannsverk",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Norway",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2002-05-08"
    },
    "joaogrimaldo": {
        "displayName": "Joao Grimaldo",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Peru",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-02-20"
    },
    "loicsoh": {
        "displayName": "Loïc Mbe Soh",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2001-06-13"
    },
    "kihoever": {
        "displayName": "Ki-Jana Hoever",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Netherlands",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-01-18"
    },
    "patrik_vydra": {
        "displayName": "Patrik Vydra",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2003-06-20"
    },
    "ebrimasinghateh": {
        "displayName": "Ebrima Singhateh",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Gambia",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2003-09-10"
    },
    "romanmacek": {
        "displayName": "Roman Macek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1997-04-18"
    },
    "matyasvojta": {
        "displayName": "Matyáš Vojta",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2004-02-26"
    },
    "jaroslav_zeleny": {
        "displayName": "Jaroslav Zelený",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1992-08-20"
    },
    "matejjurasek": {
        "displayName": "Matěj Jurásek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2003-08-30"
    },
    "hugosochurek": {
        "displayName": "Hugo Sochůrek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2008-06-07"
    },
    "jakub_surovcik": {
        "displayName": "Jakub Surovčík",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2002-06-28"
    },
    "krisztianhegyi": {
        "displayName": "Krisztián Hegyi",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Hungary",
        "position": "Goalkeeper",
        "number": 47,
        "dateofbirth": "2002-09-24"
    },
    "dominiktapaj": {
        "displayName": "Dominik Ťapaj",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2004-05-10"
    },
    "tobiaspaliscak": {
        "displayName": "Tobiáš Pališčák",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2007-10-25"
    },
    "denisvavro": {
        "displayName": "Denis Vavro",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-04-10"
    },
    "spacil": {
        "displayName": "Karel Spáčil",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-05-18"
    },
    "cerv": {
        "displayName": "Lukáš Červ",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-04-10"
    },
    "salimlawal": {
        "displayName": "Salim Fago Lawal",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-01-15"
    },
    "visinsky": {
        "displayName": "Denis Višinský",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 9,
        "dateofbirth": "2003-03-21"
    },
    "vydra": {
        "displayName": "Matěj Vydra",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1992-05-01"
    },
    "alexandrsojka": {
        "displayName": "Alexandr Sojka",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "2003-04-02"
    },
    "tvrdon": {
        "displayName": "Marián Tvrdoň",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-08-18"
    },
    "doski": {
        "displayName": "Merchas Doski",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Iraq",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1999-12-07"
    },
    "hrosovsky": {
        "displayName": "Patrik Hrošovský",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1992-04-22"
    },
    "ladra": {
        "displayName": "Tomáš Ladra",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-04-24"
    },
    "souare": {
        "displayName": "Cheick Souaré",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2002-09-03"
    },
    "panos": {
        "displayName": "Jiří Panoš",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2007-11-15"
    },
    "jemelka": {
        "displayName": "Václav Jemelka",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1995-06-23"
    },
    "paluska": {
        "displayName": "Jan Paluska",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2005-06-23"
    },
    "baboucarrfaal": {
        "displayName": "Baboucarr Faal",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Gambia",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-04-03"
    },
    "kabongo": {
        "displayName": "Christophe Kabongo",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2003-08-27"
    },
    "adamgabriel": {
        "displayName": "Adam Gabriel",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2001-05-28"
    },
    "viktorbaier": {
        "displayName": "Viktor Baier",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2005-01-16"
    },
    "dweh": {
        "displayName": "Sampson Dweh",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Liberia",
        "position": "Defender",
        "number": 40,
        "dateofbirth": "2001-10-10"
    },
    "wiegele": {
        "displayName": "Florian Wiegele",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2001-03-21"
    },
    "princeadu": {
        "displayName": "Prince Kwabena Adu",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Ghana",
        "position": "Forward",
        "number": 80,
        "dateofbirth": "2003-09-23"
    },
    "filipprebsl": {
        "displayName": "Filip Prebsl",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 98,
        "dateofbirth": "2003-03-04"
    },
    "memic": {
        "displayName": "Amar Memić",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "2001-01-20"
    },
    "diantramaj": {
        "displayName": "Diant Ramaj",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-09-19"
    },
    "felixbeijmo": {
        "displayName": "Felix Beijmo",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Sweden",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-01-31"
    },
    "asger_sorensen": {
        "displayName": "Asger Sørensen",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-06-05"
    },
    "akosmarkgraf": {
        "displayName": "Ákos Markgráf",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Hungary",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2005-06-30"
    },
    "mahercarrizo": {
        "displayName": "Maher Carrizo",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Argentina",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2006-02-19"
    },
    "mattsson": {
        "displayName": "Magnus Mattsson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-02-25"
    },
    "elyounoussi": {
        "displayName": "Mohamed Elyounoussi",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Norway",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1994-08-04"
    },
    "thapelomaseko": {
        "displayName": "Thapelo Maseko",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "South Africa",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2003-11-11"
    },
    "huescas": {
        "displayName": "Rodrigo Huescas",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Mexico",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2003-09-23"
    },
    "andreascornelius": {
        "displayName": "Andreas Cornelius",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-03-16"
    },
    "marcoslopez": {
        "displayName": "Marcos López",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Peru",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1999-11-20"
    },
    "robertsilva": {
        "displayName": "Robert Silva",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Brazil",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2005-04-13"
    },
    "kenaymyrie": {
        "displayName": "Kenay Myrie",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Costa Rica",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2006-09-06"
    },
    "suzuki": {
        "displayName": "Junnosuke Suzuki",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Japan",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-07-12"
    },
    "madsen": {
        "displayName": "Mads Emil Madsen",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1998-01-07"
    },
    "meling": {
        "displayName": "Birger Meling",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Norway",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-12-17"
    },
    "delaney": {
        "displayName": "Thomas Delaney",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1991-09-03"
    },
    "runarsson": {
        "displayName": "Rúnar Alex Rúnarsson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Iceland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1995-02-18"
    },
    "alexkral": {
        "displayName": "Alex Král",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "1998-05-19"
    },
    "clem": {
        "displayName": "William Clem",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "2004-03-26"
    },
    "viktordaason": {
        "displayName": "Viktor Daðason",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Iceland",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2008-06-30"
    },
    "geovannindjee": {
        "displayName": "Geovanni Vianney Ndjee",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Cameroon",
        "position": "Forward",
        "number": 44,
        "dateofbirth": "2007-09-25"
    },
    "polak": {
        "displayName": "Cezary Polak",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-05-31"
    },
    "stojinovic": {
        "displayName": "Dušan Stojinović",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Slovenia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-08-26"
    },
    "kobayashi": {
        "displayName": "Yuki Kobayashi",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-07-18"
    },
    "vital": {
        "displayName": "Bernardo Vital",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-12-29"
    },
    "romanczuk": {
        "displayName": "Taras Romanczuk",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1991-11-14"
    },
    "kajetanszmyt": {
        "displayName": "Kajetan Szmyt",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2002-05-29"
    },
    "drachal": {
        "displayName": "Dawid Drachal",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2005-01-31"
    },
    "rallis": {
        "displayName": "Dimitris Rallis",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2005-03-26"
    },
    "agbonifo": {
        "displayName": "Jeremy Agbonifo",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2005-10-24"
    },
    "imaz": {
        "displayName": "Jesús Imaz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1990-09-26"
    },
    "hampusfinndell": {
        "displayName": "Hampus Finndell",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2000-06-06"
    },
    "wojtuszek": {
        "displayName": "Norbert Wojtuszek",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2001-10-05"
    },
    "sylla": {
        "displayName": "Youssuf Sylla",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2002-12-19"
    },
    "klynge": {
        "displayName": "Anders Klynge",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2000-10-14"
    },
    "wdowik": {
        "displayName": "Bartłomiej Wdowik",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2000-09-25"
    },
    "lozano": {
        "displayName": "Sergio Lozano",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1999-03-24"
    },
    "guilhermemontoia": {
        "displayName": "Guilherme Montóia",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2003-09-14"
    },
    "rodrigoconceicao": {
        "displayName": "Rodrigo Conceição",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2000-01-02"
    },
    "ousmanesow": {
        "displayName": "Ousmane Sow",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Senegal",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2000-07-05"
    },
    "aleksandarcirkovic": {
        "displayName": "Aleksandar Ćirković",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2001-09-21"
    },
    "konstantopoulos": {
        "displayName": "Apostolos Konstantopoulos",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-08-02"
    },
    "abramowicz": {
        "displayName": "Sławomir Abramowicz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2004-06-09"
    },
    "damasiewicz": {
        "displayName": "Adrian Damasiewicz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 66,
        "dateofbirth": "2008-11-20"
    },
    "jozwiak": {
        "displayName": "Kamil Jóźwiak",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 72,
        "dateofbirth": "1998-04-22"
    },
    "zacharyzalewski": {
        "displayName": "Zachary Zalewski",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2009-01-03"
    },
    "nikprelec": {
        "displayName": "Nik Prelec",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Slovenia",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2001-06-10"
    },
    "mateuszlis": {
        "displayName": "Mateusz Lis",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-02-27"
    },
    "joelpereira": {
        "displayName": "Joel Pereira",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-06-28"
    },
    "alexdouglas": {
        "displayName": "Alex Douglas",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-08-17"
    },
    "joaomoutinho": {
        "displayName": "João Moutinho",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-01-12"
    },
    "berggren": {
        "displayName": "Gustav Berggren",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1997-09-07"
    },
    "agnero": {
        "displayName": "Yannick Agnero",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-02-20"
    },
    "gholizadeh": {
        "displayName": "Ali Gholizadeh",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Iran",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "1996-03-10"
    },
    "ishak": {
        "displayName": "Mikael Ishak",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-03-31"
    },
    "walemark": {
        "displayName": "Patrik Wålemark",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-10-14"
    },
    "hakans": {
        "displayName": "Daniel Håkans",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Finland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-10-26"
    },
    "bengtsson": {
        "displayName": "Leo Bengtsson",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1998-05-26"
    },
    "gurgul": {
        "displayName": "Michał Gurgul",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2006-01-30"
    },
    "allahyarsayyadmanesh": {
        "displayName": "Allahyar Sayyadmanesh",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Iran",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-06-29"
    },
    "gumny": {
        "displayName": "Robert Gumny",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1998-06-04"
    },
    "pablorodriguez": {
        "displayName": "Pablo Rodríguez",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2001-08-04"
    },
    "murawski": {
        "displayName": "Radosław Murawski",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1994-04-22"
    },
    "jagiello": {
        "displayName": "Filip Jagiełło",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1997-08-08"
    },
    "monka": {
        "displayName": "Wojciech Mońka",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2007-01-18"
    },
    "pruchniewski": {
        "displayName": "Mateusz Pruchniewski",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "2007-02-15"
    },
    "kozubal": {
        "displayName": "Antoni Kozubal",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2004-08-18"
    },
    "terryyegbe": {
        "displayName": "Terry Yegbe",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Ghana",
        "position": "Defender",
        "number": 59,
        "dateofbirth": "2001-01-25"
    },
    "skrzypczak": {
        "displayName": "Mateusz Skrzypczak",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 72,
        "dateofbirth": "2000-08-22"
    },
    "palama": {
        "displayName": "Luis Palma",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Honduras",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2000-01-17"
    },
    "ivanbrkic": {
        "displayName": "Ivan Brkić",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-06-29"
    },
    "shinnosukefukuda": {
        "displayName": "Shinnosuke Fukuda",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Japan",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2000-09-04"
    },
    "damianszymanski": {
        "displayName": "Damian Szymański",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1995-06-16"
    },
    "robertjr": {
        "displayName": "Robert Deziel Jr.",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "United States",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2005-06-30"
    },
    "henriquearreiol": {
        "displayName": "Henrique Arreiol",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-06-21"
    },
    "jan_kuchta": {
        "displayName": "Jan Kuchta",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1997-01-08"
    },
    "augustyniak": {
        "displayName": "Rafał Augustyniak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1993-10-14"
    },
    "rafaadamski": {
        "displayName": "Rafał Adamski",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-11-21"
    },
    "chodyna": {
        "displayName": "Kacper Chodyna",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1999-05-24"
    },
    "reca": {
        "displayName": "Arkadiusz Reca",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1995-06-17"
    },
    "colak": {
        "displayName": "Antonio Čolak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-09-17"
    },
    "mateuszszczepaniak": {
        "displayName": "Mateusz Szczepaniak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2007-01-05"
    },
    "ruben_vinagre": {
        "displayName": "Rúben Vinagre",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1999-04-09"
    },
    "bichakhchyan": {
        "displayName": "Vahan Bichakhchyan",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Armenia",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1999-07-09"
    },
    "pawewszoek": {
        "displayName": "Paweł Wszołek",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1992-04-30"
    },
    "michalsevcik": {
        "displayName": "Michal Ševčík",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2002-08-13"
    },
    "arsenic": {
        "displayName": "Zoran Arsenić",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-06-02"
    },
    "bohdanvyunnyk": {
        "displayName": "Bohdan Vyunnyk",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Ukraine",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-05-21"
    },
    "wojciech_urbanski": {
        "displayName": "Wojciech Urbański",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 53,
        "dateofbirth": "2005-01-12"
    },
    "kapustka": {
        "displayName": "Bartosz Kapustka",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 67,
        "dateofbirth": "1996-12-23"
    },
    "ukaszzjawinski": {
        "displayName": "Łukasz Zjawiński",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 79,
        "dateofbirth": "2001-07-11"
    },
    "ottohindrich": {
        "displayName": "Otto Hindrich",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Romania",
        "position": "Goalkeeper",
        "number": 89,
        "dateofbirth": "2002-08-05"
    },
    "piatkowski": {
        "displayName": "Kamil Piątkowski",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2000-06-21"
    },
    "trelowski": {
        "displayName": "Kacper Trelowski",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2003-08-19"
    },
    "arvidbrorsson": {
        "displayName": "Arvid Brorsson",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-05-08"
    },
    "svarnas": {
        "displayName": "Stratos Svarnas",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-11-11"
    },
    "bulat": {
        "displayName": "Marko Bulat",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-09-26"
    },
    "repka": {
        "displayName": "Oskar Repka",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1999-01-03"
    },
    "tudor": {
        "displayName": "Fran Tudor",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1995-09-27"
    },
    "makuch": {
        "displayName": "Patryk Makuch",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-04-11"
    },
    "kochergin": {
        "displayName": "Vladyslav Kocherhin",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-04-05"
    },
    "mahiremreli": {
        "displayName": "Mahir Emreli",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Azerbaijan",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-07-01"
    },
    "nilszatterstrom": {
        "displayName": "Nils Zätterström",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2005-03-29"
    },
    "jeancarlos": {
        "displayName": "Jean Carlos",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1996-05-10"
    },
    "pienko": {
        "displayName": "Tomasz Pieńko",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-01-05"
    },
    "struski": {
        "displayName": "Karol Struski",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-01-18"
    },
    "racovitan": {
        "displayName": "Bogdan Racovițan",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Romania",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2000-06-06"
    },
    "otieno": {
        "displayName": "Erick Otieno",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Kenya",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1996-09-27"
    },
    "markoperovic": {
        "displayName": "Marko Perović",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "2006-03-05"
    },
    "isakbrusberg": {
        "displayName": "Isak Brusberg",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2006-09-05"
    },
    "bogdanmircetic": {
        "displayName": "Bogdan Mirčetić",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2005-10-25"
    },
    "dieudonnedebohi": {
        "displayName": "Dieudonné Debohi",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "2001-01-15"
    },
    "diaby_fadiga": {
        "displayName": "Lamine Diaby-Fadiga",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Guinea",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2001-01-19"
    },
    "adinmolnar": {
        "displayName": "Ádin Molnár",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Hungary",
        "position": "Midfielder",
        "number": 88,
        "dateofbirth": "2004-06-18"
    },
    "adambasse": {
        "displayName": "Adam Basse",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2007-11-04"
    },
    "adriano": {
        "displayName": "Adriano Amorim",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2002-02-11"
    },
    "fayelund": {
        "displayName": "Julian Faye Lund",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-05-20"
    },
    "villadsnielsen": {
        "displayName": "Villads Nielsen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-01-29"
    },
    "bjortuft": {
        "displayName": "Odin Bjørtuft",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-12-19"
    },
    "aleesami": {
        "displayName": "Haitam Aleesami",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1991-07-31"
    },
    "gundersen": {
        "displayName": "Jostein Gundersen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-04-02"
    },
    "patrickberg": {
        "displayName": "Patrick Berg",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1997-11-24"
    },
    "auklend": {
        "displayName": "Sondre Auklend",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-06-10"
    },
    "helmersen": {
        "displayName": "Andreas Helmersen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-03-15"
    },
    "jenshauge": {
        "displayName": "Jens Petter Hauge",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-10-12"
    },
    "blomberg": {
        "displayName": "Ole Didrik Blomberg",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-06-12"
    },
    "haikin": {
        "displayName": "Nikita Haikin",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1995-07-11"
    },
    "saltnes": {
        "displayName": "Ulrik Saltnes",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1992-11-10"
    },
    "bjorkan": {
        "displayName": "Fredrik André Bjørkan",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1998-08-21"
    },
    "joshuakitolano": {
        "displayName": "Joshua Kitolano",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-08-03"
    },
    "olabrynhildsen": {
        "displayName": "Ola Brynhildsen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1999-04-27"
    },
    "brunstadfet": {
        "displayName": "Sondre Brunstad Fet",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1997-01-17"
    },
    "sjovold": {
        "displayName": "Fredrik Sjøvold",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-08-17"
    },
    "joelmvuka": {
        "displayName": "Joel Mvuka",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-11-12"
    },
    "magnusriisns": {
        "displayName": "Magnus Riisnæs",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2004-11-04"
    },
    "maatta": {
        "displayName": "Isak Dybvik Määttä",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2001-09-19"
    },
    "evjen": {
        "displayName": "Håkon Evjen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2000-02-14"
    },
    "augustmikkelsen": {
        "displayName": "August Mikkelsen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 94,
        "dateofbirth": "2000-10-24"
    },
    "owusuoduro": {
        "displayName": "Rome-Jayden Owusu-Oduro",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2004-07-02"
    },
    "maikuma": {
        "displayName": "Seiya Maikuma",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-10-16"
    },
    "woutergoes": {
        "displayName": "Wouter Goes",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-06-10"
    },
    "lewisschouten": {
        "displayName": "Lewis Schouten",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2004-02-04"
    },
    "mateochavez": {
        "displayName": "Mateo Chávez",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Mexico",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-05-12"
    },
    "peerkoopmeiners": {
        "displayName": "Peer Koopmeiners",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2000-05-04"
    },
    "weslleypatati": {
        "displayName": "Weslley Patati",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-10-01"
    },
    "jordyclasie": {
        "displayName": "Jordy Clasie",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1991-06-27"
    },
    "mexxmeerdink": {
        "displayName": "Mexx Meerdink",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-07-24"
    },
    "keessmit": {
        "displayName": "Kees Smit",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2006-01-20"
    },
    "rozangelodaal": {
        "displayName": "Ro-Zangelo Daal",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-04-16"
    },
    "verhulst": {
        "displayName": "Hobie Verhulst",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1993-04-02"
    },
    "calvinstengs": {
        "displayName": "Calvin Stengs",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-12-18"
    },
    "stijeresink": {
        "displayName": "Stije Resink",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2003-05-28"
    },
    "valdemarbyskov": {
        "displayName": "Valdemar Byskov",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-01-25"
    },
    "bendeguzkovacs": {
        "displayName": "Bendegúz Kovács",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Hungary",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2007-03-31"
    },
    "jizzhornkamp": {
        "displayName": "Jizz Hornkamp",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1998-03-07"
    },
    "andreanatali": {
        "displayName": "Andrea Natali",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Italy",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2008-01-28"
    },
    "davekwakman": {
        "displayName": "Dave Kwakman",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-06-07"
    },
    "dijkstra": {
        "displayName": "Elijah Dijkstra",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-08-05"
    },
    "ayouboufkir": {
        "displayName": "Ayoub Oufkir",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2006-01-04"
    },
    "wassimbouziane": {
        "displayName": "Wassim Bouziane",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2006-12-22"
    },
    "jaribusser": {
        "displayName": "Jari De Busser",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1999-10-21"
    },
    "wesleyhoedt": {
        "displayName": "Wesley Hoedt",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1994-03-06"
    },
    "kasius": {
        "displayName": "Denso Kasius",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2002-10-06"
    },
    "rionichihara": {
        "displayName": "Rion Ichihara",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2005-07-07"
    },
    "meeswit": {
        "displayName": "Mees de Wit",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "1998-04-17"
    },
    "jeroenzoet": {
        "displayName": "Jeroen Zoet",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "1991-01-06"
    },
    "terstegen": {
        "displayName": "Marc-André ter Stegen",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-30"
    },
    "lucasrosa": {
        "displayName": "Lucas Rosa",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-04-03"
    },
    "gaaei": {
        "displayName": "Anton Gaaei",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-11-19"
    },
    "sofyanamrabat": {
        "displayName": "Sofyan Amrabat",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-08-21"
    },
    "wijndal": {
        "displayName": "Owen Wijndal",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-11-28"
    },
    "kehrer": {
        "displayName": "Thilo Kehrer",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-09-21"
    },
    "simonadingra": {
        "displayName": "Simon Adingra",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-01-01"
    },
    "brandt": {
        "displayName": "Julian Brandt",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-05-02"
    },
    "dolberg": {
        "displayName": "Kasper Dolberg",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-10-06"
    },
    "gloukh": {
        "displayName": "Oscar Gloukh",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Israel",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2004-04-01"
    },
    "viktortsyhankov": {
        "displayName": "Viktor Tsyhankov",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1997-11-15"
    },
    "caiohenrique": {
        "displayName": "Caio Henrique",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-07-31"
    },
    "baas": {
        "displayName": "Youri Baas",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2003-03-17"
    },
    "daleyblind": {
        "displayName": "Daley Blind",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1990-03-09"
    },
    "klaassen": {
        "displayName": "Davy Klaassen",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1993-02-21"
    },
    "oliveredvardsen": {
        "displayName": "Oliver Edvardsen",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Norway",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "1999-03-19"
    },
    "jofretorrents": {
        "displayName": "Jofre Torrents",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2007-01-28"
    },
    "heerkens": {
        "displayName": "Joeri Heerkens",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "2006-03-04"
    },
    "berghuis": {
        "displayName": "Steven Berghuis",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1991-12-19"
    },
    "jorthymokio": {
        "displayName": "Jorthy Mokio",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "DR Congo",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2008-02-29"
    },
    "maartenpaes": {
        "displayName": "Maarten Paes",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Indonesia",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "1998-05-14"
    },
    "bissouma": {
        "displayName": "Yves Bissouma",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Mali",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1996-08-30"
    },
    "bouwman": {
        "displayName": "Aaron Bouwman",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2007-11-04"
    },
    "diesjanse": {
        "displayName": "Dies Janse",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 36,
        "dateofbirth": "2006-01-17"
    },
    "marcosleonardo": {
        "displayName": "Marcos Leonardo",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "2003-05-02"
    },
    "rayanebounida": {
        "displayName": "Rayane Bounida",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2006-03-03"
    },
    "abdellahouazane": {
        "displayName": "Abdellah Ouazane",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 68,
        "dateofbirth": "2009-01-15"
    },
    "toluarokodare": {
        "displayName": "Tolu Arokodare",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Nigeria",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2000-11-23"
    },
    "unnerstall": {
        "displayName": "Lars Unnerstall",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-07-20"
    },
    "micharosiak": {
        "displayName": "Michał Rosiak",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Poland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-10-12"
    },
    "propper": {
        "displayName": "Robin Pröpper",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1993-09-23"
    },
    "ruudnijstad": {
        "displayName": "Ruud Nijstad",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2008-01-17"
    },
    "zerrouki": {
        "displayName": "Ramiz Zerrouki",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-05-26"
    },
    "pjaca": {
        "displayName": "Marko Pjaca",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Croatia",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-05-06"
    },
    "weidmann": {
        "displayName": "Daouda Weidmann",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-05-04"
    },
    "weghorst": {
        "displayName": "Wout Weghorst",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1992-08-07"
    },
    "younestaha": {
        "displayName": "Younes Taha",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2002-11-27"
    },
    "daanrots": {
        "displayName": "Daan Rots",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-07-25"
    },
    "hlynsson": {
        "displayName": "Kristian Hlynsson",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Iceland",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2004-01-23"
    },
    "joeldrommel": {
        "displayName": "Joël Drommel",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1996-11-16"
    },
    "filipthorvaldsen": {
        "displayName": "Filip Thorvaldsen",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Norway",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2006-04-15"
    },
    "vandenbelt": {
        "displayName": "Thomas van den Belt",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2001-06-18"
    },
    "pasveer": {
        "displayName": "Remko Pasveer",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1983-11-08"
    },
    "lemkin": {
        "displayName": "Stav Lemkin",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Israel",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2003-04-02"
    },
    "krzysztofkurowski": {
        "displayName": "Krzysztof Kurowski",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Poland",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2006-08-29"
    },
    "lucashesselink": {
        "displayName": "Lucas Vennegoor of Hesselink",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2006-03-14"
    },
    "orjasaeter": {
        "displayName": "Sondre Ørjasæter",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Norway",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2003-11-28"
    },
    "vanrooij": {
        "displayName": "Bart van Rooij",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "2001-05-26"
    },
    "askeadelgaard": {
        "displayName": "Aske Adelgaard",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2003-11-10"
    },
    "verschueren": {
        "displayName": "Arno Verschueren",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "1997-04-08"
    },
    "naciunuvar": {
        "displayName": "Naci Ünüvar",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Turkey",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2003-06-13"
    },
    "maxbruns": {
        "displayName": "Max Bruns",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 38,
        "dateofbirth": "2002-11-06"
    },
    "gijsbesselink": {
        "displayName": "Gijs Besselink",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "2004-06-16"
    },
    "julienmesbahi": {
        "displayName": "Juliën Mesbahi",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2006-01-31"
    },
    "tjarkernst": {
        "displayName": "Tjark Ernst",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2003-03-15"
    },
    "nieuwkoop": {
        "displayName": "Bart Nieuwkoop",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-03-07"
    },
    "beelen": {
        "displayName": "Thomas Beelen",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-06-07"
    },
    "watanabe": {
        "displayName": "Tsuyoshi Watanabe",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-02-05"
    },
    "smal": {
        "displayName": "Gijs Smal",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-08-31"
    },
    "jerryjuste": {
        "displayName": "Jerry St. Juste",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-10-19"
    },
    "moder": {
        "displayName": "Jakub Moder",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Poland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-04-07"
    },
    "gjivaizechiel": {
        "displayName": "Gjivai Zechiël",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-06-01"
    },
    "valente": {
        "displayName": "Luciano Valente",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-10-04"
    },
    "borges": {
        "displayName": "Gonçalo Borges",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Portugal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-03-29"
    },
    "semsteijn": {
        "displayName": "Sem Steijn",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2001-11-12"
    },
    "jordanbos": {
        "displayName": "Jordan Bos",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Australia",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2002-10-29"
    },
    "javilopez": {
        "displayName": "Javi López",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2002-03-25"
    },
    "reissnelson": {
        "displayName": "Reiss Nelson",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "England",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1999-12-10"
    },
    "nachoferri": {
        "displayName": "Nacho Ferri",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-10-05"
    },
    "matsdeijl": {
        "displayName": "Mats Deijl",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1997-07-15"
    },
    "tobiaselshout": {
        "displayName": "Tobias van den Elshout",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2007-02-02"
    },
    "hadjmoussa": {
        "displayName": "Anis Hadj Moussa",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Algeria",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2002-02-11"
    },
    "thijskraaijeveld": {
        "displayName": "Thijs Kraaijeveld",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2007-05-03"
    },
    "givairoread": {
        "displayName": "Givairo Read",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-06-02"
    },
    "gaoussoudiarra": {
        "displayName": "Gaoussou Diarra",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Mali",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-11-21"
    },
    "targhalline": {
        "displayName": "Oussama Targhalline",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2002-05-20"
    },
    "tijmewessels": {
        "displayName": "Tijme Wessels",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2007-02-23"
    },
    "floriankastenmeier": {
        "displayName": "Florian Kastenmeier",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1997-06-28"
    },
    "charlesvanhoutte": {
        "displayName": "Charles Vanhoutte",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "1998-09-16"
    },
    "mikamarmol": {
        "displayName": "Mika Mármol",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2001-07-01"
    },
    "jivaynozinhagel": {
        "displayName": "Jivayno Zinhagel",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 36,
        "dateofbirth": "2009-04-18"
    },
    "bossin": {
        "displayName": "Liam Bossin",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Ireland",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "1996-07-15"
    },
    "shaqueelpersie": {
        "displayName": "Shaqueel van Persie",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "2006-11-16"
    },
    "olij": {
        "displayName": "Nick Olij",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-08-01"
    },
    "lutsharelgeertruida": {
        "displayName": "Lutsharel Geertruida",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2000-07-18"
    },
    "yarek": {
        "displayName": "Yarek Gasiorowski",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-01-12"
    },
    "obispo": {
        "displayName": "Armando Obispo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Curaçao",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-05"
    },
    "perisic": {
        "displayName": "Ivan Perišić",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1989-02-02"
    },
    "flamingo": {
        "displayName": "Ryan Flamingo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-12-31"
    },
    "vanbommel": {
        "displayName": "Ruben van Bommel",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-08-03"
    },
    "dest": {
        "displayName": "Sergiño Dest",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "United States",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "2000-11-03"
    },
    "pepi": {
        "displayName": "Ricardo Pepi",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "United States",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-01-09"
    },
    "wanner": {
        "displayName": "Paul Wanner",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Austria",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2005-12-23"
    },
    "samiouaissa": {
        "displayName": "Sami Ouaissa",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-10-02"
    },
    "plea": {
        "displayName": "Alassane Pléa",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-03-10"
    },
    "maurojunior": {
        "displayName": "Mauro Júnior",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1999-05-06"
    },
    "filipkostic": {
        "displayName": "Filip Kostić",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Serbia",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1992-11-01"
    },
    "bajraktarevic": {
        "displayName": "Esmir Bajraktarević",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-03-10"
    },
    "til": {
        "displayName": "Guus Til",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1997-12-22"
    },
    "mijnans": {
        "displayName": "Sven Mijnans",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2000-03-09"
    },
    "schouten": {
        "displayName": "Jerdy Schouten",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1997-01-12"
    },
    "brohansen": {
        "displayName": "Mikkel Bro Hansen",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2009-01-25"
    },
    "kodaisano": {
        "displayName": "Kodai Sano",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2003-09-25"
    },
    "sildillia": {
        "displayName": "Kiliann Sildillia",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "France",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-05-16"
    },
    "dennisman": {
        "displayName": "Dennis Man",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Romania",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "1998-08-26"
    },
    "lammers": {
        "displayName": "Sam Lammers",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1997-04-30"
    },
    "noahfernandez": {
        "displayName": "Noah Fernandez",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 31,
        "dateofbirth": "2008-01-09"
    },
    "kovar": {
        "displayName": "Matěj Kovář",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "2000-05-17"
    },
    "ayonisantos": {
        "displayName": "Ayoni Santos",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Cape Verde",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2005-07-18"
    },
    "amirbouhamdi": {
        "displayName": "Amir Bouhamdi",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2008-06-17"
    },
    "fabianmerien": {
        "displayName": "Fabian Merién",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 38,
        "dateofbirth": "2008-09-26"
    },
    "nagalo": {
        "displayName": "Adamo Nagalo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2002-09-22"
    },
    "tijnsmolenaars": {
        "displayName": "Tijn Smolenaars",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 51,
        "dateofbirth": "2005-02-23"
    },
    "unaisimon": {
        "displayName": "Unai Simón",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-06-11"
    },
    "vivian": {
        "displayName": "Dani Vivian",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-07-05"
    },
    "paredes": {
        "displayName": "Aitor Paredes",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-04-29"
    },
    "yeray": {
        "displayName": "Yeray Álvarez",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-01-24"
    },
    "prados": {
        "displayName": "Beñat Prados",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-02-08"
    },
    "berenguer": {
        "displayName": "Álex Berenguer",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-07-04"
    },
    "sancet": {
        "displayName": "Oihan Sancet",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-04-25"
    },
    "inakiwilliams": {
        "displayName": "Iñaki Williams",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Ghana",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1994-06-15"
    },
    "nicowilliams": {
        "displayName": "Nico Williams",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2002-07-12"
    },
    "guruzeta": {
        "displayName": "Gorka Guruzeta",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-09-12"
    },
    "areso": {
        "displayName": "Jesús Areso",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-07-02"
    },
    "padilla": {
        "displayName": "Álex Padilla",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Mexico",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2003-09-01"
    },
    "laporte": {
        "displayName": "Aymeric Laporte",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1994-05-27"
    },
    "hugorincon": {
        "displayName": "Hugo Rincón",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2003-01-27"
    },
    "galarreta": {
        "displayName": "Iñigo Ruiz de Galarreta",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1993-08-06"
    },
    "yuri": {
        "displayName": "Yuri Berchiche",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1990-02-10"
    },
    "jauregizar": {
        "displayName": "Mikel Jauregizar",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2003-11-13"
    },
    "alejandrorego": {
        "displayName": "Alejandro Rego",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2003-06-11"
    },
    "sannadi": {
        "displayName": "Maroan Sannadi",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2001-02-01"
    },
    "nicoserrano": {
        "displayName": "Nico Serrano",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2003-03-05"
    },
    "robertnavarro": {
        "displayName": "Robert Navarro",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2002-04-12"
    },
    "benatgerenabarrena": {
        "displayName": "Beñat Gerenabarrena",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2003-03-29"
    },
    "alvarodjalo": {
        "displayName": "Álvaro Djaló",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Guinea-Bissau",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "1999-08-16"
    },
    "peiocanales": {
        "displayName": "Peio Canales",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2005-01-17"
    },
    "johanekojean": {
        "displayName": "Johaneko Louis-Jean",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2004-06-28"
    },
    "unaiegiluz": {
        "displayName": "Unai Egiluz",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-03-19"
    },
    "musso": {
        "displayName": "Juan Musso",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-05-13"
    },
    "obedvargas": {
        "displayName": "Obed Vargas",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Mexico",
        "position": "Midfielder",
        "number": 3,
        "dateofbirth": "2005-08-05"
    },
    "cardoso": {
        "displayName": "Johnny Cardoso",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "United States",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-09-20"
    },
    "koke": {
        "displayName": "Koke",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1992-01-08"
    },
    "kanginlee": {
        "displayName": "Lee Kang-in",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "South Korea",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-02-19"
    },
    "barrios": {
        "displayName": "Pablo Barrios",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-06-15"
    },
    "sorloth": {
        "displayName": "Alexander Sørloth",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Norway",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1995-12-05"
    },
    "baena": {
        "displayName": "Álex Baena",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2001-07-20"
    },
    "lookman": {
        "displayName": "Ademola Lookman",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-10-20"
    },
    "oblak": {
        "displayName": "Jan Oblak",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Slovenia",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1993-01-07"
    },
    "llorente": {
        "displayName": "Marcos Llorente",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1995-01-30"
    },
    "jonathandavid": {
        "displayName": "Jonathan David",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Forward",
        "number": 15,
        "dateofbirth": "2000-01-14"
    },
    "arnauortiz": {
        "displayName": "Arnau Ortiz",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-10-29"
    },
    "hancko": {
        "displayName": "Dávid Hancko",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Slovakia",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-12-13"
    },
    "pubill": {
        "displayName": "Marc Pubill",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-06-20"
    },
    "alvarez": {
        "displayName": "Julián Alvarez",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2000-01-31"
    },
    "simeone": {
        "displayName": "Giuliano Simeone",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2002-12-18"
    },
    "cristianromero": {
        "displayName": "Cristian Romero",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1998-04-27"
    },
    "grimaldo": {
        "displayName": "Alejandro Grimaldo",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1995-09-20"
    },
    "mortenhjulmand": {
        "displayName": "Morten Hjulmand",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-06-25"
    },
    "lenormand": {
        "displayName": "Robin Le Normand",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1996-11-11"
    },
    "salviesquivel": {
        "displayName": "Salvi Esquivel",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2005-09-30"
    },
    "danimartinez": {
        "displayName": "Dani Martínez",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2004-05-05"
    },
    "joangarcia": {
        "displayName": "Joan Garcia",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-05-04"
    },
    "joaocancelo": {
        "displayName": "João Cancelo",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1994-05-27"
    },
    "balde": {
        "displayName": "Alejandro Balde",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-10-18"
    },
    "brianfarinas": {
        "displayName": "Brian Fariñas",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2006-02-09"
    },
    "cubarsi": {
        "displayName": "Pau Cubarsí",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2007-01-22"
    },
    "gavi": {
        "displayName": "Gavi",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-08-05"
    },
    "fermin": {
        "displayName": "Fermín López",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-05-11"
    },
    "pedri": {
        "displayName": "Pedri",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-11-25"
    },
    "gabrieljesus": {
        "displayName": "Gabriel Jesus",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-04-03"
    },
    "yamal": {
        "displayName": "Lamine Yamal",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2007-07-13"
    },
    "raphinha": {
        "displayName": "Raphinha",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-12-14"
    },
    "xaviespart": {
        "displayName": "Xavi Espart",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2007-05-21"
    },
    "szczesny": {
        "displayName": "Wojciech Szczęsny",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1990-04-18"
    },
    "adeyemi": {
        "displayName": "Karim Adeyemi",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Germany",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2002-01-18"
    },
    "andreaschristensen": {
        "displayName": "Andreas Christensen",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Denmark",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1996-04-10"
    },
    "rodri": {
        "displayName": "Rodri",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1996-06-22"
    },
    "anthonygordon": {
        "displayName": "Anthony Gordon",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "England",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-02-24"
    },
    "gerardmartin": {
        "displayName": "Gerard Martín",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2002-02-26"
    },
    "bardghji": {
        "displayName": "Roony Bardghji",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Sweden",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-11-15"
    },
    "olmo": {
        "displayName": "Dani Olmo",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1998-05-07"
    },
    "dejong": {
        "displayName": "Frenkie de Jong",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1997-05-12"
    },
    "bernal": {
        "displayName": "Marc Bernal",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2007-05-26"
    },
    "kounde": {
        "displayName": "Jules Koundé",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1998-11-12"
    },
    "ericgarcia": {
        "displayName": "Eric Garcia",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-01-09"
    },
    "dominiklivakovic": {
        "displayName": "Dominik Livaković",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Croatia",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1995-01-09"
    },
    "jessebisiwu": {
        "displayName": "Jesse Bisiwu",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Belgium",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2008-01-22"
    },
    "hamzaabdelkarim": {
        "displayName": "Hamza Abdelkarim",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Egypt",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2008-01-01"
    },
    "courtois": {
        "displayName": "Thibaut Courtois",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-05-11"
    },
    "asencio": {
        "displayName": "Raúl Asencio",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-02-13"
    },
    "militao": {
        "displayName": "Éder Militão",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-01-18"
    },
    "huijsen": {
        "displayName": "Dean Huijsen",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2005-04-14"
    },
    "bellingham": {
        "displayName": "Jude Bellingham",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "England",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2003-06-29"
    },
    "camavinga": {
        "displayName": "Eduardo Camavinga",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-11-10"
    },
    "vinicius": {
        "displayName": "Vinícius Júnior",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-07-12"
    },
    "valverde": {
        "displayName": "Federico Valverde",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-07-22"
    },
    "endrick": {
        "displayName": "Endrick",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2006-07-21"
    },
    "mbappe": {
        "displayName": "Kylian Mbappé",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1998-12-20"
    },
    "rodrygo": {
        "displayName": "Rodrygo",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-01-09"
    },
    "trent": {
        "displayName": "Trent Alexander-Arnold",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "England",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1998-10-07"
    },
    "lunin": {
        "displayName": "Andriy Lunin",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1999-02-11"
    },
    "tchouameni": {
        "displayName": "Aurélien Tchouaméni",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2000-01-27"
    },
    "ardaguler": {
        "displayName": "Arda Güler",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2005-02-25"
    },
    "liverpoolkonate": {
        "displayName": "Ibrahima Konaté",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1999-05-25"
    },
    "cucurella": {
        "displayName": "Marc Cucurella",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-07-22"
    },
    "carreras": {
        "displayName": "Álvaro Carreras",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-03-23"
    },
    "carlosespi": {
        "displayName": "Carlos Espí",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-07-24"
    },
    "bernardosilva": {
        "displayName": "Bernardo Silva",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-08-10"
    },
    "brahim": {
        "displayName": "Brahim Díaz",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1999-08-03"
    },
    "rudiger": {
        "displayName": "Antonio Rüdiger",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-03-03"
    },
    "mendy": {
        "displayName": "Ferland Mendy",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1995-06-08"
    },
    "dumfries": {
        "displayName": "Denzel Dumfries",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Netherlands",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1996-04-18"
    },
    "yandiomande": {
        "displayName": "Yan Diomande",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2006-05-04"
    },
    "thiagopitarch": {
        "displayName": "Thiago Pitarch",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2007-08-03"
    },
    "remiro": {
        "displayName": "Álex Remiro",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-24"
    },
    "aramburu": {
        "displayName": "Jon Aramburu",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Venezuela",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-07-23"
    },
    "aihen": {
        "displayName": "Aihen Muñoz",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-08-16"
    },
    "gorrotxategi": {
        "displayName": "Jon Gorrotxategi",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2002-09-02"
    },
    "zubeldia": {
        "displayName": "Igor Zubeldia",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-03-30"
    },
    "jonmartin": {
        "displayName": "Jon Martín",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2006-04-23"
    },
    "barrenetxea": {
        "displayName": "Ander Barrenetxea",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-12-27"
    },
    "turrientes": {
        "displayName": "Beñat Turrientes",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-01-31"
    },
    "oskarsson": {
        "displayName": "Orri Óskarsson",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Iceland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-08-29"
    },
    "oyarzabal": {
        "displayName": "Mikel Oyarzabal",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-04-21"
    },
    "guedes": {
        "displayName": "Gonçalo Guedes",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-11-29"
    },
    "jobochieng": {
        "displayName": "Job Ochieng",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Kenya",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2003-01-17"
    },
    "marrero": {
        "displayName": "Unai Marrero",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2001-10-08"
    },
    "kubo": {
        "displayName": "Takefusa Kubo",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Japan",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2001-06-04"
    },
    "pablomarin": {
        "displayName": "Pablo Marín",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2003-07-03"
    },
    "jonpacheco": {
        "displayName": "Jon Pacheco",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2001-01-08"
    },
    "sergiogomez": {
        "displayName": "Sergio Gómez",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-09-04"
    },
    "soler": {
        "displayName": "Carlos Soler",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-01-02"
    },
    "mamadousarr": {
        "displayName": "Mamadou Sarr",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Senegal",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2005-08-29"
    },
    "odriozola": {
        "displayName": "Álvaro Odriozola",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1995-12-14"
    },
    "yangel": {
        "displayName": "Yangel Herrera",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1998-01-07"
    },
    "hectorfort": {
        "displayName": "Héctor Fort",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-08-02"
    },
    "zakharyan": {
        "displayName": "Arsen Zakharyan",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Russia",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2003-05-26"
    },
    "lukasucic": {
        "displayName": "Luka Sučić",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2002-09-08"
    },
    "vlachodimos": {
        "displayName": "Odysseas Vlachodimos",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-04-26"
    },
    "juaniglesias": {
        "displayName": "Juan Iglesias",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-07-03"
    },
    "juliodiaz": {
        "displayName": "Julio Díaz",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-01-10"
    },
    "kikesalas": {
        "displayName": "Kike Salas",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-04-01"
    },
    "andrescastrin": {
        "displayName": "Andrés Castrín",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-05-26"
    },
    "agoume": {
        "displayName": "Lucien Agoumé",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-02-12"
    },
    "alfongonzalez": {
        "displayName": "Alfon González",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-05-04"
    },
    "kochorashvili": {
        "displayName": "Giorgi Kochorashvili",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-06-29"
    },
    "robbieure": {
        "displayName": "Robbie Ure",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Scotland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-02-24"
    },
    "peque": {
        "displayName": "Peque Fernández",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-10-04"
    },
    "rubenvargas": {
        "displayName": "Rubén Vargas",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Switzerland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-08-05"
    },
    "arounasangante": {
        "displayName": "Arouna Sangante",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Senegal",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2002-04-12"
    },
    "frangonzalez": {
        "displayName": "Fran González",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2005-06-24"
    },
    "manubueno": {
        "displayName": "Manu Bueno",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2004-07-27"
    },
    "isaacromero": {
        "displayName": "Isaac Romero",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2000-05-18"
    },
    "suazo": {
        "displayName": "Gabriel Suazo",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Chile",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-08-09"
    },
    "jonguridi": {
        "displayName": "Jon Guridi",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1995-02-28"
    },
    "lucasstassin": {
        "displayName": "Lucas Stassin",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Belgium",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-11-29"
    },
    "felix_correia": {
        "displayName": "Félix Correia",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2001-01-22"
    },
    "ejuke": {
        "displayName": "Chidera Ejuke",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1998-01-02"
    },
    "josecarmona": {
        "displayName": "José Ángel Carmona",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2002-01-29"
    },
    "marcao": {
        "displayName": "Marcão",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1996-06-05"
    },
    "youssouffofana": {
        "displayName": "Youssouf Fofana",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1999-01-10"
    },
    "miguelsierra": {
        "displayName": "Miguel Sierra",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2004-07-14"
    },
    "luizjunior": {
        "displayName": "Luiz Júnior",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-01-14"
    },
    "logancosta": {
        "displayName": "Logan Costa",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Cape Verde",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-04-01"
    },
    "alexfreeman": {
        "displayName": "Alex Freeman",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "United States",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-08-09"
    },
    "alassanediatta": {
        "displayName": "Alassane Diatta",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2005-05-14"
    },
    "paunavarro": {
        "displayName": "Pau Navarro",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2005-04-25"
    },
    "gerardmoreno": {
        "displayName": "Gerard Moreno",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-04-07"
    },
    "foyth": {
        "displayName": "Juan Foyth",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "1998-01-12"
    },
    "mikautadze": {
        "displayName": "Georges Mikautadze",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Georgia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-10-31"
    },
    "moleiro": {
        "displayName": "Alberto Moleiro",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-09-30"
    },
    "akhomach": {
        "displayName": "Ilias Akhomach",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-04-16"
    },
    "renatoveiga": {
        "displayName": "Renato Veiga",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2003-07-29"
    },
    "rubengomez": {
        "displayName": "Rubén Gómez",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2002-01-24"
    },
    "comesana": {
        "displayName": "Santi Comesaña",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1996-10-05"
    },
    "mourino": {
        "displayName": "Santiago Mouriño",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2002-02-13"
    },
    "carlosmacia": {
        "displayName": "Carlos Maciá",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2008-09-01"
    },
    "buchanan": {
        "displayName": "Tajon Buchanan",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1999-02-08"
    },
    "papegueye": {
        "displayName": "Pape Gueye",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1999-01-24"
    },
    "nicolaspepe": {
        "displayName": "Nicolas Pépé",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1995-05-29"
    },
    "carlosromero": {
        "displayName": "Carlos Romero",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2001-10-29"
    },
    "oluwaseyi": {
        "displayName": "Tani Oluwaseyi",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2000-05-15"
    },
    "ayozeperez": {
        "displayName": "Ayoze Pérez",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1993-07-29"
    },
    "sergicardona": {
        "displayName": "Sergi Cardona",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-07-08"
    },
    "nathansaliba": {
        "displayName": "Nathan Saliba",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2004-08-29"
    },
    "gulacsi": {
        "displayName": "Péter Gulácsi",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Hungary",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1990-05-06"
    },
    "hradecky": {
        "displayName": "Lukas Hradecky",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Finland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1989-11-24"
    },
    "vanderson": {
        "displayName": "Vanderson",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-06-21"
    },
    "teze": {
        "displayName": "Jordan Teze",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-09-30"
    },
    "zakaria": {
        "displayName": "Denis Zakaria",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-11-20"
    },
    "mathysdetourbet": {
        "displayName": "Mathys Detourbet",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2007-04-29"
    },
    "laminecamara": {
        "displayName": "Lamine Camara",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-01-01"
    },
    "balogun": {
        "displayName": "Folarin Balogun",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-07-03"
    },
    "golovin": {
        "displayName": "Aleksandr Golovin",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Russia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-05-30"
    },
    "matthisabline": {
        "displayName": "Matthis Abline",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-03-28"
    },
    "mawissa": {
        "displayName": "Christian Mawissa",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2005-04-18"
    },
    "biereth": {
        "displayName": "Mika Biereth",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-02-08"
    },
    "ericdier": {
        "displayName": "Eric Dier",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1994-01-15"
    },
    "kohn": {
        "displayName": "Philipp Köhn",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1998-04-02"
    },
    "idumbo": {
        "displayName": "Stanis Idumbo",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "DR Congo",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-06-29"
    },
    "minamino": {
        "displayName": "Takumi Minamino",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Japan",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1995-01-16"
    },
    "papecabral": {
        "displayName": "Pape Cabral",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2007-01-20"
    },
    "flavionazinho": {
        "displayName": "Flávio Nazinho",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-07-20"
    },
    "salisu": {
        "displayName": "Mohammed Salisu",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Ghana",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1999-04-17"
    },
    "coulibaly": {
        "displayName": "Mamadou Coulibaly",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2004-04-21"
    },
    "brunner": {
        "displayName": "Paris Brunner",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Germany",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2006-02-15"
    },
    "ansufati": {
        "displayName": "Ansu Fati",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2002-10-31"
    },
    "edandiop": {
        "displayName": "Edan Diop",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2004-08-24"
    },
    "ilanetoure": {
        "displayName": "Ilane Touré",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 49,
        "dateofbirth": "2006-08-04"
    },
    "sadibousane": {
        "displayName": "Sadibou Sané",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Defender",
        "number": 72,
        "dateofbirth": "2004-06-10"
    },
    "berke_ozer": {
        "displayName": "Berke Özer",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-05-25"
    },
    "lounsrdanovic": {
        "displayName": "Loun Srdanovic",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2006-08-04"
    },
    "ngoy": {
        "displayName": "Nathan Ngoy",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-06-10"
    },
    "alexsandro": {
        "displayName": "Alexsandro",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-09"
    },
    "bentaleb": {
        "displayName": "Nabil Bentaleb",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1994-11-24"
    },
    "dilanebakwa": {
        "displayName": "Dilane Bakwa",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-08-26"
    },
    "ethan_mbappe": {
        "displayName": "Ethan Mbappé",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2006-12-29"
    },
    "giroud": {
        "displayName": "Olivier Giroud",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1986-09-30"
    },
    "hakonharaldsson": {
        "displayName": "Hákon Haraldsson",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Iceland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-04-10"
    },
    "sahraoui": {
        "displayName": "Osame Sahraoui",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-06-11"
    },
    "orlandogill": {
        "displayName": "Orlando Gill",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Paraguay",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2000-06-11"
    },
    "kjaergaard": {
        "displayName": "Maurits Kjærgaard",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2003-06-26"
    },
    "perraud": {
        "displayName": "Romain Perraud",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1997-09-22"
    },
    "mukau": {
        "displayName": "Ngal'ayel Mukau",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "DR Congo",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-11-03"
    },
    "ueda": {
        "displayName": "Ayase Ueda",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Japan",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1998-08-28"
    },
    "basaronal": {
        "displayName": "Başar Önal",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Turkey",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-07-06"
    },
    "andre": {
        "displayName": "Benjamin André",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1990-08-03"
    },
    "tiago_santos": {
        "displayName": "Tiago Santos",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2002-07-23"
    },
    "nianzou": {
        "displayName": "Tanguy Nianzou",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2002-06-07"
    },
    "verdonk": {
        "displayName": "Calvin Verdonk",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Indonesia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1997-04-26"
    },
    "isaaccossier": {
        "displayName": "Isaac Cossier",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-11-30"
    },
    "gaetanperrin": {
        "displayName": "Gaëtan Perrin",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1996-06-07"
    },
    "igamane": {
        "displayName": "Hamza Igamane",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2002-11-02"
    },
    "soribadiaoune": {
        "displayName": "Soriba Diaoune",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2007-08-14"
    },
    "maximagoffi": {
        "displayName": "Maxima Goffi",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 38,
        "dateofbirth": "2008-01-23"
    },
    "delange": {
        "displayName": "Jeffrey de Lange",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-04-01"
    },
    "eganriley": {
        "displayName": "CJ Egan-Riley",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-01-02"
    },
    "tochukwunnadi": {
        "displayName": "Tochukwu Nnadi",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2003-06-30"
    },
    "angelgomes": {
        "displayName": "Angel Gomes",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "England",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2000-08-31"
    },
    "himadabdelli": {
        "displayName": "Himad Abdelli",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-11-17"
    },
    "gouiri": {
        "displayName": "Amine Gouiri",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-02-16"
    },
    "maupay": {
        "displayName": "Neal Maupay",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-08-14"
    },
    "derekcornelius": {
        "displayName": "Derek Cornelius",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Canada",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1997-11-25"
    },
    "paixao": {
        "displayName": "Igor Paixão",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2000-06-28"
    },
    "bamomeite": {
        "displayName": "Bamo Meïté",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2001-06-20"
    },
    "kondogbia": {
        "displayName": "Geoffrey Kondogbia",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Central African Republic",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1993-02-15"
    },
    "aguerd": {
        "displayName": "Nayef Aguerd",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1996-03-30"
    },
    "weah": {
        "displayName": "Timothy Weah",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2000-02-22"
    },
    "hojbjerg": {
        "displayName": "Pierre-Emile Højbjerg",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1995-08-05"
    },
    "ulissesgarcia": {
        "displayName": "Ulisses Garcia",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1996-01-11"
    },
    "farismoumbagna": {
        "displayName": "Faris Moumbagna",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Cameroon",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2000-07-01"
    },
    "emerson": {
        "displayName": "Emerson Palmieri",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1994-08-03"
    },
    "jelleneck": {
        "displayName": "Jelle Van Neck",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2004-03-07"
    },
    "keylianeabdallah": {
        "displayName": "Keyliane Abdallah",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 48,
        "dateofbirth": "2006-04-05"
    },
    "amineharit": {
        "displayName": "Amine Harit",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 77,
        "dateofbirth": "1997-06-18"
    },
    "greif": {
        "displayName": "Dominik Greif",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-04-06"
    },
    "bidstrup": {
        "displayName": "Mads Bidstrup",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 2,
        "dateofbirth": "2001-02-25"
    },
    "tagliafico": {
        "displayName": "Nicolás Tagliafico",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Argentina",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1992-08-31"
    },
    "tessmann": {
        "displayName": "Tanner Tessmann",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-09-24"
    },
    "nuamah": {
        "displayName": "Ernest Nuamah",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Ghana",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-11-01"
    },
    "tolisso": {
        "displayName": "Corentin Tolisso",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-08-03"
    },
    "pavelsulc": {
        "displayName": "Pavel Šulc",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-12-29"
    },
    "keitonakamura": {
        "displayName": "Keito Nakamura",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Japan",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-07-28"
    },
    "athekame": {
        "displayName": "Zachary Athekame",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2004-12-13"
    },
    "abner": {
        "displayName": "Abner",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2000-05-27"
    },
    "openda": {
        "displayName": "Loïs Openda",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2000-02-16"
    },
    "khalismerah": {
        "displayName": "Khalis Merah",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2007-02-24"
    },
    "niakhate": {
        "displayName": "Moussa Niakhaté",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1996-03-08"
    },
    "felixbacher": {
        "displayName": "Felix Bacher",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Austria",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2000-10-25"
    },
    "rubenkluivert": {
        "displayName": "Ruben Kluivert",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2001-05-21"
    },
    "clintonmata": {
        "displayName": "Clinton Mata",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Angola",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1992-11-07"
    },
    "tylermorton": {
        "displayName": "Tyler Morton",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "England",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2002-10-31"
    },
    "duranville": {
        "displayName": "Julien Duranville",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2006-05-05"
    },
    "justinbengui": {
        "displayName": "Justin Bengui",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2005-07-09"
    },
    "kailboudache": {
        "displayName": "Kaïl Boudache",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2006-06-15"
    },
    "descamps": {
        "displayName": "Rémy Descamps",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1996-06-25"
    },
    "remihimbert": {
        "displayName": "Rémi Himbert",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2008-02-29"
    },
    "diarra": {
        "displayName": "Lassine Diarra",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Mali",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2002-11-11"
    },
    "mohamedouedraogo": {
        "displayName": "Mohamed Ouédraogo",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 76,
        "dateofbirth": "2003-01-02"
    },
    "nohamkamara": {
        "displayName": "Noham Kamara",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 85,
        "dateofbirth": "2007-01-22"
    },
    "noahnartey": {
        "displayName": "Noah Nartey",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "2005-10-05"
    },
    "hakimi": {
        "displayName": "Achraf Hakimi",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-11-04"
    },
    "beraldo": {
        "displayName": "Lucas Beraldo",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-11-24"
    },
    "marquinhos": {
        "displayName": "Marquinhos",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-05-14"
    },
    "zabarnyi": {
        "displayName": "Illia Zabarnyi",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Ukraine",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-09-01"
    },
    "kvaratskhelia": {
        "displayName": "Khvicha Kvaratskhelia",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Georgia",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-02-12"
    },
    "fabianruiz": {
        "displayName": "Fabián Ruiz",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-04-03"
    },
    "ferrantorres": {
        "displayName": "Ferran Torres",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-02-29"
    },
    "dembele": {
        "displayName": "Ousmane Dembélé",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-05-15"
    },
    "akliouche": {
        "displayName": "Maghnes Akliouche",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2002-02-25"
    },
    "digne": {
        "displayName": "Lucas Digne",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1993-07-20"
    },
    "desiredoue": {
        "displayName": "Désiré Doué",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2005-06-03"
    },
    "alessandrolongoni": {
        "displayName": "Alessandro Longoni",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "2008-01-31"
    },
    "vitinha": {
        "displayName": "Vitinha",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-02-13"
    },
    "lucashernandez": {
        "displayName": "Lucas Hernandez",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1996-02-14"
    },
    "godts": {
        "displayName": "Mika Godts",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2005-06-07"
    },
    "mayulu": {
        "displayName": "Senny Mayulu",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2006-05-17"
    },
    "nunomendes": {
        "displayName": "Nuno Mendes",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-06-19"
    },
    "drofernandez": {
        "displayName": "Dro Fernández",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2008-01-12"
    },
    "chevalier": {
        "displayName": "Lucas Chevalier",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2001-11-06"
    },
    "zaireemery": {
        "displayName": "Warren Zaïre-Emery",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2006-03-08"
    },
    "safonov": {
        "displayName": "Matvey Safonov",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "1999-02-25"
    },
    "ndjantou": {
        "displayName": "Quentin Ndjantou",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 47,
        "dateofbirth": "2007-07-23"
    },
    "pacho": {
        "displayName": "Willian Pacho",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Ecuador",
        "position": "Defender",
        "number": 51,
        "dateofbirth": "2001-10-16"
    },
    "joaoneves": {
        "displayName": "João Neves",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 87,
        "dateofbirth": "2004-09-27"
    },
    "gurtner": {
        "displayName": "Régis Gurtner",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-12-08"
    },
    "aguilar": {
        "displayName": "Ruben Aguilar",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1993-04-26"
    },
    "maiknawrocki": {
        "displayName": "Maik Nawrocki",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Poland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-02-07"
    },
    "nidalcelik": {
        "displayName": "Nidal Čelik",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-07-17"
    },
    "bulatovic": {
        "displayName": "Andrija Bulatović",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2006-12-27"
    },
    "sambaidoo": {
        "displayName": "Samson Baidoo",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Austria",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-03-31"
    },
    "sotoca": {
        "displayName": "Florian Sotoca",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1990-10-25"
    },
    "yacinetitraoui": {
        "displayName": "Yacine Titraoui",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-07-26"
    },
    "thorganhazard": {
        "displayName": "Thorgan Hazard",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-03-29"
    },
    "thauvin": {
        "displayName": "Florian Thauvin",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1993-01-26"
    },
    "edouard": {
        "displayName": "Odsonne Édouard",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-01-16"
    },
    "chavez": {
        "displayName": "Jhoanner Chávez",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Ecuador",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-04-25"
    },
    "udol": {
        "displayName": "Matthieu Udol",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1996-03-20"
    },
    "mathieugorgelin": {
        "displayName": "Mathieu Gorgelin",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1990-08-05"
    },
    "sima": {
        "displayName": "Abdallah Sima",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2001-06-17"
    },
    "jeantodibo": {
        "displayName": "Jean-Clair Todibo",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1999-12-30"
    },
    "haidara": {
        "displayName": "Amadou Haidara",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Mali",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1998-01-31"
    },
    "michaskoras": {
        "displayName": "Michał Skóraś",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Poland",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2000-02-15"
    },
    "saud": {
        "displayName": "Saud Abdulhamid",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-07-18"
    },
    "gradit": {
        "displayName": "Jonathan Gradit",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1992-11-24"
    },
    "ganiou": {
        "displayName": "Ismaëlo Ganiou",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2005-06-03"
    },
    "michaelcuisance": {
        "displayName": "Michaël Cuisance",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1999-08-16"
    },
    "juniorkadile": {
        "displayName": "Junior Kadile",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "DR Congo",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2002-12-16"
    },
    "franjoivanovic": {
        "displayName": "Franjo Ivanović",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Croatia",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2003-10-01"
    },
    "souleymanesagnan": {
        "displayName": "Souleymane Sagnan",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Mali",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2005-05-06"
    },
    "antonio": {
        "displayName": "Kyllian Antonio",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2008-01-14"
    },
    "mezianmesloub": {
        "displayName": "Mezian Mesloub",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2009-11-08"
    },
    "risser": {
        "displayName": "Robin Risser",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2004-12-02"
    },
    "jourdren": {
        "displayName": "Ilan Jourdren",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 60,
        "dateofbirth": "2008-01-08"
    },
    "charliecresswell": {
        "displayName": "Charlie Cresswell",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-12-07"
    },
    "goncalooliveira": {
        "displayName": "Gonçalo Oliveira",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2006-07-04"
    },
    "djaouicisse": {
        "displayName": "Djaoui Cissé",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-01-31"
    },
    "estebanlepaul": {
        "displayName": "Esteban Lepaul",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-04-18"
    },
    "ludovicblas": {
        "displayName": "Ludovic Blas",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Martinique",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1997-12-31"
    },
    "musataamari": {
        "displayName": "Musa Al-Taamari",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Jordan",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-06-10"
    },
    "eliezermayenda": {
        "displayName": "Eliezer Mayenda",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2005-05-08"
    },
    "bryanreynolds": {
        "displayName": "Bryan Reynolds",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2001-06-28"
    },
    "nicolaslemaitre": {
        "displayName": "Nicolas Lemaître",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1997-01-12"
    },
    "sebaszymanski": {
        "displayName": "Sebastian Szymański",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Poland",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1999-05-10"
    },
    "aboubakarnagida": {
        "displayName": "Aboubakar Nagida",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Cameroon",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2005-06-28"
    },
    "valentinrongier": {
        "displayName": "Valentin Rongier",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1994-12-07"
    },
    "dia": {
        "displayName": "Boulaye Dia",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1996-11-16"
    },
    "anthonyrouault": {
        "displayName": "Anthony Rouault",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-05-29"
    },
    "quentinmerlin": {
        "displayName": "Quentin Merlin",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2002-05-19"
    },
    "thomasson": {
        "displayName": "Adrien Thomasson",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1993-12-10"
    },
    "bricesamba": {
        "displayName": "Brice Samba",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1994-04-25"
    },
    "eliaslegendre": {
        "displayName": "Elías Legendre",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Ecuador",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2008-04-22"
    },
    "mahdicamara": {
        "displayName": "Mahdi Camara",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "1998-06-30"
    },
    "abdelhamidboudlal": {
        "displayName": "Abdelhamid Aït Boudlal",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Defender",
        "number": 48,
        "dateofbirth": "2006-04-16"
    },
    "henrickmarcolino": {
        "displayName": "Henrick Do Marcolino",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 65,
        "dateofbirth": "2006-03-21"
    },
    "arnaudnordin": {
        "displayName": "Arnaud Nordin",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "1998-06-17"
    },
    "issasoumare": {
        "displayName": "Issa Soumaré",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2000-10-10"
    },
    "przemysawfrankowski": {
        "displayName": "Przemysław Frankowski",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Poland",
        "position": "Midfielder",
        "number": 95,
        "dateofbirth": "1995-04-12"
    },
    "ayandasishuba": {
        "displayName": "Ayanda Sishuba",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2005-02-02"
    },
    "lujan": {
        "displayName": "Gonzalo Luján",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-04-27"
    },
    "reguilon": {
        "displayName": "Sergio Reguilón",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-12-16"
    },
    "mura": {
        "displayName": "Facundo Mura",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-23"
    },
    "casemiro": {
        "displayName": "Casemiro",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1992-02-23"
    },
    "depaul": {
        "displayName": "Rodrigo De Paul",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-05-24"
    },
    "segovia": {
        "displayName": "Telasco Segovia",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-04-02"
    },
    "luissuarez2": {
        "displayName": "Luis Suárez (Miami)",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1987-01-24"
    },
    "messi": {
        "displayName": "Lionel Messi",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1987-06-24"
    },
    "riquelmefillipi": {
        "displayName": "Riquelme Fillipi",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2006-09-15"
    },
    "luisbarraza": {
        "displayName": "Luis Barraza",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1996-11-08"
    },
    "friciocaicedo": {
        "displayName": "Fricio Caicedo",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Ecuador",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2008-04-17"
    },
    "micael": {
        "displayName": "Micael",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Brazil",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2000-08-12"
    },
    "fray": {
        "displayName": "Ian Fray",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Jamaica",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2002-08-31"
    },
    "germanberterame": {
        "displayName": "Germán Berterame",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Mexico",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1998-11-13"
    },
    "santiagomorales": {
        "displayName": "Santiago Morales",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2007-02-09"
    },
    "allende": {
        "displayName": "Tadeo Allende",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1999-02-20"
    },
    "ayala": {
        "displayName": "David Ayala",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2002-07-26"
    },
    "silvetti": {
        "displayName": "Mateo Silvetti",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2006-01-14"
    },
    "tylerhall": {
        "displayName": "Tyler Hall",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-02-05"
    },
    "rocconovo": {
        "displayName": "Rocco Ríos Novo",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 34,
        "dateofbirth": "2002-06-04"
    },
    "falcon": {
        "displayName": "Maximiliano Falcón",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1997-05-01"
    },
    "bright": {
        "displayName": "Yannick Bright",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Italy",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2001-09-03"
    },
    "danielpinter": {
        "displayName": "Dániel Pintér",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 56,
        "dateofbirth": "2007-06-06"
    },
    "prestonplambeck": {
        "displayName": "Preston Plambeck",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 59,
        "dateofbirth": "2005-12-20"
    },
    "israelboatwright": {
        "displayName": "Israel Boatwright",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Dominican Republic",
        "position": "Defender",
        "number": 62,
        "dateofbirth": "2005-06-02"
    },
    "matiasgalarza": {
        "displayName": "Matías Galarza",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Paraguay",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2002-02-11"
    },
    "stclair": {
        "displayName": "Dayne St. Clair",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 97,
        "dateofbirth": "1997-05-09"
    },
    "micovic": {
        "displayName": "Novak Mićović",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-10-25"
    },
    "lucascalegari": {
        "displayName": "Lucas Calegari",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-02-27"
    },
    "aude": {
        "displayName": "Julián Aude",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-03-24"
    },
    "yoshida": {
        "displayName": "Maya Yoshida",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1988-08-24"
    },
    "glesnes": {
        "displayName": "Jakob Glesnes",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Norway",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-03-25"
    },
    "sergiroberto": {
        "displayName": "Sergi Roberto",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1992-02-07"
    },
    "kyogofuruhashi": {
        "displayName": "Kyōgo Furuhashi",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Japan",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-01-20"
    },
    "sanabria": {
        "displayName": "Lucas Sanabria",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-12-28"
    },
    "puig": {
        "displayName": "Riqui Puig",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1999-08-13"
    },
    "hirvinglozano": {
        "displayName": "Hirving Lozano",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Mexico",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1995-07-30"
    },
    "marcinkowski": {
        "displayName": "JT Marcinkowski",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1997-05-09"
    },
    "nelson": {
        "displayName": "John Nelson",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1998-07-11"
    },
    "haak": {
        "displayName": "Justin Haak",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2001-09-12"
    },
    "parente": {
        "displayName": "Isaiah Parente",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2000-03-16"
    },
    "pabloruiz": {
        "displayName": "Pablo Ruiz",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1998-12-20"
    },
    "reus": {
        "displayName": "Marco Reus",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Germany",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1989-05-31"
    },
    "chrisrindov": {
        "displayName": "Chris Rindov",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2001-10-08"
    },
    "roberttaylor": {
        "displayName": "Robert Taylor",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Finland",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1994-10-21"
    },
    "wynder": {
        "displayName": "Elijah Wynder",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2003-03-10"
    },
    "carlosgarces": {
        "displayName": "Carlos Garcés",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2001-10-11"
    },
    "millermiller": {
        "displayName": "Harbor Miller",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2007-06-21"
    },
    "erikthommy": {
        "displayName": "Erik Thommy",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Germany",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1994-08-20"
    },
    "paintsil": {
        "displayName": "Joseph Paintsil",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Ghana",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1998-02-01"
    },
    "bradyscott": {
        "displayName": "Brady Scott",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1999-06-30"
    },
    "joaoklauss": {
        "displayName": "João Klauss",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Brazil",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1997-03-01"
    },
    "lloris": {
        "displayName": "Hugo Lloris",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "France",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-12-26"
    },
    "segura": {
        "displayName": "Eddie Segura",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-02-02"
    },
    "porteous": {
        "displayName": "Ryan Porteous",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Scotland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-03-25"
    },
    "igor_jesus": {
        "displayName": "Igor Jesus",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2003-03-07"
    },
    "son": {
        "displayName": "Son Heung-min",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "South Korea",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-07-08"
    },
    "delgado": {
        "displayName": "Mark Delgado",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-05-16"
    },
    "armindosieb": {
        "displayName": "Armindo Sieb",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Germany",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-02-17"
    },
    "timothytillman": {
        "displayName": "Timothy Tillman",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1999-01-04"
    },
    "hasal": {
        "displayName": "Thomas Hasal",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1999-07-09"
    },
    "palencia": {
        "displayName": "Sergi Palencia",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1996-03-23"
    },
    "ebobisse": {
        "displayName": "Jeremy Ebobisse",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1997-02-14"
    },
    "shaffelburg": {
        "displayName": "Jacob Shaffelburg",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1999-11-26"
    },
    "boyd": {
        "displayName": "Tyler Boyd",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1994-12-30"
    },
    "ryanraposo": {
        "displayName": "Ryan Raposo",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1999-03-05"
    },
    "jude_terry": {
        "displayName": "Jude Terry",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2008-10-08"
    },
    "yevhencheberko": {
        "displayName": "Yevhen Cheberko",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Ukraine",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1998-01-23"
    },
    "hollingshead": {
        "displayName": "Ryan Hollingshead",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1991-04-16"
    },
    "cabral_carter": {
        "displayName": "Cabral Carter",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2005-01-31"
    },
    "long": {
        "displayName": "Aaron Long",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1992-10-12"
    },
    "nielsen": {
        "displayName": "Kenny Nielsen",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "2002-02-13"
    },
    "choiniere": {
        "displayName": "Mathieu Choinière",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 66,
        "dateofbirth": "1999-02-07"
    },
    "leowalta": {
        "displayName": "Leo Walta",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Finland",
        "position": "Midfielder",
        "number": 81,
        "dateofbirth": "2003-06-24"
    },
    "tafari": {
        "displayName": "Nkosi Tafari",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "1997-03-23"
    },
    "bouanga": {
        "displayName": "Denis Bouanga",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Gabon",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1994-11-11"
    },
    "ajmarcucci": {
        "displayName": "AJ Marcucci",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-08-31"
    },
    "justinche": {
        "displayName": "Justin Che",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-11-18"
    },
    "jahkeelerutty": {
        "displayName": "Jahkeele Marshall-Rutty",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-06-16"
    },
    "omarvalencia": {
        "displayName": "Omar Valencia",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Panama",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-06-08"
    },
    "robertvoloder": {
        "displayName": "Robert Voloder",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Germany",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2001-05-09"
    },
    "cowell": {
        "displayName": "Cade Cowell",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-10-14"
    },
    "ruiz": {
        "displayName": "David Ruiz",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Honduras",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-02-08"
    },
    "forsberg": {
        "displayName": "Emil Forsberg",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-10-23"
    },
    "jorgeruvalcaba": {
        "displayName": "Jorge Ruvalcaba",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Mexico",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-07-23"
    },
    "dnealis": {
        "displayName": "Dylan Nealis",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1998-07-30"
    },
    "choupomoting": {
        "displayName": "Eric Maxim Choupo-Moting",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Cameroon",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1989-03-23"
    },
    "julianbazan": {
        "displayName": "Julián Bazán",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2005-11-25"
    },
    "adrimehmeti": {
        "displayName": "Adri Mehmeti",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2009-04-06"
    },
    "hall": {
        "displayName": "Julian Hall",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2008-03-24"
    },
    "cameronharper": {
        "displayName": "Cameron Harper",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-11-19"
    },
    "mina": {
        "displayName": "Juan José Mina",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2004-07-27"
    },
    "timparker": {
        "displayName": "Tim Parker",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1993-02-23"
    },
    "ethanhorvath": {
        "displayName": "Ethan Horvath",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 34,
        "dateofbirth": "1995-06-09"
    },
    "mohammedsofo": {
        "displayName": "Mohammed Sofo",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2004-11-30"
    },
    "benedetti": {
        "displayName": "Nehuén Benedetti",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2005-01-20"
    },
    "donkor": {
        "displayName": "Ronald Donkor",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 48,
        "dateofbirth": "2004-11-20"
    },
    "matthewsantos": {
        "displayName": "Matthew Dos Santos",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 56,
        "dateofbirth": "2008-06-05"
    },
    "tannerrosborough": {
        "displayName": "Tanner Rosborough",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 66,
        "dateofbirth": "2008-03-21"
    },
    "andyrojas": {
        "displayName": "Andy Rojas",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Costa Rica",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2005-12-05"
    },
    "mccarthy": {
        "displayName": "John McCarthy",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 77,
        "dateofbirth": "1992-07-04"
    },
    "rafaelmosquera": {
        "displayName": "Rafael Mosquera",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Panama",
        "position": "Midfielder",
        "number": 79,
        "dateofbirth": "2005-05-24"
    },
    "mijahirjimenez": {
        "displayName": "Mijahir Jiménez",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Panama",
        "position": "Forward",
        "number": 91,
        "dateofbirth": "2007-03-28"
    },
    "takaoka": {
        "displayName": "Yohei Takaoka",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Japan",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-03-16"
    },
    "laborda": {
        "displayName": "Mathías Laborda",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-09-15"
    },
    "adekugbe": {
        "displayName": "Sam Adekugbe",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1995-01-16"
    },
    "veselinovic": {
        "displayName": "Ranko Veselinović",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Serbia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-24"
    },
    "priso": {
        "displayName": "Ralph Priso",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-08-02"
    },
    "sabbi": {
        "displayName": "Emmanuel Sabbi",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-12-24"
    },
    "muller": {
        "displayName": "Thomas Müller",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Germany",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1989-09-13"
    },
    "cabrera": {
        "displayName": "Kenji Cabrera",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Peru",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-01-23"
    },
    "ocampo": {
        "displayName": "Édier Ocampo",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-10-03"
    },
    "elloumi": {
        "displayName": "Rayan Elloumi",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Tunisia",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2007-09-17"
    },
    "cubas": {
        "displayName": "Andrés Cubas",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Paraguay",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1996-05-11"
    },
    "white": {
        "displayName": "Brian White",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "1996-02-03"
    },
    "gauld": {
        "displayName": "Ryan Gauld",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1995-12-16"
    },
    "tatejohnson": {
        "displayName": "Tate Johnson",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "2005-07-10"
    },
    "zendejas": {
        "displayName": "Adrian Zendejas",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1995-08-30"
    },
    "boehmer": {
        "displayName": "Isaac Boehmer",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "2001-11-20"
    },
    "blackmon": {
        "displayName": "Tristan Blackmon",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1996-08-12"
    },
    "djordjevic": {
        "displayName": "Nikola Djordjevic",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 41,
        "dateofbirth": "2002-09-15"
    },
    "badwal": {
        "displayName": "Jeevan Badwal",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 59,
        "dateofbirth": "2006-03-11"
    },
    "davidraya": {
        "displayName": "David Raya",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-09-15"
    },
    "saliba": {
        "displayName": "William Saliba",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-03-24"
    },
    "mosquera": {
        "displayName": "Cristhian Mosquera",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-06-27"
    },
    "benwhite": {
        "displayName": "Ben White",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-10-08"
    },
    "hincapie": {
        "displayName": "Piero Hincapié",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-01-09"
    },
    "gabriel": {
        "displayName": "Gabriel Magalhães",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1997-12-19"
    },
    "saka": {
        "displayName": "Bukayo Saka",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-09-05"
    },
    "odegaard": {
        "displayName": "Martin Ødegaard",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-12-17"
    },
    "eze": {
        "displayName": "Eberechi Eze",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-06-29"
    },
    "jurrientimber": {
        "displayName": "Jurriën Timber",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2001-06-17"
    },
    "kepa": {
        "displayName": "Kepa Arrizabalaga",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-10-03"
    },
    "gyokeres": {
        "displayName": "Viktor Gyökeres",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-06-04"
    },
    "konsa": {
        "displayName": "Ezri Konsa",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1997-10-23"
    },
    "tzolis": {
        "displayName": "Christos Tzolis",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Greece",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2002-01-30"
    },
    "madueke": {
        "displayName": "Noni Madueke",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2002-03-10"
    },
    "merino": {
        "displayName": "Mikel Merino",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1996-06-22"
    },
    "havertz": {
        "displayName": "Kai Havertz",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Germany",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-06-11"
    },
    "illanmeslier": {
        "displayName": "Illan Meslier",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "France",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2000-03-02"
    },
    "calafiori": {
        "displayName": "Riccardo Calafiori",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2002-05-19"
    },
    "zubimendi": {
        "displayName": "Martín Zubimendi",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "1999-02-02"
    },
    "bruno": {
        "displayName": "Bruno Guimarães",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "1997-11-16"
    },
    "declanrice": {
        "displayName": "Declan Rice",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "1999-01-14"
    },
    "lewisskelly": {
        "displayName": "Myles Lewis-Skelly",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 49,
        "dateofbirth": "2006-09-26"
    },
    "zionsuzuki": {
        "displayName": "Zion Suzuki",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Japan",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-08-21"
    },
    "cash": {
        "displayName": "Matty Cash",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Poland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-08-07"
    },
    "lindelof": {
        "displayName": "Victor Lindelöf",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1994-07-17"
    },
    "taylorbellis": {
        "displayName": "Taylor Harwood-Bellis",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-01-30"
    },
    "mings": {
        "displayName": "Tyrone Mings",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1993-03-13"
    },
    "barkley": {
        "displayName": "Ross Barkley",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1993-12-05"
    },
    "mcginn": {
        "displayName": "John McGinn",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-10-18"
    },
    "kamara": {
        "displayName": "Boubacar Kamara",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-11-23"
    },
    "buendia": {
        "displayName": "Emiliano Buendía",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-12-25"
    },
    "nicolasjackson": {
        "displayName": "Nicolas Jackson",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-06-20"
    },
    "ruggeri": {
        "displayName": "Matteo Ruggeri",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-07-11"
    },
    "pautorres": {
        "displayName": "Pau Torres",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1997-01-16"
    },
    "garnacho": {
        "displayName": "Alejandro Garnacho",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-07-01"
    },
    "tammyabraham": {
        "displayName": "Tammy Abraham",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1997-10-02"
    },
    "ibrahimmbaye": {
        "displayName": "Ibrahim Mbaye",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2008-01-24"
    },
    "maatsen": {
        "displayName": "Ian Maatsen",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2002-03-10"
    },
    "aonana": {
        "displayName": "Amadou Onana",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2001-08-16"
    },
    "lamarebogarde": {
        "displayName": "Lamare Bogarde",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2004-01-05"
    },
    "goretzka": {
        "displayName": "Leon Goretzka",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1995-02-06"
    },
    "aaronbissaka": {
        "displayName": "Aaron Wan-Bissaka",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "DR Congo",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1997-11-26"
    },
    "joaogomes": {
        "displayName": "João Gomes",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2001-02-12"
    },
    "brianmadjo": {
        "displayName": "Brian Madjo",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2009-01-12"
    },
    "bizot": {
        "displayName": "Marco Bizot",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1991-03-10"
    },
    "jameswright": {
        "displayName": "James Wright",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 42,
        "dateofbirth": "2004-12-02"
    },
    "johanmanzambi": {
        "displayName": "Johan Manzambi",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2005-10-14"
    },
    "alysson": {
        "displayName": "Alysson",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 47,
        "dateofbirth": "2006-05-05"
    },
    "modoucisse": {
        "displayName": "Modou Kéba Cissé",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Defender",
        "number": 48,
        "dateofbirth": "2005-08-04"
    },
    "georgehemmings": {
        "displayName": "George Hemmings",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 53,
        "dateofbirth": "2007-03-04"
    },
    "emartinez": {
        "displayName": "Emiliano Martínez",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-09-02"
    },
    "marcopalestra": {
        "displayName": "Marco Palestra",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-03-03"
    },
    "wesleyfofana": {
        "displayName": "Wesley Fofana",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-12-17"
    },
    "valentinbarco": {
        "displayName": "Valentín Barco",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2004-07-23"
    },
    "maxencelacroix": {
        "displayName": "Maxence Lacroix",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-04-06"
    },
    "colwill": {
        "displayName": "Levi Colwill",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-02-26"
    },
    "pedroneto": {
        "displayName": "Pedro Neto",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-03-09"
    },
    "joaopedro": {
        "displayName": "João Pedro",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-09-26"
    },
    "palmer": {
        "displayName": "Cole Palmer",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-05-06"
    },
    "gittens": {
        "displayName": "Jamie Gittens",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-08-08"
    },
    "jordanhenderson": {
        "displayName": "Jordan Henderson",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1990-06-17"
    },
    "mrogers": {
        "displayName": "Morgan Rogers",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2002-07-26"
    },
    "dannywelbeck": {
        "displayName": "Danny Welbeck",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1990-11-26"
    },
    "hato": {
        "displayName": "Jorrel Hato",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2006-03-07"
    },
    "emmanuelemegha": {
        "displayName": "Emmanuel Emegha",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2003-02-03"
    },
    "geovanyquenda": {
        "displayName": "Geovany Quenda",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2007-04-30"
    },
    "reecejames": {
        "displayName": "Reece James",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1999-12-08"
    },
    "caicedo": {
        "displayName": "Moisés Caicedo",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Ecuador",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-11-02"
    },
    "gusto": {
        "displayName": "Malo Gusto",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2003-05-19"
    },
    "teddylowe": {
        "displayName": "Teddy Sharman-Lowe",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "2003-03-30"
    },
    "pepchavarria": {
        "displayName": "Pep Chavarría",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1998-04-10"
    },
    "anselmino": {
        "displayName": "Aarón Anselmino",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2005-04-29"
    },
    "reggiewatson": {
        "displayName": "Reggie Watson",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 31,
        "dateofbirth": "2010-01-26"
    },
    "mahdijazuli": {
        "displayName": "Mahdi Nicoll-Jazuli",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2010-01-06"
    },
    "joshacheampong": {
        "displayName": "Josh Acheampong",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2006-05-05"
    },
    "mikependers": {
        "displayName": "Mike Penders",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "2005-07-31"
    },
    "estevao": {
        "displayName": "Estêvão",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 41,
        "dateofbirth": "2007-04-24"
    },
    "slonina": {
        "displayName": "Gabriel Slonina",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2004-05-15"
    },
    "lavia": {
        "displayName": "Roméo Lavia",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2004-01-06"
    },
    "deanhenderson": {
        "displayName": "Dean Henderson",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-03-12"
    },
    "tyrickmitchell": {
        "displayName": "Tyrick Mitchell",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-09-01"
    },
    "chadiriad": {
        "displayName": "Chadi Riad",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Morocco",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-06-17"
    },
    "axeldisasi": {
        "displayName": "Axel Disasi",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1998-03-11"
    },
    "jaydeecanvot": {
        "displayName": "Jaydee Canvot",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2006-07-29"
    },
    "ismailasarr": {
        "displayName": "Ismaïla Sarr",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1998-02-25"
    },
    "jeffersonlerma": {
        "displayName": "Jefferson Lerma",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-10-25"
    },
    "eddienketiah": {
        "displayName": "Eddie Nketiah",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-05-30"
    },
    "yeremypino": {
        "displayName": "Yéremy Pino",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2002-10-20"
    },
    "dwightmcneil": {
        "displayName": "Dwight McNeil",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1999-11-22"
    },
    "zaviergozo": {
        "displayName": "Zavier Gozo",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "United States",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2007-03-22"
    },
    "jeanmateta": {
        "displayName": "Jean-Philippe Mateta",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-06-28"
    },
    "tomiyasu": {
        "displayName": "Takehiro Tomiyasu",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Japan",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-11-05"
    },
    "daichikamada": {
        "displayName": "Daichi Kamada",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Japan",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1996-08-05"
    },
    "willhughes": {
        "displayName": "Will Hughes",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1995-04-17"
    },
    "adamwharton": {
        "displayName": "Adam Wharton",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-02-06"
    },
    "ahanor": {
        "displayName": "Honest Ahanor",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2008-02-23"
    },
    "jrgenlarsen": {
        "displayName": "Jørgen Strand Larsen",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2000-02-06"
    },
    "quintentimber": {
        "displayName": "Quinten Timber",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-06-17"
    },
    "darioosorio": {
        "displayName": "Darío Osorio",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Chile",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2004-01-24"
    },
    "khalaili": {
        "displayName": "Anan Khalaili",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Israel",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2004-09-03"
    },
    "chrisrichards": {
        "displayName": "Chris Richards",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "United States",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2000-03-28"
    },
    "cheickdoucoure": {
        "displayName": "Cheick Doucouré",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Mali",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2000-01-08"
    },
    "guessand": {
        "displayName": "Evann Guessand",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2001-07-01"
    },
    "oscarmingueza": {
        "displayName": "Óscar Mingueza",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1999-05-13"
    },
    "remimatthews": {
        "displayName": "Remi Matthews",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1994-02-10"
    },
    "benchilwell": {
        "displayName": "Ben Chilwell",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1996-12-21"
    },
    "walterbenitez": {
        "displayName": "Walter Benítez",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "1993-01-19"
    },
    "berndleno": {
        "displayName": "Bernd Leno",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-03-04"
    },
    "kennytete": {
        "displayName": "Kenny Tete",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-10-09"
    },
    "calvinbassey": {
        "displayName": "Calvin Bassey",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Nigeria",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-12-31"
    },
    "jorgecuenca": {
        "displayName": "Jorge Cuenca",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-11-17"
    },
    "joachimandersen": {
        "displayName": "Joachim Andersen",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-05-31"
    },
    "harrisonreed": {
        "displayName": "Harrison Reed",
        "club": "Fulham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1995-01-27"
    },
    "gonzalo": {
        "displayName": "Gonzalo García",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-03-24"
    },
    "cesarpalacios": {
        "displayName": "César Palacios",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-11-11"
    },
    "rodrigomuniz": {
        "displayName": "Rodrigo Muniz",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-05-04"
    },
    "tomcairney": {
        "displayName": "Tom Cairney",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-01-20"
    },
    "kevin": {
        "displayName": "Kevin",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-01-04"
    },
    "bobb": {
        "displayName": "Oscar Bobb",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-07-12"
    },
    "larsson": {
        "displayName": "Hugo Larsson",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2004-06-27"
    },
    "sanderberge": {
        "displayName": "Sander Berge",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1998-02-14"
    },
    "alexiwobi": {
        "displayName": "Alex Iwobi",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1996-05-03"
    },
    "jonahasare": {
        "displayName": "Jonah Kusi-Asare",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2007-07-04"
    },
    "sheacharles": {
        "displayName": "Shea Charles",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Northern Ireland",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2003-11-05"
    },
    "manuelangel": {
        "displayName": "Manuel Ángel",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-03-15"
    },
    "timothycastagne": {
        "displayName": "Timothy Castagne",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1995-12-05"
    },
    "davidaffengruber": {
        "displayName": "David Affengruber",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Austria",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2001-03-19"
    },
    "benjaminlecomte": {
        "displayName": "Benjamin Lecomte",
        "club": "Fulham",
        "league": "Premier League",
        "country": "France",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1991-04-26"
    },
    "joshking": {
        "displayName": "Josh King",
        "club": "Fulham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2007-01-03"
    },
    "ryansessegnon": {
        "displayName": "Ryan Sessegnon",
        "club": "Fulham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2000-05-18"
    },
    "emilerowe": {
        "displayName": "Emile Smith Rowe",
        "club": "Fulham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2000-07-28"
    },
    "antoneerobinson": {
        "displayName": "Antonee Robinson",
        "club": "Fulham",
        "league": "Premier League",
        "country": "United States",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1997-08-08"
    },
    "alisson": {
        "displayName": "Alisson Becker",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-10-02"
    },
    "gomez": {
        "displayName": "Joe Gomez",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-05-23"
    },
    "endo": {
        "displayName": "Wataru Endo",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Japan",
        "position": "Midfielder",
        "number": 3,
        "dateofbirth": "1993-02-09"
    },
    "vandijk": {
        "displayName": "Virgil van Dijk",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1991-07-08"
    },
    "jeremyjacquet": {
        "displayName": "Jérémy Jacquet",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2005-07-13"
    },
    "kerkez": {
        "displayName": "Milos Kerkez",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Hungary",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-11-07"
    },
    "wirtz": {
        "displayName": "Florian Wirtz",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-05-03"
    },
    "szoboszlai": {
        "displayName": "Dominik Szoboszlai",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Hungary",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-10-25"
    },
    "isak": {
        "displayName": "Alexander Isak",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-09-21"
    },
    "alexismacallister": {
        "displayName": "Alexis Mac Allister",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-12-24"
    },
    "bradley": {
        "displayName": "Conor Bradley",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Northern Ireland",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2003-07-09"
    },
    "chiesa": {
        "displayName": "Federico Chiesa",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Italy",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-10-25"
    },
    "leoni": {
        "displayName": "Giovanni Leoni",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2006-12-21"
    },
    "gakpo": {
        "displayName": "Cody Gakpo",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1999-05-07"
    },
    "tsimikas": {
        "displayName": "Kostas Tsimikas",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Greece",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1996-05-12"
    },
    "ekitike": {
        "displayName": "Hugo Ekitike",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-06-20"
    },
    "victormunoz": {
        "displayName": "Víctor Muñoz",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Spain",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-07-13"
    },
    "mamardashvili": {
        "displayName": "Giorgi Mamardashvili",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Georgia",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2000-09-29"
    },
    "woodman": {
        "displayName": "Freddie Woodman",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1997-03-04"
    },
    "barcola": {
        "displayName": "Bradley Barcola",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2002-09-02"
    },
    "frimpong": {
        "displayName": "Jeremie Frimpong",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2000-12-10"
    },
    "araujo": {
        "displayName": "Ronald Araújo",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Uruguay",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1999-03-07"
    },
    "gravenberch": {
        "displayName": "Ryan Gravenberch",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2002-05-16"
    },
    "nyoni": {
        "displayName": "Trey Nyoni",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2007-06-30"
    },
    "lukechambers": {
        "displayName": "Luke Chambers",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2004-06-24"
    },
    "mcconnell": {
        "displayName": "James McConnell",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 53,
        "dateofbirth": "2004-09-13"
    },
    "jaros": {
        "displayName": "Vítězslav Jaroš",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 56,
        "dateofbirth": "2001-07-23"
    },
    "lewiskoumas": {
        "displayName": "Lewis Koumas",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Wales",
        "position": "Forward",
        "number": 67,
        "dateofbirth": "2005-09-19"
    },
    "ngumoha": {
        "displayName": "Rio Ngumoha",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 73,
        "dateofbirth": "2008-07-21"
    },
    "jaydendanns": {
        "displayName": "Jayden Danns",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 76,
        "dateofbirth": "2006-01-16"
    },
    "harveydavies": {
        "displayName": "Harvey Davies",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 95,
        "dateofbirth": "2003-09-23"
    },
    "donnarumma": {
        "displayName": "Gianluigi Donnarumma",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-02-25"
    },
    "rubendias": {
        "displayName": "Rúben Dias",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-05-14"
    },
    "elliotanderson": {
        "displayName": "Elliot Anderson",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2002-11-06"
    },
    "guehi": {
        "displayName": "Marc Guéhi",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2000-07-13"
    },
    "ilimanndiaye": {
        "displayName": "Iliman Ndiaye",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-03-06"
    },
    "kovacic": {
        "displayName": "Mateo Kovačić",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-05-06"
    },
    "haaland": {
        "displayName": "Erling Haaland",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-07-21"
    },
    "cherki": {
        "displayName": "Rayan Cherki",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-08-17"
    },
    "doku": {
        "displayName": "Jérémy Doku",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-05-27"
    },
    "marcusbettinelli": {
        "displayName": "Marcus Bettinelli",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1992-05-24"
    },
    "enzo": {
        "displayName": "Enzo Fernández",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2001-01-17"
    },
    "aitnouri": {
        "displayName": "Rayan Aït-Nouri",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Algeria",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2001-06-06"
    },
    "vitorreis": {
        "displayName": "Vitor Reis",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-01-12"
    },
    "gvardiol": {
        "displayName": "Joško Gvardiol",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Croatia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2002-01-23"
    },
    "matheusnunes": {
        "displayName": "Matheus Nunes",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1998-08-27"
    },
    "rulli": {
        "displayName": "Gerónimo Rulli",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1992-05-20"
    },
    "bouaddi": {
        "displayName": "Ayyoub Bouaddi",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2007-10-02"
    },
    "oreilly": {
        "displayName": "Nico O'Reilly",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2005-03-21"
    },
    "allan": {
        "displayName": "Allan",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2004-04-19"
    },
    "semenyo": {
        "displayName": "Antoine Semenyo",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Ghana",
        "position": "Forward",
        "number": 42,
        "dateofbirth": "2000-01-07"
    },
    "khusanov": {
        "displayName": "Abdukodir Khusanov",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Uzbekistan",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "2004-02-29"
    },
    "foden": {
        "displayName": "Phil Foden",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2000-05-28"
    },
    "ryanmcaidoo": {
        "displayName": "Ryan McAidoo",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 56,
        "dateofbirth": "2008-06-24"
    },
    "kadenbraithwaite": {
        "displayName": "Kaden Braithwaite",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 61,
        "dateofbirth": "2008-02-08"
    },
    "floydsamba": {
        "displayName": "Floyd Samba",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 75,
        "dateofbirth": "2009-01-15"
    },
    "ricolewis": {
        "displayName": "Rico Lewis",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 82,
        "dateofbirth": "2004-11-21"
    },
    "lammens": {
        "displayName": "Senne Lammens",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-07-07"
    },
    "dalot": {
        "displayName": "Diogo Dalot",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-03-18"
    },
    "mazraoui": {
        "displayName": "Noussair Mazraoui",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Morocco",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-11-14"
    },
    "deligt": {
        "displayName": "Matthijs de Ligt",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-12"
    },
    "maguire": {
        "displayName": "Harry Maguire",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1993-03-05"
    },
    "inigomartinez": {
        "displayName": "Lisandro Martínez",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-01-18"
    },
    "mount": {
        "displayName": "Mason Mount",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-01-10"
    },
    "brunofernandes": {
        "displayName": "Bruno Fernandes",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-09-08"
    },
    "rashford": {
        "displayName": "Marcus Rashford",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-10-31"
    },
    "cunha": {
        "displayName": "Matheus Cunha",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-05-27"
    },
    "zirkzee": {
        "displayName": "Joshua Zirkzee",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-05-22"
    },
    "karldarlow": {
        "displayName": "Karl Darlow",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Wales",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1990-10-08"
    },
    "dorgu": {
        "displayName": "Patrick Dorgu",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2004-10-26"
    },
    "yoro": {
        "displayName": "Leny Yoro",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2005-11-13"
    },
    "amad": {
        "displayName": "Amad Diallo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2002-07-11"
    },
    "andreysantos": {
        "displayName": "Andrey Santos",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-05-03"
    },
    "tielemans": {
        "displayName": "Youri Tielemans",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-05-07"
    },
    "mbeumo": {
        "displayName": "Bryan Mbeumo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Cameroon",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-08-07"
    },
    "carlosbaleba": {
        "displayName": "Carlos Baleba",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Cameroon",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-01-03"
    },
    "heaton": {
        "displayName": "Tom Heaton",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1986-04-15"
    },
    "shaw": {
        "displayName": "Luke Shaw",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1995-07-12"
    },
    "ugarte": {
        "displayName": "Manuel Ugarte",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-04-11"
    },
    "heaven": {
        "displayName": "Ayden Heaven",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-09-22"
    },
    "sesko": {
        "displayName": "Benjamin Šeško",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Slovenia",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2003-05-31"
    },
    "shealacey": {
        "displayName": "Shea Lacey",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2007-04-14"
    },
    "mainoo": {
        "displayName": "Kobbie Mainoo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2005-04-19"
    },
    "jackfletcher": {
        "displayName": "Jack Fletcher",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2007-03-19"
    },
    "tylerfletcher": {
        "displayName": "Tyler Fletcher",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2007-03-19"
    },
    "harryamass": {
        "displayName": "Harry Amass",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 41,
        "dateofbirth": "2007-03-16"
    },
    "dermotmee": {
        "displayName": "Dermot Mee",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Northern Ireland",
        "position": "Goalkeeper",
        "number": 45,
        "dateofbirth": "2002-11-20"
    },
    "nickpope": {
        "displayName": "Nick Pope",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-19"
    },
    "livramento": {
        "displayName": "Tino Livramento",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-11-12"
    },
    "lewishall": {
        "displayName": "Lewis Hall",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-09-08"
    },
    "botman": {
        "displayName": "Sven Botman",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-01-12"
    },
    "schar": {
        "displayName": "Fabian Schär",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1991-12-20"
    },
    "nicogonzalez": {
        "displayName": "Nico González",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-01-03"
    },
    "joelinton": {
        "displayName": "Joelinton",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1996-08-14"
    },
    "aladjibamba": {
        "displayName": "Aladji Bamba",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-07-14"
    },
    "wissa": {
        "displayName": "Yoane Wissa",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "DR Congo",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1996-09-03"
    },
    "osula": {
        "displayName": "William Osula",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2003-08-04"
    },
    "harveybarnes": {
        "displayName": "Harvey Barnes",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-12-09"
    },
    "thiaw": {
        "displayName": "Malick Thiaw",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Germany",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2001-08-08"
    },
    "seansteur": {
        "displayName": "Sean Steur",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2008-01-11"
    },
    "bazoumanatoure": {
        "displayName": "Bazoumana Touré",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2006-03-02"
    },
    "elanga": {
        "displayName": "Anthony Elanga",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2002-04-27"
    },
    "fernandez_pardo": {
        "displayName": "Matias Fernandez-Pardo",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2005-02-03"
    },
    "hornicek": {
        "displayName": "Lukáš Horníček",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 21,
        "dateofbirth": "2002-07-13"
    },
    "jacobmurphy": {
        "displayName": "Jacob Murphy",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1995-02-24"
    },
    "ewenjaouen": {
        "displayName": "Ewen Jaouen",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "France",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "2005-12-29"
    },
    "willock": {
        "displayName": "Joe Willock",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1999-08-20"
    },
    "gillespie": {
        "displayName": "Mark Gillespie",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "1992-03-27"
    },
    "danburn": {
        "displayName": "Dan Burn",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1992-05-09"
    },
    "amardedic": {
        "displayName": "Amar Dedić",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2002-08-18"
    },
    "jacobramsey": {
        "displayName": "Jacob Ramsey",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "2001-05-28"
    },
    "lewismiley": {
        "displayName": "Lewis Miley",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 67,
        "dateofbirth": "2006-05-01"
    },
    "robertson": {
        "displayName": "Andy Robertson",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1994-03-11"
    },
    "adarabioyo": {
        "displayName": "Tosin Adarabioyo",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-09-24"
    },
    "marcossenesi": {
        "displayName": "Marcos Senesi",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-05-10"
    },
    "janhecke": {
        "displayName": "Jan Paul van Hecke",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2000-06-08"
    },
    "xavisimons": {
        "displayName": "Xavi Simons",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-04-21"
    },
    "gallagher": {
        "displayName": "Conor Gallagher",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-02-06"
    },
    "richarlison": {
        "displayName": "Richarlison",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-05-10"
    },
    "maddison": {
        "displayName": "James Maddison",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-11-23"
    },
    "mathystel": {
        "displayName": "Mathys Tel",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-04-27"
    },
    "udogie": {
        "displayName": "Destiny Udogie",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-11-28"
    },
    "archiegray": {
        "displayName": "Archie Gray",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2006-03-12"
    },
    "bergvall": {
        "displayName": "Lucas Bergvall",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2006-02-02"
    },
    "tonali": {
        "displayName": "Sandro Tonali",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Italy",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2000-05-08"
    },
    "savio": {
        "displayName": "Sávio",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2004-04-10"
    },
    "mateusfernandes": {
        "displayName": "Mateus Fernandes",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2004-07-10"
    },
    "solanke": {
        "displayName": "Dominic Solanke",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1997-09-14"
    },
    "kudus": {
        "displayName": "Mohammed Kudus",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Ghana",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-08-02"
    },
    "kulusevski": {
        "displayName": "Dejan Kulusevski",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2000-04-25"
    },
    "marmoush": {
        "displayName": "Omar Marmoush",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Egypt",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1999-02-07"
    },
    "pedroporro": {
        "displayName": "Pedro Porro",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-09-13"
    },
    "mudryk": {
        "displayName": "Mykhailo Mudryk",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Ukraine",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2001-01-05"
    },
    "odobert": {
        "displayName": "Wilson Odobert",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2004-11-28"
    },
    "bentancur": {
        "displayName": "Rodrigo Bentancur",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "1997-06-25"
    },
    "kinsky": {
        "displayName": "Antonín Kinský",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2003-03-13"
    },
    "bendavies": {
        "displayName": "Ben Davies",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Wales",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1993-04-24"
    },
    "vandeven": {
        "displayName": "Micky van de Ven",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2001-04-19"
    },
    "martindubravka": {
        "displayName": "Martin Dúbravka",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "1989-01-15"
    },
    "austin": {
        "displayName": "Brandon Austin",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1999-01-08"
    },
    "madshermansen": {
        "displayName": "Mads Hermansen",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-07-11"
    },
    "kylepeters": {
        "displayName": "Kyle Walker-Peters",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-04-13"
    },
    "maximiliankilman": {
        "displayName": "Maximilian Kilman",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-05-23"
    },
    "edsonalvarez": {
        "displayName": "Edson Álvarez",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Mexico",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1997-10-24"
    },
    "morato": {
        "displayName": "Morato",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2001-06-30"
    },
    "arneengels": {
        "displayName": "Arne Engels",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-09-08"
    },
    "joelpiroe": {
        "displayName": "Joël Piroe",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Suriname",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-08-02"
    },
    "solomon": {
        "displayName": "Manor Solomon",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Israel",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-07-24"
    },
    "castellanos": {
        "displayName": "Taty Castellanos",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-10-03"
    },
    "divinemukasa": {
        "displayName": "Divine Mukasa",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2007-08-22"
    },
    "konstantinosmavropanos": {
        "displayName": "Konstantinos Mavropanos",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Greece",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1997-12-11"
    },
    "mohamadoukante": {
        "displayName": "Mohamadou Kanté",
        "club": "West Ham",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-09-20"
    },
    "adamaboiro": {
        "displayName": "Adama Boiro",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2002-06-22"
    },
    "pablo": {
        "displayName": "Pablo",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-01-02"
    },
    "jarrodbowen": {
        "displayName": "Jarrod Bowen",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "1996-12-20"
    },
    "keiberlamadrid": {
        "displayName": "Keiber Lamadrid",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-11-18"
    },
    "maxwelcornet": {
        "displayName": "Maxwel Cornet",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1996-09-27"
    },
    "alphonseareola": {
        "displayName": "Alphonse Areola",
        "club": "West Ham",
        "league": "Premier League",
        "country": "France",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1993-02-27"
    },
    "soungoutoumagassa": {
        "displayName": "Soungoutou Magassa",
        "club": "West Ham",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2003-10-08"
    },
    "tomassoucek": {
        "displayName": "Tomáš Souček",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1995-02-27"
    },
    "oliverscarles": {
        "displayName": "Oliver Scarles",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2005-12-12"
    },
    "joelveltman": {
        "displayName": "Joël Veltman",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "1992-01-15"
    },
    "edvinaustb": {
        "displayName": "Edvin Austbø",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2005-05-01"
    },
    "finlayherrick": {
        "displayName": "Finlay Herrick",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 49,
        "dateofbirth": "2006-01-18"
    },
    "airidasgolambeckis": {
        "displayName": "Airidas Golambeckis",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 58,
        "dateofbirth": "2007-11-04"
    },
    "lewisorford": {
        "displayName": "Lewis Orford",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 61,
        "dateofbirth": "2006-02-18"
    },
    "ezramayers": {
        "displayName": "Ezra Mayers",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 63,
        "dateofbirth": "2007-01-16"
    },
    "joshuaajala": {
        "displayName": "Joshua Ajala",
        "club": "West Ham",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 66,
        "dateofbirth": "2006-11-13"
    },
    "shakhruddinmagomedaliyev": {
        "displayName": "Shakhruddin Magomedaliyev",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Azerbaijan",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-06-12"
    },
    "matheussilva": {
        "displayName": "Matheus Silva",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-10-03"
    },
    "bencevarkonyi": {
        "displayName": "Bence Várkonyi",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Hungary",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-03-18"
    },
    "brunolanga": {
        "displayName": "Bruno Langa",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Mozambique",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-10-31"
    },
    "jalymouaddib": {
        "displayName": "Jaly Mouaddib",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "France",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2000-11-18"
    },
    "markojankovic": {
        "displayName": "Marko Janković",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-07-09"
    },
    "zakariasawo": {
        "displayName": "Zakaria Sawo",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-01-11"
    },
    "jonimontiel": {
        "displayName": "Joni Montiel",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-09-03"
    },
    "redakhadra": {
        "displayName": "Reda Khadra",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Germany",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2001-07-04"
    },
    "behlulmustafazade": {
        "displayName": "Behlul Mustafazade",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Azerbaijan",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1997-02-27"
    },
    "ismaheel": {
        "displayName": "Taofeek Ismaheel",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Nigeria",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2000-08-16"
    },
    "kadyborges": {
        "displayName": "Kady Borges",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1996-05-02"
    },
    "oleksiykashchuk": {
        "displayName": "Oleksiy Kashchuk",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2000-06-29"
    },
    "musaqurbanl": {
        "displayName": "Musa Qurbanlı",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Azerbaijan",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-04-13"
    },
    "martinzlomislic": {
        "displayName": "Martin Zlomislić",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Bosnia and Herzegovina",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1998-08-16"
    },
    "cebrailsmakreckis": {
        "displayName": "Čebrails Makreckis",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Latvia",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2000-05-10"
    },
    "renaldocephas": {
        "displayName": "Renaldo Cephas",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Jamaica",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-12-08"
    },
    "diegorosa": {
        "displayName": "Diego Rosa",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2002-10-12"
    },
    "pedrobicalho": {
        "displayName": "Pedro Bicalho",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2001-04-23"
    },
    "elvincafarguliyev": {
        "displayName": "Elvin Cafarguliyev",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Azerbaijan",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2000-10-26"
    },
    "badaviguseynov": {
        "displayName": "Badavi Guseynov",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Azerbaijan",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "1991-07-11"
    },
    "samuellobato": {
        "displayName": "Samuel Lobato",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 88,
        "dateofbirth": "2001-10-19"
    },
    "kiwior": {
        "displayName": "Jakub Kiwior",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-02-15"
    },
    "bednarek": {
        "displayName": "Jan Bednarek",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-04-12"
    },
    "chrissmalling": {
        "displayName": "Chris Smalling",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1989-11-22"
    },
    "williamgomes": {
        "displayName": "William Gomes",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2006-03-15"
    },
    "froholdt": {
        "displayName": "Victor Froholdt",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-02-25"
    },
    "samuaghehowa": {
        "displayName": "Samu Aghehowa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-05-05"
    },
    "gabriveiga": {
        "displayName": "Gabri Veiga",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-05-27"
    },
    "pepe": {
        "displayName": "Pepê",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-02-24"
    },
    "zaidusanusi": {
        "displayName": "Zaidu Sanusi",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Nigeria",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-06-13"
    },
    "pablorosario": {
        "displayName": "Pablo Rosario",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Dominican Republic",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1997-01-07"
    },
    "claudioramos": {
        "displayName": "Cláudio Ramos",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 14,
        "dateofbirth": "1991-12-15"
    },
    "vascosousa": {
        "displayName": "Vasco Sousa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2003-04-03"
    },
    "hwang": {
        "displayName": "Hwang In-beom",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "South Korea",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1996-09-20"
    },
    "borjasainz": {
        "displayName": "Borja Sainz",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-02-01"
    },
    "nehuenperez": {
        "displayName": "Nehuén Pérez",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2000-06-24"
    },
    "andresilva": {
        "displayName": "André Silva",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1995-11-06"
    },
    "albertocosta": {
        "displayName": "Alberto Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-09-29"
    },
    "prpic": {
        "displayName": "Dominik Prpić",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Croatia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2004-05-19"
    },
    "alanvarela": {
        "displayName": "Alan Varela",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2001-07-04"
    },
    "joaocosta": {
        "displayName": "João Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1996-02-02"
    },
    "santiagogimenez": {
        "displayName": "Santiago Giménez",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Mexico",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2001-04-18"
    },
    "souza": {
        "displayName": "Souza",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2006-06-16"
    },
    "gabrielmec": {
        "displayName": "Gabriel Mec",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2008-04-11"
    },
    "sekofofana": {
        "displayName": "Seko Fofana",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "1995-05-07"
    },
    "martimfernandes": {
        "displayName": "Martim Fernandes",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 52,
        "dateofbirth": "2006-01-18"
    },
    "franciscomoura": {
        "displayName": "Francisco Moura",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 74,
        "dateofbirth": "1999-08-16"
    },
    "pietuszewski": {
        "displayName": "Oskar Pietuszewski",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2008-05-20"
    },
    "diogocosta": {
        "displayName": "Diogo Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-09-19"
    },
    "victorgomez": {
        "displayName": "Víctor Gómez",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2000-04-01"
    },
    "niakate": {
        "displayName": "Sikou Niakaté",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Mali",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-07-10"
    },
    "vitor_carvalho": {
        "displayName": "Vitor Carvalho",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1997-05-27"
    },
    "diogotravassos": {
        "displayName": "Diogo Travassos",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "2004-03-31"
    },
    "moutinho": {
        "displayName": "João Moutinho (Braga)",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1986-09-08"
    },
    "frannavarro": {
        "displayName": "Fran Navarro",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-02-03"
    },
    "pau_victor": {
        "displayName": "Pau Víctor",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-11-26"
    },
    "gabrielsilva": {
        "displayName": "Gabriel Silva",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-03-22"
    },
    "tiagosa": {
        "displayName": "Tiago Sá",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1995-01-11"
    },
    "lagerbielke": {
        "displayName": "Gustaf Lagerbielke",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Sweden",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2000-04-10"
    },
    "tommymarques": {
        "displayName": "Tommy Marqués",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2006-10-30"
    },
    "jovanmilosevic": {
        "displayName": "Jovan Milošević",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Serbia",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2005-07-31"
    },
    "jonaswind": {
        "displayName": "Jonas Wind",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-02-07"
    },
    "dorgeles": {
        "displayName": "Mario Dorgeles",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-08-07"
    },
    "ricardohorta": {
        "displayName": "Ricardo Horta",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1994-09-15"
    },
    "sergiobarcia": {
        "displayName": "Sergio Barcia",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2000-12-31"
    },
    "denishuseinbasic": {
        "displayName": "Denis Huseinbašić",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-07-03"
    },
    "arreymbi": {
        "displayName": "Bright Arrey-Mbi",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Germany",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2003-03-26"
    },
    "jeangorby": {
        "displayName": "Jean-Baptiste Gorby",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "France",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2002-07-25"
    },
    "bernardo": {
        "displayName": "Bernardo",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2002-07-23"
    },
    "demirtknaz": {
        "displayName": "Demir Ege Tıknaz",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "2004-08-17"
    },
    "adrianbarisic": {
        "displayName": "Adrian Barišić",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2001-07-19"
    },
    "adrianbajrami": {
        "displayName": "Adrian Bajrami",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-04-05"
    },
    "diegorodrigues": {
        "displayName": "Diego Rodrigues",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 50,
        "dateofbirth": "2005-08-20"
    },
    "joaoaragao": {
        "displayName": "João Aragão",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 73,
        "dateofbirth": "2008-03-24"
    },
    "gabrimartinez": {
        "displayName": "Gabri Martínez",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2003-02-22"
    },
    "joaocarvalho": {
        "displayName": "João Carvalho",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 78,
        "dateofbirth": "2004-04-09"
    },
    "trubin": {
        "displayName": "Anatoliy Trubin",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-08-01"
    },
    "lenglet": {
        "displayName": "Clément Lenglet",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-06-17"
    },
    "alessandrocircati": {
        "displayName": "Alessandro Circati",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Australia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-10-10"
    },
    "barrenechea": {
        "displayName": "Enzo Barrenechea",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-05-22"
    },
    "alexanderbah": {
        "displayName": "Alexander Bah",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1997-12-09"
    },
    "aursnes": {
        "displayName": "Fredrik Aursnes",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-12-10"
    },
    "sudakov": {
        "displayName": "Heorhiy Sudakov",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-09-01"
    },
    "lukebakio": {
        "displayName": "Dodi Lukébakio",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-09-24"
    },
    "jakubkaminski": {
        "displayName": "Jakub Kamiński",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "2002-06-05"
    },
    "pavlidis": {
        "displayName": "Vangelis Pavlidis",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-11-21"
    },
    "manusilva": {
        "displayName": "Manu Silva",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-06-12"
    },
    "barreiro": {
        "displayName": "Leandro Barreiro",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Luxembourg",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2000-01-03"
    },
    "schjelderup": {
        "displayName": "Andreas Schjelderup",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Norway",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2004-06-01"
    },
    "jhonduran": {
        "displayName": "Jhon Durán",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Colombia",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2003-12-13"
    },
    "samuelsoares": {
        "displayName": "Samuel Soares",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "2002-06-15"
    },
    "prestianni": {
        "displayName": "Gianluca Prestianni",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2006-01-31"
    },
    "samueldahl": {
        "displayName": "Samuel Dahl",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Sweden",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2003-03-04"
    },
    "rafasilva": {
        "displayName": "Rafa Silva",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1993-05-17"
    },
    "echeverri": {
        "displayName": "Claudio Echeverri",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2006-01-02"
    },
    "gabrielindio": {
        "displayName": "Gabriel Índio",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2008-07-26"
    },
    "souffiankarouani": {
        "displayName": "Souffian El Karouani",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Morocco",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2000-10-19"
    },
    "palhinha": {
        "displayName": "João Palhinha",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "1995-07-09"
    },
    "tomasaraujo": {
        "displayName": "Tomás Araújo",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-05-16"
    },
    "diogoferreira": {
        "displayName": "Diogo Ferreira",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2007-04-10"
    },
    "danielbanjaqui": {
        "displayName": "Daniel Banjaqui",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 58,
        "dateofbirth": "2008-03-24"
    },
    "joseneto": {
        "displayName": "José Neto",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 62,
        "dateofbirth": "2008-04-19"
    },
    "anisiocabral": {
        "displayName": "Anísio Cabral",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 72,
        "dateofbirth": "2008-02-15"
    },
    "ruisilva": {
        "displayName": "Rui Silva",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-02-07"
    },
    "silasandersen": {
        "displayName": "Silas Andersen",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2004-06-13"
    },
    "sergialtimira": {
        "displayName": "Sergi Altimira",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-08-25"
    },
    "zenodebast": {
        "displayName": "Zeno Debast",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Belgium",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-10-24"
    },
    "fotisioannidis": {
        "displayName": "Fotis Ioannidis",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-01-10"
    },
    "joaosimoes": {
        "displayName": "João Simões",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2007-01-06"
    },
    "rafaelnel": {
        "displayName": "Rafael Nel",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2005-04-03"
    },
    "genycatamo": {
        "displayName": "Geny Catamo",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Mozambique",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-01-26"
    },
    "nunosantos": {
        "displayName": "Nuno Santos",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 11,
        "dateofbirth": "1995-02-13"
    },
    "vagiannidis": {
        "displayName": "Georgios Vagiannidis",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2001-09-12"
    },
    "zalazar": {
        "displayName": "Rodrigo Zalazar",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1999-08-12"
    },
    "moncefzekri": {
        "displayName": "Moncef Zekri",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Morocco",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2008-09-20"
    },
    "nestoryirankunda": {
        "displayName": "Nestory Irankunda",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Australia",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2006-02-09"
    },
    "maxiaraujo": {
        "displayName": "Maximiliano Araújo",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Uruguay",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-02-15"
    },
    "pedrolima": {
        "displayName": "Pedro Lima",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-03-27"
    },
    "ivanfresneda": {
        "displayName": "Iván Fresneda",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2004-09-28"
    },
    "goncaloinacio": {
        "displayName": "Gonçalo Inácio",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2001-08-25"
    },
    "jessederry": {
        "displayName": "Jesse Derry",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "England",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2007-06-30"
    },
    "kaiquepereira": {
        "displayName": "Kaique Pereira",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2003-04-16"
    },
    "luisguilherme": {
        "displayName": "Luis Guilherme",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2006-02-09"
    },
    "diegocallai": {
        "displayName": "Diego Callai",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2004-07-18"
    },
    "ibrahimaba": {
        "displayName": "Ibrahima Ba",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Senegal",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "2005-05-26"
    },
    "flaviogoncalves": {
        "displayName": "Flávio Gonçalves",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 58,
        "dateofbirth": "2007-05-30"
    },
    "eduardoquaresma": {
        "displayName": "Eduardo Quaresma",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 72,
        "dateofbirth": "2002-03-02"
    },
    "eduardofelicissimo": {
        "displayName": "Eduardo Felicíssimo",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 73,
        "dateofbirth": "2007-01-08"
    },
    "issadoumbia": {
        "displayName": "Issa Doumbia",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Italy",
        "position": "Midfielder",
        "number": 77,
        "dateofbirth": "2003-10-16"
    },
    "luissuarez": {
        "displayName": "Luis Suárez",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Colombia",
        "position": "Forward",
        "number": 97,
        "dateofbirth": "1997-12-02"
    },
    "franciscosilva": {
        "displayName": "Francisco Silva",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "2005-11-20"
    },
    "sommer": {
        "displayName": "Yann Sommer",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1988-12-17"
    },
    "leebeom": {
        "displayName": "Lee Han-beom",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "South Korea",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-06-17"
    },
    "ordonez": {
        "displayName": "Joel Ordóñez",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2004-04-21"
    },
    "tresoldi": {
        "displayName": "Nicolò Tresoldi",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-08-20"
    },
    "freddiepotts": {
        "displayName": "Freddie Potts",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "England",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-09-12"
    },
    "forbs": {
        "displayName": "Carlos Forbs",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-03-19"
    },
    "vetlesen": {
        "displayName": "Hugo Vetlesen",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-02-29"
    },
    "janvirgili": {
        "displayName": "Jan Virgili",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Spain",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2006-07-26"
    },
    "cheveyo_tsawa": {
        "displayName": "Cheveyo Tsawa",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2006-12-09"
    },
    "vermant": {
        "displayName": "Romeo Vermant",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2004-01-24"
    },
    "vanaken": {
        "displayName": "Hans Vanaken",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1992-08-24"
    },
    "mike": {
        "displayName": "Wisdom Mike",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Germany",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2008-07-14"
    },
    "jackers": {
        "displayName": "Nordin Jackers",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "1997-09-05"
    },
    "dams": {
        "displayName": "Matteo Dams",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2004-03-09"
    },
    "siquet": {
        "displayName": "Hugo Siquet",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 41,
        "dateofbirth": "2002-07-09"
    },
    "mechele": {
        "displayName": "Brandon Mechele",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "1993-01-28"
    },
    "spileers": {
        "displayName": "Jorne Spileers",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 58,
        "dateofbirth": "2005-01-21"
    },
    "lynntaudoor": {
        "displayName": "Lynnt Audoor",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 62,
        "dateofbirth": "2003-10-13"
    },
    "sabbe": {
        "displayName": "Kyriani Sabbe",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 64,
        "dateofbirth": "2005-01-26"
    },
    "seys": {
        "displayName": "Joaquin Seys",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 65,
        "dateofbirth": "2005-03-28"
    },
    "diakhon": {
        "displayName": "Mamadou Diakhon",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Senegal",
        "position": "Forward",
        "number": 67,
        "dateofbirth": "2005-09-22"
    },
    "alejandrogranados": {
        "displayName": "Alejandro Granados",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 70,
        "dateofbirth": "2006-05-30"
    },
    "andrejvasovic": {
        "displayName": "Andrej Vasovic",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2007-10-14"
    },
    "felixlemarechal": {
        "displayName": "Félix Lemaréchal",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2003-08-07"
    },
    "tiankoren": {
        "displayName": "Tian Nai Koren",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 85,
        "dateofbirth": "2009-07-31"
    },
    "tobeleysen": {
        "displayName": "Tobe Leysen",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-03-09"
    },
    "benjamintahirovic": {
        "displayName": "Benjamin Tahirović",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2003-03-03"
    },
    "christiaanravych": {
        "displayName": "Christiaan Ravych",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-07-30"
    },
    "smets": {
        "displayName": "Matte Smets",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-01-04"
    },
    "heynen": {
        "displayName": "Bryan Heynen",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-02-06"
    },
    "junyaito": {
        "displayName": "Junya Itō",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Japan",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1993-03-09"
    },
    "jeppeerenbjerg": {
        "displayName": "Jeppe Erenbjerg",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2000-04-29"
    },
    "durosinmi": {
        "displayName": "Rafiu Durosinmi",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-01-01"
    },
    "kayembe": {
        "displayName": "Joris Kayembe",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "DR Congo",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1994-08-08"
    },
    "yaimarmedina": {
        "displayName": "Yaimar Medina",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2004-11-05"
    },
    "kevinamaro": {
        "displayName": "Kevin Amaro",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Uruguay",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2004-03-03"
    },
    "bangoura": {
        "displayName": "Ibrahima Sory Bangoura",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Guinea",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-01-05"
    },
    "bibout": {
        "displayName": "Aaron Bibout",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Cameroon",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2004-09-03"
    },
    "sattlberger": {
        "displayName": "Nikolas Sattlberger",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Austria",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2004-01-18"
    },
    "milanroganovic": {
        "displayName": "Milan Roganović",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Montenegro",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2005-10-28"
    },
    "lawal": {
        "displayName": "Tobias Lawal",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "2000-06-07"
    },
    "nkuba": {
        "displayName": "Ken Nkuba",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2002-01-21"
    },
    "brughmans": {
        "displayName": "Lucca Brughmans",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "2008-06-27"
    },
    "yokoyama": {
        "displayName": "Ayumu Yokoyama",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Japan",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2003-03-04"
    },
    "noahsternberg": {
        "displayName": "Noah Adedeji-Sternberg",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2005-06-19"
    },
    "adrianpalacios": {
        "displayName": "Adrián Palacios",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Venezuela",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2004-06-07"
    },
    "heymans": {
        "displayName": "Daan Heymans",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "1999-06-15"
    },
    "kongolo": {
        "displayName": "Josue Kongolo",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2006-04-13"
    },
    "augustwannemacker": {
        "displayName": "August De Wannemacker",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 56,
        "dateofbirth": "2008-12-25"
    },
    "eliembavu": {
        "displayName": "Elie Mbavu",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 73,
        "dateofbirth": "2009-10-20"
    },
    "alvarocortes": {
        "displayName": "Álvaro Cortés",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-03-17"
    },
    "tsunashima": {
        "displayName": "Yuto Tsunashima",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-08-15"
    },
    "foulon": {
        "displayName": "Daam Foulon",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-03-23"
    },
    "bahmeddeuff": {
        "displayName": "Bahmed Deuff",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Mauritania",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2006-03-10"
    },
    "anthonyvalencia": {
        "displayName": "Anthony Valencia",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-07-21"
    },
    "michaelfrey": {
        "displayName": "Michael Frey",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1994-07-19"
    },
    "hairemans": {
        "displayName": "Geoffry Hairemans",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1991-10-21"
    },
    "xanderdierckx": {
        "displayName": "Xander Dierckx",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2009-02-27"
    },
    "thoelen": {
        "displayName": "Yannick Thoelen",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 15,
        "dateofbirth": "1990-07-18"
    },
    "renders": {
        "displayName": "Semm Renders",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2007-09-21"
    },
    "urinboev": {
        "displayName": "Mukhammadali Urinboev",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Uzbekistan",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-04-24"
    },
    "reinhelden": {
        "displayName": "Rein Van Helden",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-07-24"
    },
    "verstraeten": {
        "displayName": "Andreas Verstraeten",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2006-01-10"
    },
    "adekami": {
        "displayName": "Farouck Adekami",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2006-08-07"
    },
    "kokiando": {
        "displayName": "Koki Ando",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Japan",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2007-09-22"
    },
    "somers": {
        "displayName": "Thibo Somers",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1999-03-16"
    },
    "scott": {
        "displayName": "Christopher Scott",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2002-06-07"
    },
    "taishinozawa": {
        "displayName": "Taishi Nozawa",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Japan",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2002-12-25"
    },
    "youssefhamdaoui": {
        "displayName": "Youssef Hamdaoui",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2008-03-20"
    },
    "maximebusi": {
        "displayName": "Maxime Busi",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "1999-10-14"
    },
    "vermeeren": {
        "displayName": "Arthur Vermeeren",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 48,
        "dateofbirth": "2005-02-07"
    },
    "ibrahimsalah": {
        "displayName": "Ibrahim Salah",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Morocco",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2001-08-30"
    },
    "devalckeneer": {
        "displayName": "Niels Devalckeneer",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 81,
        "dateofbirth": "2004-05-17"
    },
    "chambaere": {
        "displayName": "Vic Chambaere",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2003-01-10"
    },
    "kevinmacallister": {
        "displayName": "Kevin Mac Allister",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Argentina",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-11-07"
    },
    "vandeperre": {
        "displayName": "Kamiel Van de Perre",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-02-12"
    },
    "zorgane": {
        "displayName": "Adem Zorgane",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-01-06"
    },
    "mateobiondic": {
        "displayName": "Mateo Biondić",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Germany",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-07-24"
    },
    "aitelhadj": {
        "displayName": "Anouar Ait El Hadj",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-04-20"
    },
    "smith": {
        "displayName": "Guilherme Smith",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-06-11"
    },
    "hervekoffi": {
        "displayName": "Hervé Koffi",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Burkina Faso",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1996-10-16"
    },
    "kevinrodriguez": {
        "displayName": "Kevin Rodríguez",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "2000-03-04"
    },
    "ivanpavlic": {
        "displayName": "Ivan Pavlić",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2001-11-10"
    },
    "schoofs": {
        "displayName": "Rob Schoofs",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1994-03-23"
    },
    "kavlashvili": {
        "displayName": "Giorgi Kavlashvili",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Georgia",
        "position": "Goalkeeper",
        "number": 18,
        "dateofbirth": "2007-01-24"
    },
    "dylanaquino": {
        "displayName": "Dylan Aquino",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Argentina",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2005-06-04"
    },
    "denzelroeve": {
        "displayName": "Denzel De Roeve",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2004-08-10"
    },
    "besfortzeneli": {
        "displayName": "Besfort Zeneli",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2002-11-21"
    },
    "sykes": {
        "displayName": "Ross Sykes",
        "club": "Union SG",
        "league": "Pro League",
        "country": "England",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1999-03-26"
    },
    "patris": {
        "displayName": "Louis Patris",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-06-07"
    },
    "dariusolaru": {
        "displayName": "Darius Olaru",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Romania",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1998-03-03"
    },
    "massiresylla": {
        "displayName": "Massiré Sylla",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Senegal",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2005-01-07"
    },
    "florucz": {
        "displayName": "Raul Florucz",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Austria",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2001-06-10"
    },
    "relebohilemofokeng": {
        "displayName": "Relebohile Mofokeng",
        "club": "Union SG",
        "league": "Pro League",
        "country": "South Africa",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "2004-10-23"
    },
    "nikkihavenaar": {
        "displayName": "Nikki Havenaar",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Japan",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "1995-02-16"
    },
    "ondrejkricfalusi": {
        "displayName": "Ondřej Kričfaluši",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2004-03-29"
    },
    "alsanbi": {
        "displayName": "Abdulrahman Al-Sanbi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-02-03"
    },
    "zakariahawsawi": {
        "displayName": "Zakaria Hawsawi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-01-12"
    },
    "ibanez": {
        "displayName": "Roger Ibañez",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-11-23"
    },
    "ibrahimadiaby": {
        "displayName": "Ibrahima Diaby",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2007-03-17"
    },
    "sulaiman": {
        "displayName": "Mohammed Sulaiman",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-05-14"
    },
    "atangana": {
        "displayName": "Valentin Atangana",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-08-25"
    },
    "franciscotrincao": {
        "displayName": "Francisco Trincão",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-12-29"
    },
    "eduardspertsyan": {
        "displayName": "Eduard Spertsyan",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Armenia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-06-07"
    },
    "alburaikan": {
        "displayName": "Firas Al-Buraikan",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-05-14"
    },
    "meshalmutairi": {
        "displayName": "Meshal Al-Mutairi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1999-03-25"
    },
    "galeno": {
        "displayName": "Galeno",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1997-10-22"
    },
    "edouardmendy": {
        "displayName": "Édouard Mendy",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1992-03-01"
    },
    "ivantoney": {
        "displayName": "Ivan Toney",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "England",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1996-03-16"
    },
    "artembondarenko": {
        "displayName": "Artem Bondarenko",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2000-08-21"
    },
    "matheusgoncalves": {
        "displayName": "Matheus Gonçalves",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2005-08-18"
    },
    "radif": {
        "displayName": "Abdullah Radif",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2003-01-20"
    },
    "abubacarrkinteh": {
        "displayName": "Abubacarr Sedi Kinteh",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Gambia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2006-11-30"
    },
    "majrashi": {
        "displayName": "Ali Majrashi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1999-10-01"
    },
    "demiral": {
        "displayName": "Merih Demiral",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Turkey",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "1998-03-05"
    },
    "mohammedabdulrahman": {
        "displayName": "Mohammed Abdulrahman",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2003-01-14"
    },
    "aljohani": {
        "displayName": "Ziyad Al-Johani",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2001-11-11"
    },
    "saadbalobaid": {
        "displayName": "Saad Balobaid",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2000-01-27"
    },
    "rayanhamed": {
        "displayName": "Rayan Hamed",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 46,
        "dateofbirth": "2002-04-13"
    },
    "salehshamat": {
        "displayName": "Saleh Abu Al-Shamat",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2002-08-11"
    },
    "naifmasoud": {
        "displayName": "Naif Masoud",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 66,
        "dateofbirth": "2001-01-08"
    },
    "koulibaly": {
        "displayName": "Kalidou Koulibaly",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1991-06-20"
    },
    "akcicek": {
        "displayName": "Yusuf Akçiçek",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Turkey",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-01-25"
    },
    "aldawsari_nasser": {
        "displayName": "Nasser Al-Dawsari",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-12-19"
    },
    "gabrielmartinelli": {
        "displayName": "Gabriel Martinelli",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-06-18"
    },
    "rubenneves": {
        "displayName": "Rúben Neves",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-03-13"
    },
    "watkins": {
        "displayName": "Ollie Watkins",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1995-12-30"
    },
    "mohammedrubaie": {
        "displayName": "Mohammed Al-Rubaie",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 17,
        "dateofbirth": "1997-08-14"
    },
    "muradhawsawi": {
        "displayName": "Murad Hawsawi",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2001-06-03"
    },
    "theohernandez": {
        "displayName": "Théo Hernandez",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1997-10-06"
    },
    "milinkovicsavic": {
        "displayName": "Sergej Milinković-Savić",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1995-02-27"
    },
    "alharbi": {
        "displayName": "Moteb Al-Harbi",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2000-02-19"
    },
    "sultanmandash": {
        "displayName": "Sultan Mandash",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1994-10-17"
    },
    "kanno": {
        "displayName": "Mohamed Kanno",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1994-09-22"
    },
    "aldawsari_salem": {
        "displayName": "Salem Al-Dawsari",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1991-08-19"
    },
    "mohammedowais": {
        "displayName": "Mohammed Al-Owais",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1991-10-10"
    },
    "bounou": {
        "displayName": "Yassine Bounou",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Morocco",
        "position": "Goalkeeper",
        "number": 37,
        "dateofbirth": "1991-04-05"
    },
    "crysenciosummerville": {
        "displayName": "Crysencio Summerville",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "2001-10-30"
    },
    "saimonbouabre": {
        "displayName": "Saïmon Bouabré",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 70,
        "dateofbirth": "2006-06-01"
    },
    "mohamedmeite": {
        "displayName": "Mohamed Kader Meïté",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 75,
        "dateofbirth": "2007-10-11"
    },
    "lajami": {
        "displayName": "Ali Lajami",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 78,
        "dateofbirth": "1996-04-24"
    },
    "tambakti": {
        "displayName": "Hassan Al-Tambakti",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 87,
        "dateofbirth": "1999-02-09"
    },
    "hamadyami": {
        "displayName": "Hamad Al-Yami",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 88,
        "dateofbirth": "1999-05-17"
    },
    "rajkovic": {
        "displayName": "Predrag Rajković",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-10-31"
    },
    "danilopereira": {
        "displayName": "Danilo Pereira",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 2,
        "dateofbirth": "1991-09-09"
    },
    "simic": {
        "displayName": "Jan-Carlo Simić",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2005-05-02"
    },
    "richardrios": {
        "displayName": "Richard Ríos",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2000-06-02"
    },
    "almousa": {
        "displayName": "Saad Al-Mousa",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-12-10"
    },
    "rogerfernandes": {
        "displayName": "Roger Fernandes",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2005-11-21"
    },
    "mukhtarali": {
        "displayName": "Mukhtar Ali",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-10-30"
    },
    "ilenikhena": {
        "displayName": "George Ilenikhena",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2006-08-16"
    },
    "aouar": {
        "displayName": "Houssem Aouar",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-06-30"
    },
    "alshehri": {
        "displayName": "Saleh Al-Shehri",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1993-11-01"
    },
    "shanqeeti_m": {
        "displayName": "Muhannad Al-Shanqeeti",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1999-03-12"
    },
    "kadesh": {
        "displayName": "Hassan Kadesh",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1992-09-06"
    },
    "doumbia": {
        "displayName": "Mahamadou Doumbia",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Mali",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-05-15"
    },
    "sharahili": {
        "displayName": "Ahmed Sharahili",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1994-05-08"
    },
    "ennesyri": {
        "displayName": "Youssef En-Nesyri",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1997-06-01"
    },
    "alsahafi": {
        "displayName": "Marwan Al-Sahafi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2004-02-17"
    },
    "georginiowijnaldum": {
        "displayName": "Georginio Wijnaldum",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1990-11-11"
    },
    "farisabdi": {
        "displayName": "Faris Abdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1999-05-19"
    },
    "alghamdi_a": {
        "displayName": "Ahmed Al-Ghamdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2001-09-20"
    },
    "farhahshamrani": {
        "displayName": "Farhah Al-Shamrani",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2006-02-27"
    },
    "dionlopy": {
        "displayName": "Dion Lopy",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2002-02-02"
    },
    "ahmedjulaydan": {
        "displayName": "Ahmed Al-Julaydan",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2004-03-08"
    },
    "bergwijn": {
        "displayName": "Steven Bergwijn",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 34,
        "dateofbirth": "1997-10-08"
    },
    "muathfaqeehi": {
        "displayName": "Muath Faqeehi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2002-05-30"
    },
    "alabsi": {
        "displayName": "Mohammed Al-Absi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2002-09-24"
    },
    "rakankaabi": {
        "displayName": "Rakan Kaabi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 60,
        "dateofbirth": "2002-12-02"
    },
    "mohammedbarnawi": {
        "displayName": "Mohammed Barnawi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 66,
        "dateofbirth": "2005-08-07"
    },
    "alghamdi_h": {
        "displayName": "Hamed Al-Ghamdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "1999-04-02"
    },
    "alaqidi": {
        "displayName": "Nawaf Al-Aqidi",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-05-10"
    },
    "alghannam": {
        "displayName": "Sultan Al-Ghannam",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1994-05-06"
    },
    "simakan": {
        "displayName": "Mohamed Simakan",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-05-03"
    },
    "alsharari": {
        "displayName": "Nader Al-Sharari",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-05-08"
    },
    "alamri": {
        "displayName": "Abdulelah Al-Amri",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-01-15"
    },
    "saadnasser": {
        "displayName": "Saad Al-Nasser",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2001-01-08"
    },
    "ronaldo": {
        "displayName": "Cristiano Ronaldo",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1985-02-05"
    },
    "hayderabdulkareem": {
        "displayName": "Hayder Abdulkareem",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Iraq",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-07-08"
    },
    "alhamdan": {
        "displayName": "Abdullah Al-Hamdan",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-09-13"
    },
    "mane": {
        "displayName": "Sadio Mané",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1992-04-10"
    },
    "samucosta": {
        "displayName": "Samú Costa",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2000-11-27"
    },
    "nawafboushal": {
        "displayName": "Nawaf Boushal",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-09-16"
    },
    "alhajai": {
        "displayName": "Sami Al-Najei",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1997-02-07"
    },
    "mohammedmaran": {
        "displayName": "Mohammed Maran",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2001-02-15"
    },
    "alkhaibari": {
        "displayName": "Abdullah Al-Khaibari",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1996-08-16"
    },
    "angelogabriel": {
        "displayName": "Ângelo Gabriel",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-12-21"
    },
    "coman": {
        "displayName": "Kingsley Coman",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1996-06-13"
    },
    "aymanyahya": {
        "displayName": "Ayman Yahya",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-05-14"
    },
    "bento": {
        "displayName": "Bento",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1999-06-10"
    },
    "martinez": {
        "displayName": "Iñigo Martínez",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1991-05-17"
    },
    "ghareeb": {
        "displayName": "Abdulrahman Ghareeb",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "1997-03-31"
    },
    "najjar": {
        "displayName": "Raghed Al-Najjar",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1996-09-20"
    },
    "majedqasheesh": {
        "displayName": "Majed Qasheesh",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 50,
        "dateofbirth": "2001-12-04"
    },
    "joaofelix": {
        "displayName": "João Félix",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 79,
        "dateofbirth": "1999-11-10"
    },
    "alnajdi": {
        "displayName": "Salem Al-Najdi",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 83,
        "dateofbirth": "2003-01-27"
    },
    "casteels": {
        "displayName": "Koen Casteels",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-06-25"
    },
    "mohammedshamat": {
        "displayName": "Mohammed Abu Al-Shamat",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-08-11"
    },
    "jehadthakri": {
        "displayName": "Jehad Thakri",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2001-07-21"
    },
    "weigl": {
        "displayName": "Julian Weigl",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1995-09-08"
    },
    "nacho": {
        "displayName": "Nacho",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1990-01-18"
    },
    "alammar": {
        "displayName": "Turki Al-Ammar",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-09-23"
    },
    "nandez": {
        "displayName": "Nahitan Nández",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-12-28"
    },
    "alsalem": {
        "displayName": "Abdullah Al-Salem",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1992-12-19"
    },
    "aljuwayr": {
        "displayName": "Musab Al-Juwayr",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-06-20"
    },
    "hazazi": {
        "displayName": "Ali Hazazi",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1994-02-18"
    },
    "alshahrani": {
        "displayName": "Yasser Al-Shahrani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1992-05-25"
    },
    "reijnders": {
        "displayName": "Tijjani Reijnders",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1998-07-29"
    },
    "mohammedqahtani": {
        "displayName": "Mohammed Al-Qahtani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2002-07-23"
    },
    "gastonalvarez": {
        "displayName": "Gastón Álvarez",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Uruguay",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-03-24"
    },
    "aljaber": {
        "displayName": "Abdulmalik Al-Jaber",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2004-01-07"
    },
    "haithamasiri": {
        "displayName": "Haitham Asiri",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2001-03-25"
    },
    "bonsubaah": {
        "displayName": "Christopher Bonsu Baah",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2004-12-14"
    },
    "waleedahmed": {
        "displayName": "Waleed Al-Ahmed",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-05-03"
    },
    "mohammedqassem": {
        "displayName": "Mohammed Qassem",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1995-01-19"
    },
    "alkassar": {
        "displayName": "Ahmed Al-Kassar",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1991-05-08"
    },
    "mahamadousangare": {
        "displayName": "Mahamadou Sangaré",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2007-03-06"
    },
    "retegui": {
        "displayName": "Mateo Retegui",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Italy",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "1999-04-29"
    },
    "quinones": {
        "displayName": "Julián Quiñones",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Mexico",
        "position": "Forward",
        "number": 33,
        "dateofbirth": "1997-03-24"
    },
    "abdulazizaliwa": {
        "displayName": "Abdulaziz Al-Aliwa",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 46,
        "dateofbirth": "2004-02-11"
    },
    "mesharisunyur": {
        "displayName": "Meshari Sunyur",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2001-01-01"
    },
    "sulemansani": {
        "displayName": "Suleman Sani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2006-09-01"
    },
    "sinisalo": {
        "displayName": "Viljami Sinisalo",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Finland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-10-11"
    },
    "alistairjohnston": {
        "displayName": "Alistair Johnston",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Canada",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-10-08"
    },
    "lotomba": {
        "displayName": "Jordan Lotomba",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Switzerland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-09-29"
    },
    "scales": {
        "displayName": "Liam Scales",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Ireland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1998-08-08"
    },
    "trusty": {
        "displayName": "Auston Trusty",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "United States",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-08-12"
    },
    "jota": {
        "displayName": "Jota",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-03-30"
    },
    "nygren": {
        "displayName": "Benjamin Nygren",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-07-08"
    },
    "kasperhogh": {
        "displayName": "Kasper Høgh",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Denmark",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-12-06"
    },
    "camiloduran": {
        "displayName": "Camilo Durán",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Colombia",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-02-10"
    },
    "landonemenalo": {
        "displayName": "Landon Emenalo",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "2008-01-18"
    },
    "yangjun": {
        "displayName": "Yang Hyun-jun",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "South Korea",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "2002-05-25"
    },
    "mccowan": {
        "displayName": "Luke McCowan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1997-12-09"
    },
    "sebastiantounekti": {
        "displayName": "Sebastian Tounekti",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Tunisia",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2002-07-13"
    },
    "oliversrensen": {
        "displayName": "Oliver Sørensen",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2002-03-10"
    },
    "callumosmand": {
        "displayName": "Callum Osmand",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Wales",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-11-08"
    },
    "cartervickers": {
        "displayName": "Cameron Carter-Vickers",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "United States",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1997-12-31"
    },
    "alexchamberlain": {
        "displayName": "Alex Oxlade-Chamberlain",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1993-08-15"
    },
    "mikabaur": {
        "displayName": "Mika Baur",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Germany",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2004-07-09"
    },
    "haissemhassan": {
        "displayName": "Haissem Hassan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Egypt",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2002-02-08"
    },
    "samjohnstone": {
        "displayName": "Sam Johnstone",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "1993-03-25"
    },
    "shimmheuka": {
        "displayName": "Shim Mheuka",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2007-10-20"
    },
    "doohan": {
        "displayName": "Ross Doohan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1998-03-29"
    },
    "joelberg": {
        "displayName": "Joël van den Berg",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2007-02-11"
    },
    "mcgregor": {
        "displayName": "Callum McGregor",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "1993-06-14"
    },
    "danemurray": {
        "displayName": "Dane Murray",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 47,
        "dateofbirth": "2003-06-26"
    },
    "forrest": {
        "displayName": "James Forrest",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "1991-07-07"
    },
    "colbydonovan": {
        "displayName": "Colby Donovan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 51,
        "dateofbirth": "2006-09-07"
    },
    "anthonyralston": {
        "displayName": "Anthony Ralston",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 56,
        "dateofbirth": "1998-11-16"
    },
    "tierney": {
        "displayName": "Kieran Tierney",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 63,
        "dateofbirth": "1997-06-05"
    },
    "ivorpandur": {
        "displayName": "Ivor Pandur",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Croatia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-03-25"
    },
    "rossmccrorie": {
        "displayName": "Ross McCrorie",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-03-18"
    },
    "bengodfrey": {
        "displayName": "Ben Godfrey",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-01-15"
    },
    "souttar": {
        "displayName": "John Souttar",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-09-25"
    },
    "danneil": {
        "displayName": "Dan Neil",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-12-13"
    },
    "lawrenceshankland": {
        "displayName": "Lawrence Shankland",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-08-10"
    },
    "chermiti": {
        "displayName": "Youssef Chermiti",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-05-24"
    },
    "cammydevlin": {
        "displayName": "Cammy Devlin",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Australia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1998-06-07"
    },
    "josecifuentes": {
        "displayName": "José Cifuentes",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Ecuador",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "1999-03-12"
    },
    "daisukeyokota": {
        "displayName": "Daisuke Yokota",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Japan",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-06-15"
    },
    "nedeljkovic": {
        "displayName": "Kosta Nedeljković",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Serbia",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2005-12-16"
    },
    "kevinkelsy": {
        "displayName": "Kevin Kelsy",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Venezuela",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-07-27"
    },
    "ryannaderi": {
        "displayName": "Ryan Naderi",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2003-07-10"
    },
    "sterling": {
        "displayName": "Dujon Sterling",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1999-10-24"
    },
    "vanjadragojevic": {
        "displayName": "Vanja Dragojević",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2006-01-11"
    },
    "gassama": {
        "displayName": "Djeidi Gassama",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Mauritania",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-09-10"
    },
    "olwethumakhanya": {
        "displayName": "Olwethu Makhanya",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "South Africa",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2004-04-30"
    },
    "tuurrommens": {
        "displayName": "Tuur Rommens",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Belgium",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2003-03-26"
    },
    "bouanani": {
        "displayName": "Badredine Bouanani",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Algeria",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2004-12-08"
    },
    "miovski": {
        "displayName": "Bojan Miovski",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "North Macedonia",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1999-06-24"
    },
    "penrice": {
        "displayName": "James Penrice",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1998-12-22"
    },
    "liamkelly": {
        "displayName": "Liam Kelly",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1996-01-23"
    },
    "fernandez": {
        "displayName": "Emmanuel Fernandez",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Nigeria",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2001-11-20"
    },
    "chukwuani": {
        "displayName": "Tochi Chukwuani",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2003-03-24"
    },
    "raskin": {
        "displayName": "Nicolas Raskin",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2001-02-23"
    },
    "rossmccausland": {
        "displayName": "Ross McCausland",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Northern Ireland",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2003-05-12"
    },
    "findlaycurtis": {
        "displayName": "Findlay Curtis",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 52,
        "dateofbirth": "2006-10-01"
    },
    "pietro_terracciano": {
        "displayName": "Pietro Terracciano",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-03-08"
    },
    "estupinan": {
        "displayName": "Pervis Estupiñán",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Ecuador",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-01-21"
    },
    "dewinter": {
        "displayName": "Koni De Winter",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-06-12"
    },
    "loftuscheek": {
        "displayName": "Ruben Loftus-Cheek",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-01-23"
    },
    "goncaloramos": {
        "displayName": "Gonçalo Ramos",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-06-20"
    },
    "pulisic": {
        "displayName": "Christian Pulisic",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "United States",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1998-09-18"
    },
    "rabiot": {
        "displayName": "Adrien Rabiot",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "1995-04-03"
    },
    "sankhoundiawara": {
        "displayName": "Sankhoun Diawara",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2006-01-13"
    },
    "modric": {
        "displayName": "Luka Modrić",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1985-09-09"
    },
    "maignan": {
        "displayName": "Mike Maignan",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1995-07-03"
    },
    "omarihutchinson": {
        "displayName": "Omari Hutchinson",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2003-10-29"
    },
    "samuelchukwueze": {
        "displayName": "Samuel Chukwueze",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1999-05-22"
    },
    "diegomoreira": {
        "displayName": "Diego Moreira",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2004-08-06"
    },
    "tomori": {
        "displayName": "Fikayo Tomori",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1997-12-19"
    },
    "christiancomotto": {
        "displayName": "Christian Comotto",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2008-04-25"
    },
    "jashari": {
        "displayName": "Ardon Jashari",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2002-07-30"
    },
    "strahinjapavlovic": {
        "displayName": "Strahinja Pavlović",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2001-05-24"
    },
    "bartesaghi": {
        "displayName": "Davide Bartesaghi",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2005-12-29"
    },
    "gila": {
        "displayName": "Mario Gila",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2000-08-29"
    },
    "valerivladimirov": {
        "displayName": "Valeri Vladimirov",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Bulgaria",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2008-06-04"
    },
    "filippoterracciano": {
        "displayName": "Filippo Terracciano",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2003-02-08"
    },
    "gabbia": {
        "displayName": "Matteo Gabbia",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 46,
        "dateofbirth": "1999-10-21"
    },
    "saelemaekers": {
        "displayName": "Alexis Saelemaekers",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 56,
        "dateofbirth": "1999-06-27"
    },
    "alphadjocisse": {
        "displayName": "Alphadjo Cisse",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 70,
        "dateofbirth": "2006-10-22"
    },
    "francescocamarda": {
        "displayName": "Francesco Camarda",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 73,
        "dateofbirth": "2008-03-10"
    },
    "musah": {
        "displayName": "Yunus Musah",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "United States",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2002-11-29"
    },
    "torriani": {
        "displayName": "Lorenzo Torriani",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2005-01-31"
    },
    "rensch": {
        "displayName": "Devyne Rensch",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-01-18"
    },
    "konstantinoskoulierakis": {
        "displayName": "Konstantinos Koulierakis",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Greece",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-11-28"
    },
    "cristante": {
        "displayName": "Bryan Cristante",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1995-03-03"
    },
    "ndicka": {
        "displayName": "Evan Ndicka",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-08-20"
    },
    "pellegrini": {
        "displayName": "Lorenzo Pellegrini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1996-06-19"
    },
    "santiagocastro": {
        "displayName": "Santiago Castro",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-09-18"
    },
    "malen": {
        "displayName": "Donyell Malen",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1999-01-19"
    },
    "deroon": {
        "displayName": "Marten de Roon",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "1991-03-29"
    },
    "kone": {
        "displayName": "Manu Koné",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2001-05-17"
    },
    "soule": {
        "displayName": "Matías Soulé",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2003-04-15"
    },
    "molina": {
        "displayName": "Nahuel Molina",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1998-04-06"
    },
    "dybala": {
        "displayName": "Paulo Dybala",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1993-11-15"
    },
    "hermoso": {
        "displayName": "Mario Hermoso",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1995-06-18"
    },
    "mancini": {
        "displayName": "Gianluca Mancini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1996-04-17"
    },
    "balerdi": {
        "displayName": "Leonardo Balerdi",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1999-01-26"
    },
    "wesley": {
        "displayName": "Wesley",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 43,
        "dateofbirth": "2003-09-06"
    },
    "pisilli": {
        "displayName": "Niccolò Pisilli",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 61,
        "dateofbirth": "2004-09-23"
    },
    "antonioarena": {
        "displayName": "Antonio Arena",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 68,
        "dateofbirth": "2009-02-10"
    },
    "giorgiomarzi": {
        "displayName": "Giorgio De Marzi",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 70,
        "dateofbirth": "2007-04-18"
    },
    "rodrigomora": {
        "displayName": "Rodrigo Mora",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 86,
        "dateofbirth": "2007-05-05"
    },
    "danieleghilardi": {
        "displayName": "Daniele Ghilardi",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 87,
        "dateofbirth": "2003-01-06"
    },
    "gollini": {
        "displayName": "Pierluigi Gollini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 95,
        "dateofbirth": "1995-03-18"
    },
    "svilar": {
        "displayName": "Mile Svilar",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-08-27"
    },
    "kossounou": {
        "displayName": "Odilon Kossounou",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-01-04"
    },
    "hien": {
        "displayName": "Isak Hien",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Sweden",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-01-13"
    },
    "sulemana": {
        "displayName": "Kamaldeen Sulemana",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Ghana",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-02-15"
    },
    "pasalic": {
        "displayName": "Mario Pašalić",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-02-09"
    },
    "scamacca": {
        "displayName": "Gianluca Scamacca",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-01-01"
    },
    "samardzic": {
        "displayName": "Lazar Samardžić",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-02-24"
    },
    "jonathanrowe": {
        "displayName": "Jonathan Rowe",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-04-30"
    },
    "ederson": {
        "displayName": "Éderson",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1999-07-07"
    },
    "bellanova": {
        "displayName": "Raoul Bellanova",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2000-05-17"
    },
    "deketelaere": {
        "displayName": "Charles De Ketelaere",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2001-03-10"
    },
    "raspadori": {
        "displayName": "Giacomo Raspadori",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2000-02-18"
    },
    "franckkessie": {
        "displayName": "Franck Kessié",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1996-12-19"
    },
    "kolasinac": {
        "displayName": "Sead Kolašinac",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1993-06-20"
    },
    "carnesecchi": {
        "displayName": "Marco Carnesecchi",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "2000-07-01"
    },
    "thomaskristensen": {
        "displayName": "Thomas Kristensen",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2002-01-17"
    },
    "reljaobric": {
        "displayName": "Relja Obrić",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Defender",
        "number": 40,
        "dateofbirth": "2006-04-11"
    },
    "scalvini": {
        "displayName": "Giorgio Scalvini",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2003-12-11"
    },
    "lorenzobernasconi": {
        "displayName": "Lorenzo Bernasconi",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 47,
        "dateofbirth": "2003-11-16"
    },
    "sportiello": {
        "displayName": "Marco Sportiello",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 57,
        "dateofbirth": "1992-05-10"
    },
    "zalewski": {
        "displayName": "Nicola Zalewski",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Poland",
        "position": "Midfielder",
        "number": 59,
        "dateofbirth": "2002-01-23"
    },
    "gianlucagaetano": {
        "displayName": "Gianluca Gaetano",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 70,
        "dateofbirth": "2000-05-05"
    },
    "zappacosta": {
        "displayName": "Davide Zappacosta",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1992-06-11"
    },
    "krstovic": {
        "displayName": "Nikola Krstović",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Montenegro",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2000-04-05"
    },
    "elmas": {
        "displayName": "Eljif Elmas",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "North Macedonia",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "1999-09-24"
    },
    "dodo": {
        "displayName": "Dodô",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-11-17"
    },
    "dragusin": {
        "displayName": "Radu Drăgușin",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Romania",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-02-03"
    },
    "brescianini": {
        "displayName": "Marco Brescianini",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2000-01-20"
    },
    "pongracic": {
        "displayName": "Marin Pongračić",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-09-11"
    },
    "ranieri": {
        "displayName": "Luca Ranieri",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1999-04-23"
    },
    "arthuratta": {
        "displayName": "Arthur Atta",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2003-01-14"
    },
    "joaomario2": {
        "displayName": "João Mário (Fiorentina)",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-01-03"
    },
    "lezzerini": {
        "displayName": "Luca Lezzerini",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 19,
        "dateofbirth": "1995-03-24"
    },
    "alexjimenez": {
        "displayName": "Álex Jiménez",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2005-05-08"
    },
    "victorvaldepenas": {
        "displayName": "Víctor Valdepeñas",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2006-10-20"
    },
    "beto": {
        "displayName": "Beto",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Guinea-Bissau",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1998-01-31"
    },
    "alieunjie": {
        "displayName": "Alieu Njie",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Sweden",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2005-05-14"
    },
    "ndour": {
        "displayName": "Cher Ndour",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2004-07-27"
    },
    "pedrogoncalves": {
        "displayName": "Pedro Gonçalves",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1998-06-28"
    },
    "wilfriedgnonto": {
        "displayName": "Wilfried Gnonto",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2003-11-05"
    },
    "mastantuono": {
        "displayName": "Franco Mastantuono",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2007-08-14"
    },
    "mateopellegrino": {
        "displayName": "Mateo Pellegrino",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2001-10-22"
    },
    "viery": {
        "displayName": "Viery",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2005-01-02"
    },
    "oulai": {
        "displayName": "Christ Inao Oulaï",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2006-06-22"
    },
    "degea": {
        "displayName": "David de Gea",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 43,
        "dateofbirth": "1990-11-07"
    },
    "fagioli": {
        "displayName": "Nicolò Fagioli",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2001-02-12"
    },
    "oliverchristensen": {
        "displayName": "Oliver Christensen",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 53,
        "dateofbirth": "1999-03-22"
    },
    "parisi": {
        "displayName": "Fabiano Parisi",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 65,
        "dateofbirth": "2000-11-09"
    },
    "josepmartinez": {
        "displayName": "Josep Martínez",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-05-27"
    },
    "aleksstankovic": {
        "displayName": "Aleksandar Stanković",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2005-08-03"
    },
    "stones": {
        "displayName": "John Stones",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1994-05-28"
    },
    "zielinski": {
        "displayName": "Piotr Zieliński",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Poland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-05-20"
    },
    "petarsucic": {
        "displayName": "Petar Sučić",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-10-25"
    },
    "mthuram": {
        "displayName": "Marcus Thuram",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-08-06"
    },
    "lautaro": {
        "displayName": "Lautaro Martínez",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-08-22"
    },
    "luis_henrique": {
        "displayName": "Luis Henrique",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2001-12-14"
    },
    "digennaro": {
        "displayName": "Raffaele Di Gennaro",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1993-10-03"
    },
    "bonny": {
        "displayName": "Ange-Yoan Bonny",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-10-25"
    },
    "andy_diouf": {
        "displayName": "Andy Diouf",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-05-17"
    },
    "calhanoglu": {
        "displayName": "Hakan Çalhanoğlu",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-02-08"
    },
    "curtisjones": {
        "displayName": "Curtis Jones",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2001-01-30"
    },
    "mkhitaryan": {
        "displayName": "Henrikh Mkhitaryan",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Armenia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1989-01-21"
    },
    "barella": {
        "displayName": "Nicolò Barella",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1997-02-07"
    },
    "akanji": {
        "displayName": "Manuel Akanji",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1995-07-19"
    },
    "pavard": {
        "displayName": "Benjamin Pavard",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "1996-03-28"
    },
    "carlosaugusto": {
        "displayName": "Carlos Augusto",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1999-01-07"
    },
    "bisseck": {
        "displayName": "Yann Bisseck",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Germany",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2000-11-29"
    },
    "dimarco": {
        "displayName": "Federico Dimarco",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1997-11-10"
    },
    "provedel": {
        "displayName": "Ivan Provedel",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 49,
        "dateofbirth": "1994-03-17"
    },
    "francescoesposito": {
        "displayName": "Francesco Pio Esposito",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 94,
        "dateofbirth": "2005-06-28"
    },
    "bastoni": {
        "displayName": "Alessandro Bastoni",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 95,
        "dateofbirth": "1999-04-13"
    },
    "spence": {
        "displayName": "Djed Spence",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 99,
        "dateofbirth": "2000-08-09"
    },
    "kamilgrabara": {
        "displayName": "Kamil Grabara",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-01-08"
    },
    "zekicelik": {
        "displayName": "Zeki Çelik",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-02-17"
    },
    "bremer": {
        "displayName": "Bremer",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-03-18"
    },
    "gatti": {
        "displayName": "Federico Gatti",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-06-24"
    },
    "locatelli": {
        "displayName": "Manuel Locatelli",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1998-01-08"
    },
    "lloydkelly": {
        "displayName": "Lloyd Kelly",
        "club": "Juventus",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-10-06"
    },
    "conceicao": {
        "displayName": "Francisco Conceição",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-12-14"
    },
    "koopmeiners": {
        "displayName": "Teun Koopmeiners",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-02-28"
    },
    "kolomuani": {
        "displayName": "Randal Kolo Muani",
        "club": "Juventus",
        "league": "Serie A",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-12-05"
    },
    "yildiz": {
        "displayName": "Kenan Yıldız",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2005-05-04"
    },
    "zhegrova": {
        "displayName": "Edon Zhegrova",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Kosovo",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1999-03-31"
    },
    "douglasluiz": {
        "displayName": "Douglas Luiz",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "1998-05-09"
    },
    "jeremieboga": {
        "displayName": "Jérémie Boga",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1997-01-03"
    },
    "milik": {
        "displayName": "Arkadiusz Milik",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Poland",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1994-02-28"
    },
    "kalulu": {
        "displayName": "Pierre Kalulu",
        "club": "Juventus",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2000-06-05"
    },
    "alajbegovic": {
        "displayName": "Kerim Alajbegović",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2007-09-21"
    },
    "jeffekhator": {
        "displayName": "Jeff Ekhator",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2006-11-11"
    },
    "thuram": {
        "displayName": "Khéphren Thuram",
        "club": "Juventus",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2001-03-26"
    },
    "cambiaso": {
        "displayName": "Andrea Cambiaso",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2000-02-20"
    },
    "mckennie": {
        "displayName": "Weston McKennie",
        "club": "Juventus",
        "league": "Serie A",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1998-08-28"
    },
    "pinsoglio": {
        "displayName": "Carlo Pinsoglio",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1990-03-16"
    },
    "danielerugani": {
        "displayName": "Daniele Rugani",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-07-29"
    },
    "vicario": {
        "displayName": "Guglielmo Vicario",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1996-10-07"
    },
    "jhonlucumi": {
        "displayName": "Jhon Lucumí",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Colombia",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1998-06-26"
    },
    "woltemade": {
        "displayName": "Nick Woltemade",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Germany",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-02-14"
    },
    "papesarr": {
        "displayName": "Pape Matar Sarr",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2002-09-14"
    },
    "nicogonzalez2": {
        "displayName": "Nico González (Juve)",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "1998-04-06"
    },
    "cabal": {
        "displayName": "Juan Cabal",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Colombia",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2001-01-08"
    },
    "neto": {
        "displayName": "Neto",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1989-07-19"
    },
    "augustoowusu": {
        "displayName": "Augusto Owusu",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "2005-01-28"
    },
    "diogoleite": {
        "displayName": "Diogo Leite",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-01-23"
    },
    "lucapellegrini": {
        "displayName": "Luca Pellegrini",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-03-07"
    },
    "danilhodoekhi": {
        "displayName": "Danilho Doekhi",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1998-06-30"
    },
    "rovella": {
        "displayName": "Nicolò Rovella",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-12-04"
    },
    "delebashiru": {
        "displayName": "Fisayo Dele-Bashiru",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-02-06"
    },
    "brunogalassi": {
        "displayName": "Bruno Galassi",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2007-02-07"
    },
    "andreapinamonti": {
        "displayName": "Andrea Pinamonti",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-05-19"
    },
    "zaccagni": {
        "displayName": "Mattia Zaccagni",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1995-06-16"
    },
    "isaksen": {
        "displayName": "Gustav Isaksen",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-04-19"
    },
    "noslin": {
        "displayName": "Tijjani Noslin",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1999-07-07"
    },
    "romanomussolini": {
        "displayName": "Romano Floriani Mussolini",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2003-01-27"
    },
    "frattesi": {
        "displayName": "Davide Frattesi",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1999-09-22"
    },
    "nunotavares": {
        "displayName": "Nuno Tavares",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-01-26"
    },
    "belahyane": {
        "displayName": "Reda Belahyane",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-06-01"
    },
    "cancellieri": {
        "displayName": "Matteo Cancellieri",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-02-12"
    },
    "pedraza": {
        "displayName": "Alfonso Pedraza",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1996-04-09"
    },
    "taylor": {
        "displayName": "Kenneth Taylor",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2002-05-16"
    },
    "provstgaard": {
        "displayName": "Oliver Provstgaard",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2003-06-04"
    },
    "adrianprzyborek": {
        "displayName": "Adrian Przyborek",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Poland",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2007-01-01"
    },
    "lazzari": {
        "displayName": "Manuel Lazzari",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "1993-11-29"
    },
    "cataldi": {
        "displayName": "Danilo Cataldi",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "1994-08-06"
    },
    "mandas": {
        "displayName": "Christos Mandas",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 35,
        "dateofbirth": "2001-09-17"
    },
    "sutalo": {
        "displayName": "Josip Šutalo",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2000-02-28"
    },
    "edoardomotta": {
        "displayName": "Edoardo Motta",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2005-01-13"
    },
    "furlanetto": {
        "displayName": "Alessio Furlanetto",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 55,
        "dateofbirth": "2002-02-07"
    },
    "filipebordon": {
        "displayName": "Filipe Bordon",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 76,
        "dateofbirth": "2005-06-24"
    },
    "marusic": {
        "displayName": "Adam Marušić",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Montenegro",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1992-10-17"
    },
    "gudmundsson": {
        "displayName": "Albert Guðmundsson",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Iceland",
        "position": "Forward",
        "number": 80,
        "dateofbirth": "1997-06-15"
    },
    "meret": {
        "displayName": "Alex Meret",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-03-22"
    },
    "costantinofavasuli": {
        "displayName": "Costantino Favasuli",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2004-04-26"
    },
    "buongiorno": {
        "displayName": "Alessandro Buongiorno",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-06-06"
    },
    "badiashile": {
        "displayName": "Benoît Badiashile",
        "club": "Napoli",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2001-03-26"
    },
    "gilmour": {
        "displayName": "Billy Gilmour",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-06-11"
    },
    "neres": {
        "displayName": "David Neres",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1997-03-03"
    },
    "mctominay": {
        "displayName": "Scott McTominay",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-12-08"
    },
    "debruyne": {
        "displayName": "Kevin De Bruyne",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1991-06-28"
    },
    "rrahmani": {
        "displayName": "Amir Rrahmani",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Kosovo",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1994-02-24"
    },
    "contini": {
        "displayName": "Nikita Contini",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 14,
        "dateofbirth": "1996-05-21"
    },
    "rafamarin": {
        "displayName": "Rafa Marín",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2002-05-19"
    },
    "olivera": {
        "displayName": "Mathías Olivera",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Uruguay",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-10-31"
    },
    "rasmushojlund": {
        "displayName": "Rasmus Højlund",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2003-02-04"
    },
    "lucca": {
        "displayName": "Lorenzo Lucca",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-09-10"
    },
    "politano": {
        "displayName": "Matteo Politano",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1993-08-03"
    },
    "dilorenzo": {
        "displayName": "Giovanni Di Lorenzo",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-08-04"
    },
    "giovane": {
        "displayName": "Giovane",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-11-24"
    },
    "antoniovergara": {
        "displayName": "Antonio Vergara",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2003-01-16"
    },
    "alissonsantos": {
        "displayName": "Alisson Santos",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-05-12"
    },
    "beukema": {
        "displayName": "Sam Beukema",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "1998-11-17"
    },
    "milinkovic_savic": {
        "displayName": "Vanja Milinković-Savić",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "1997-02-20"
    },
    "lucamarianucci": {
        "displayName": "Luca Marianucci",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2004-07-23"
    },
    "spinazzola": {
        "displayName": "Leonardo Spinazzola",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1993-03-25"
    },
    "lobotka": {
        "displayName": "Stanislav Lobotka",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Slovakia",
        "position": "Midfielder",
        "number": 68,
        "dateofbirth": "1994-11-25"
    },
    "noa_lang": {
        "displayName": "Noa Lang",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "1999-06-17"
    },
    "frankanguissa": {
        "displayName": "Frank Anguissa",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Cameroon",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "1995-11-16"
    },
    "strakosha": {
        "displayName": "Thomas Strakosha",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Albania",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-19"
    },
    "bruma": {
        "displayName": "Bruma",
        "club": "Aris Thessaloniki",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Attacker",
        "number": 77,
        "dateofbirth": "1994-10-24"
    },
    "moukoudi": {
        "displayName": "Harold Moukoudi",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Cameroon",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-11-27"
    },
    "pilios": {
        "displayName": "Stavros Pilios",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Albania",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-12-10"
    },
    "christosalexiou": {
        "displayName": "Christos Alexiou",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2005-06-30"
    },
    "kaan_kairinen": {
        "displayName": "Kaan Kairinen",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Finland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-12-22"
    },
    "kutesa": {
        "displayName": "Dereck Kutesa",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1997-12-06"
    },
    "mijatgacinovic": {
        "displayName": "Mijat Gaćinović",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-02-08"
    },
    "jovic": {
        "displayName": "Luka Jović",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-12-23"
    },
    "zubkov": {
        "displayName": "Oleksandr Zubkov",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-08-03"
    },
    "koita": {
        "displayName": "Aboubakary Koïta",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Mauritania",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-09-20"
    },
    "rota": {
        "displayName": "Lazaros Rota",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-08-23"
    },
    "lovromajer": {
        "displayName": "Lovro Majer",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1998-01-17"
    },
    "martingeorgiev": {
        "displayName": "Martin Georgiev",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Bulgaria",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2005-09-24"
    },
    "kervinarriaga": {
        "displayName": "Kervin Arriaga",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Honduras",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1998-01-05"
    },
    "dimitriskaloskamis": {
        "displayName": "Dimitris Kaloskamis",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-03-01"
    },
    "razvanmarin": {
        "displayName": "Răzvan Marin",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Romania",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1996-05-23"
    },
    "barnabasvarga": {
        "displayName": "Barnabás Varga",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Hungary",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1994-10-25"
    },
    "mantalos": {
        "displayName": "Petros Mantalos",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1991-08-31"
    },
    "vida": {
        "displayName": "Domagoj Vida",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1989-04-29"
    },
    "charalamposlykogiannis": {
        "displayName": "Charalampos Lykogiannis",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-10-22"
    },
    "joaomario": {
        "displayName": "João Mário",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1993-01-19"
    },
    "milanvitalis": {
        "displayName": "Milán Vitális",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Hungary",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2002-01-28"
    },
    "filiperelvas": {
        "displayName": "Filipe Relvas",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "1999-09-20"
    },
    "hakimsahabo": {
        "displayName": "Hakim Sahabo",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Rwanda",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2005-06-16"
    },
    "zini": {
        "displayName": "Zini",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Angola",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2002-07-03"
    },
    "brignoli": {
        "displayName": "Alberto Brignoli",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 91,
        "dateofbirth": "1991-08-19"
    },
    "stefanortega": {
        "displayName": "Stefan Ortega",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-11-06"
    },
    "manolissaliakas": {
        "displayName": "Manolis Saliakas",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-09-12"
    },
    "zinedinsmajlovic": {
        "displayName": "Zinedin Smajlović",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-12-20"
    },
    "pirola": {
        "displayName": "Lorenzo Pirola",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-02-20"
    },
    "davidcarmo": {
        "displayName": "David Carmo",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Angola",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1999-07-19"
    },
    "kostasfortounis": {
        "displayName": "Kostas Fortounis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1992-10-16"
    },
    "gustavosa": {
        "displayName": "Gustavo Sá",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-11-11"
    },
    "elkaabi": {
        "displayName": "Ayoub El Kaabi",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-06-25"
    },
    "gelonmartins": {
        "displayName": "Gelson Martins",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1995-05-11"
    },
    "yaremchuk": {
        "displayName": "Roman Yaremchuk",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Ukraine",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1995-11-27"
    },
    "gustavopuerta": {
        "displayName": "Gustavo Puerta",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2003-07-23"
    },
    "scipioni": {
        "displayName": "Lorenzo Scipioni",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-11-24"
    },
    "bailey": {
        "displayName": "Leon Bailey",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Jamaica",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1997-08-09"
    },
    "remofreuler": {
        "displayName": "Remo Freuler",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1992-04-15"
    },
    "iotasilva": {
        "displayName": "Jota Silva",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1999-08-01"
    },
    "theofanisbakoulas": {
        "displayName": "Theofanis Bakoulas",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2005-01-04"
    },
    "chiquinho": {
        "displayName": "Chiquinho",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1995-07-19"
    },
    "marcuspedersen": {
        "displayName": "Marcus Pedersen",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Norway",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2000-07-16"
    },
    "balsapopovic": {
        "displayName": "Balša Popović",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Montenegro",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2000-06-10"
    },
    "hezze": {
        "displayName": "Santiago Hezze",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2001-10-22"
    },
    "armandogonzalez": {
        "displayName": "Armando González",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Mexico",
        "position": "Forward",
        "number": 34,
        "dateofbirth": "2003-04-20"
    },
    "retsos": {
        "displayName": "Panagiotis Retsos",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "1998-08-09"
    },
    "onyemaechi": {
        "displayName": "Bruno Onyemaechi",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Nigeria",
        "position": "Defender",
        "number": 70,
        "dateofbirth": "1999-04-03"
    },
    "nairtiknizyan": {
        "displayName": "Nair Tiknizyan",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Armenia",
        "position": "Defender",
        "number": 71,
        "dateofbirth": "1999-05-12"
    },
    "joelroca": {
        "displayName": "Joel Roca",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Midfielder",
        "number": 73,
        "dateofbirth": "2005-07-07"
    },
    "clayton": {
        "displayName": "Clayton",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "1999-01-11"
    },
    "dimitriosstournaras": {
        "displayName": "Dimitrios Stournaras",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 91,
        "dateofbirth": "2001-05-30"
    },
    "yusufyazc": {
        "displayName": "Yusuf Yazıcı",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 97,
        "dateofbirth": "1997-01-29"
    },
    "mariusmouandilmadji": {
        "displayName": "Marius Mouandilmadji",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Chad",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1998-01-22"
    },
    "pavlenka": {
        "displayName": "Jiří Pavlenka",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-14"
    },
    "madycamara": {
        "displayName": "Mady Camara",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Guinea",
        "position": "Midfielder",
        "number": 2,
        "dateofbirth": "1997-02-28"
    },
    "jonjoekenny": {
        "displayName": "Jonjoe Kenny",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-03-15"
    },
    "pantelischatzidiakos": {
        "displayName": "Pantelis Chatzidiakos",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-01-18"
    },
    "michailidis": {
        "displayName": "Giannis Michailidis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-02-18"
    },
    "elustondo": {
        "displayName": "Aritz Elustondo",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1994-03-28"
    },
    "baptistesantamaria": {
        "displayName": "Baptiste Santamaria",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1995-03-09"
    },
    "meite": {
        "displayName": "Soualiho Meïté",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-03-17"
    },
    "fyodorchalov": {
        "displayName": "Fyodor Chalov",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Russia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-04-10"
    },
    "pelkas": {
        "displayName": "Dimitrios Pelkas",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1993-10-26"
    },
    "taison": {
        "displayName": "Taison",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1988-01-13"
    },
    "dimitrisgiannoulis": {
        "displayName": "Dimitris Giannoulis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1995-10-17"
    },
    "zivkovic": {
        "displayName": "Andrija Živković",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1996-07-11"
    },
    "ognjenugresic": {
        "displayName": "Ognjen Ugrešić",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2006-07-15"
    },
    "kristijanjakic": {
        "displayName": "Kristijan Jakić",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-05-14"
    },
    "diegocosta": {
        "displayName": "Diego Costa",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1999-07-21"
    },
    "zafeiris": {
        "displayName": "Christos Zafeiris",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2003-02-23"
    },
    "baba": {
        "displayName": "Abdul Rahman Baba",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Ghana",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1994-07-02"
    },
    "ali": {
        "displayName": "Taha Ali",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1998-07-01"
    },
    "tomlouchet": {
        "displayName": "Tom Louchet",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2003-05-04"
    },
    "simonbanza": {
        "displayName": "Simon Banza",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "DR Congo",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "1996-08-13"
    },
    "cherifndiaye": {
        "displayName": "Cherif Ndiaye",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Senegal",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "1996-01-23"
    },
    "gregtaylor": {
        "displayName": "Greg Taylor",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Scotland",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1997-11-05"
    },
    "monastirlis": {
        "displayName": "Dimitrios Monastirlis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2004-03-22"
    },
    "sholashoretire": {
        "displayName": "Shola Shoretire",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "England",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2004-02-02"
    },
    "dimitrischatsidis": {
        "displayName": "Dimitris Chatsidis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 52,
        "dateofbirth": "2006-06-14"
    },
    "konstantinosbalomenos": {
        "displayName": "Konstantinos Balomenos",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 54,
        "dateofbirth": "2002-03-11"
    },
    "anestismythou": {
        "displayName": "Anestis Mythou",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Forward",
        "number": 56,
        "dateofbirth": "2007-05-22"
    },
    "despodov": {
        "displayName": "Kiril Despodov",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Bulgaria",
        "position": "Midfielder",
        "number": 77,
        "dateofbirth": "1996-11-11"
    },
    "tsiftsis": {
        "displayName": "Antonis Tsiftsis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-07-21"
    },
    "inakipena": {
        "displayName": "Iñaki Peña",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-03-02"
    },
    "calabria": {
        "displayName": "Davide Calabria",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-12-06"
    },
    "giorgoskatris": {
        "displayName": "Giorgos Katris",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-10-14"
    },
    "chirivella": {
        "displayName": "Pedro Chirivella",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1997-05-23"
    },
    "salah_eddine": {
        "displayName": "Anass Salah-Eddine",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-01-18"
    },
    "devrij": {
        "displayName": "Stefan de Vrij",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1992-02-05"
    },
    "andrewstetteh": {
        "displayName": "Andrews Tetteh",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-05-25"
    },
    "adrianojagusic": {
        "displayName": "Adriano Jagušić",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2005-09-06"
    },
    "dessers": {
        "displayName": "Cyriel Dessers",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Nigeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1994-12-08"
    },
    "santinoandino": {
        "displayName": "Santino Andino",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2005-10-25"
    },
    "lucaschaves": {
        "displayName": "Lucas Chaves",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1995-08-09"
    },
    "erikbrown": {
        "displayName": "Erik Palmer-Brown",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "United States",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1997-04-24"
    },
    "ingason": {
        "displayName": "Sverrir Ingi Ingason",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Iceland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1993-08-05"
    },
    "pavlospantelidis": {
        "displayName": "Pavlos Pantelidis",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2002-09-16"
    },
    "sotiriskontouris": {
        "displayName": "Sotiris Kontouris",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2005-02-24"
    },
    "triantafyllostsapras": {
        "displayName": "Triantafyllos Tsapras",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2001-10-22"
    },
    "taborda": {
        "displayName": "Vicente Taborda",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2001-06-14"
    },
    "azzedineounahi": {
        "displayName": "Azzedine Ounahi",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2000-04-19"
    },
    "etiennecamara": {
        "displayName": "Etienne Camara",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2003-03-30"
    },
    "imranlouza": {
        "displayName": "Imrân Louza",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1999-05-01"
    },
    "pellistri": {
        "displayName": "Facundo Pellistri",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2001-12-20"
    },
    "victorkristiansen": {
        "displayName": "Victor Kristiansen",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Denmark",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2002-12-16"
    },
    "giannisbokos": {
        "displayName": "Giannis Bokos",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2007-02-03"
    },
    "kingskangwa": {
        "displayName": "Kings Kangwa",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Zambia",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "1999-04-06"
    },
    "rickdrongelen": {
        "displayName": "Rick van Drongelen",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Netherlands",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "1998-12-20"
    },
    "kotsaris": {
        "displayName": "Konstantinos Kotsaris",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 70,
        "dateofbirth": "1996-07-25"
    },
    "elminrastoder": {
        "displayName": "Elmin Rastoder",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "North Macedonia",
        "position": "Forward",
        "number": 74,
        "dateofbirth": "2001-10-07"
    },
    "giorgoskyriakopoulos": {
        "displayName": "Giorgos Kyriakopoulos",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1996-02-05"
    },
    "levigarcia": {
        "displayName": "Levi García",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Trinidad and Tobago",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1997-11-20"
    },
    "marvin_keller": {
        "displayName": "Marvin Keller",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-07-03"
    },
    "ryan_andrews": {
        "displayName": "Ryan Andrews",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2004-08-26"
    },
    "moritzjenz": {
        "displayName": "Moritz Jenz",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-04-30"
    },
    "gregory_wuthrich": {
        "displayName": "Gregory Wüthrich",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-12-04"
    },
    "edimilson_fernandes": {
        "displayName": "Edimilson Fernandes",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-04-15"
    },
    "alan_virginius": {
        "displayName": "Alan Virginius",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-01-03"
    },
    "armin_gigovic": {
        "displayName": "Armin Gigović",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-04-06"
    },
    "kalysene": {
        "displayName": "Kaly Sène",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Senegal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-05-28"
    },
    "alvyn_sanches": {
        "displayName": "Alvyn Sanches",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-02-12"
    },
    "herbaguirassy": {
        "displayName": "Herba Guirassy",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "2006-08-29"
    },
    "dominik_pech": {
        "displayName": "Dominik Pech",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "2006-09-04"
    },
    "cedriczesiger": {
        "displayName": "Cédric Zesiger",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1998-06-24"
    },
    "christian_fassnacht": {
        "displayName": "Christian Fassnacht",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1993-11-11"
    },
    "saidy_janko": {
        "displayName": "Saidy Janko",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Gambia",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1995-10-22"
    },
    "joelmall": {
        "displayName": "Joël Mall",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Cyprus",
        "position": "Goalkeeper",
        "number": 18,
        "dateofbirth": "1991-04-05"
    },
    "isaacschmidt": {
        "displayName": "Isaac Schmidt",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1999-12-07"
    },
    "loris_benito": {
        "displayName": "Loris Benito",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1992-01-07"
    },
    "lewinblum": {
        "displayName": "Lewin Blum",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-07-27"
    },
    "sandro_lauper": {
        "displayName": "Sandro Lauper",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "1996-10-25"
    },
    "facinet_conte": {
        "displayName": "Facinet Conte",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Guinea",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2005-03-24"
    },
    "stefanbukinac": {
        "displayName": "Stefan Bukinac",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Serbia",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2005-07-08"
    },
    "dario_marzino": {
        "displayName": "Dario Marzino",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1996-09-19"
    },
    "samuelessende": {
        "displayName": "Samuel Essende",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "DR Congo",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1998-01-23"
    },
    "jonasomlin": {
        "displayName": "Jonas Omlin",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-01-10"
    },
    "vouilloz": {
        "displayName": "Nicolas Vouilloz",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-05-11"
    },
    "beciromeragic": {
        "displayName": "Bećir Omeragić",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-01-20"
    },
    "metinho": {
        "displayName": "Metinho",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2003-04-23"
    },
    "tsunemoto": {
        "displayName": "Keigo Tsunemoto",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Japan",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-10-21"
    },
    "otele": {
        "displayName": "Philip Otele",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-04-15"
    },
    "ludwigthorell": {
        "displayName": "Ludwig Małachowski Thorell",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2005-02-25"
    },
    "zancelar": {
        "displayName": "Žan Celar",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Slovenia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-03-14"
    },
    "shaqiri": {
        "displayName": "Xherdan Shaqiri",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-10-10"
    },
    "olaigbe": {
        "displayName": "Kazeem Olaigbe",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-01-02"
    },
    "salvi": {
        "displayName": "Mirko Salvi",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-02-14"
    },
    "bacanin": {
        "displayName": "Andrej Bačanin",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2007-06-13"
    },
    "aaronmalouda": {
        "displayName": "Aaron Malouda",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2005-11-30"
    },
    "asanesow": {
        "displayName": "Asane Sow",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Italy",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2006-05-02"
    },
    "clementmichelin": {
        "displayName": "Clément Michelin",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1997-05-11"
    },
    "daniliuc": {
        "displayName": "Flavius Daniliuc",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Austria",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-04-27"
    },
    "gabrielsigua": {
        "displayName": "Gabriel Sigua",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2005-06-30"
    },
    "ruegg": {
        "displayName": "Kevin Rüegg",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1998-08-05"
    },
    "moussacisse": {
        "displayName": "Moussa Cissé",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2003-04-29"
    },
    "giacomokoloto": {
        "displayName": "Giacomo Koloto",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2008-01-31"
    },
    "jonasharder": {
        "displayName": "Jonas Harder",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Italy",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2005-09-30"
    },
    "akpevictory": {
        "displayName": "Akpe Victory",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Nigeria",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "2006-07-19"
    },
    "silas_huber": {
        "displayName": "Silas Huber",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2005-07-10"
    },
    "lindrit_kamberi": {
        "displayName": "Lindrit Kamberi",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-10-07"
    },
    "selminhodza": {
        "displayName": "Selmin Hodža",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-05-24"
    },
    "jorge_segura": {
        "displayName": "Jorge Segura",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Colombia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-01-18"
    },
    "bledian_krasniqi": {
        "displayName": "Bledian Krasniqi",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Kosovo",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-06-17"
    },
    "livano_comenencia": {
        "displayName": "Livano Comenencia",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Curaçao",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "2004-02-03"
    },
    "umeh_emmanuel": {
        "displayName": "Umeh Emmanuel",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-08-31"
    },
    "heinz_lindner": {
        "displayName": "Heinz Lindner",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1990-07-17"
    },
    "kevinspadanuda": {
        "displayName": "Kevin Spadanuda",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1997-01-16"
    },
    "philippe_keny": {
        "displayName": "Philippe Kény",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-05-18"
    },
    "chriskablan": {
        "displayName": "Chris Kablan",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1994-11-30"
    },
    "valonberisha": {
        "displayName": "Valon Berisha",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Kosovo",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1993-02-07"
    },
    "ilan_sauter": {
        "displayName": "Ilan Sauter",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-02-06"
    },
    "damienus_reverson": {
        "displayName": "Damienus Reverson",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Ghana",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2003-10-18"
    },
    "miguel_reichmuth": {
        "displayName": "Miguel Reichmuth",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2003-10-26"
    },
    "alexanderhack": {
        "displayName": "Alexander Hack",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Germany",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "1993-09-08"
    },
    "nubel": {
        "displayName": "Alexander Nübel",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-09-30"
    },
    "ndidi": {
        "displayName": "Wilfred Ndidi",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-12-16"
    },
    "salihozcan": {
        "displayName": "Salih Özcan",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-01-11"
    },
    "rashica": {
        "displayName": "Milot Rashica",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Kosovo",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1996-06-28"
    },
    "kartalylmaz": {
        "displayName": "Kartal Yılmaz",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-11-04"
    },
    "ohgyu": {
        "displayName": "Oh Hyeon-gyu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "South Korea",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-04-12"
    },
    "orkunkokcu": {
        "displayName": "Orkun Kökçü",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-12-29"
    },
    "ouattara": {
        "displayName": "Kassoum Ouattara",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 11,
        "dateofbirth": "2004-10-14"
    },
    "emmanuelagbadou": {
        "displayName": "Emmanuel Agbadou",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-06-17"
    },
    "juniorolaitan": {
        "displayName": "Junior Olaitan",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Benin",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2002-05-09"
    },
    "poku": {
        "displayName": "Ernest Poku",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Netherlands",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2004-01-28"
    },
    "vaclavcerny": {
        "displayName": "Václav Černý",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-10-17"
    },
    "trossard": {
        "displayName": "Leandro Trossard",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1994-12-04"
    },
    "miretti": {
        "displayName": "Fabio Miretti",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Italy",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-08-03"
    },
    "taylanbulut": {
        "displayName": "Taylan Bulut",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-01-19"
    },
    "mustafahekimoglu": {
        "displayName": "Mustafa Hekimoğlu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2007-04-22"
    },
    "vlahovic": {
        "displayName": "Dušan Vlahović",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Serbia",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2000-01-28"
    },
    "ilhanfakl": {
        "displayName": "İlhan Fakılı",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2006-01-20"
    },
    "ridvanyilmaz": {
        "displayName": "Rıdvan Yılmaz",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2001-05-21"
    },
    "tiagodjalo": {
        "displayName": "Tiago Djaló",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2000-04-09"
    },
    "umitakdag": {
        "displayName": "Ümit Akdağ",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Romania",
        "position": "Defender",
        "number": 50,
        "dateofbirth": "2003-10-06"
    },
    "emirhantopcu": {
        "displayName": "Emirhan Topçu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 53,
        "dateofbirth": "2000-10-11"
    },
    "yasinozcan": {
        "displayName": "Yasin Özcan",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 58,
        "dateofbirth": "2006-04-20"
    },
    "murillo": {
        "displayName": "Amir Murillo",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Panama",
        "position": "Defender",
        "number": 62,
        "dateofbirth": "1996-02-11"
    },
    "cankeles": {
        "displayName": "Can Keleş",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Austria",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2001-09-02"
    },
    "doganalemdar": {
        "displayName": "Doğan Alemdar",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 80,
        "dateofbirth": "2002-10-29"
    },
    "semihklcsoy": {
        "displayName": "Semih Kılıçsoy",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2005-08-15"
    },
    "emiryasar": {
        "displayName": "Emir Yaşar",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2006-01-16"
    },
    "archiebrown": {
        "displayName": "Archie Brown",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-05-28"
    },
    "yuksek": {
        "displayName": "İsmail Yüksek",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1999-01-26"
    },
    "guendouzi": {
        "displayName": "Mattéo Guendouzi",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1999-04-14"
    },
    "akturkoglu": {
        "displayName": "Kerem Aktürkoğlu",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1998-10-21"
    },
    "yandas": {
        "displayName": "Mert Hakan Yandaş",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-08-19"
    },
    "lukaku": {
        "displayName": "Romelu Lukaku",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Belgium",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-05-13"
    },
    "asensio": {
        "displayName": "Marco Asensio",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-01-21"
    },
    "greenwood": {
        "displayName": "Mason Greenwood",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-10-01"
    },
    "tarikcetin": {
        "displayName": "Tarık Çetin",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1997-01-08"
    },
    "yigitdemir": {
        "displayName": "Yiğit Demir",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2004-08-02"
    },
    "ake": {
        "displayName": "Nathan Aké",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Netherlands",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1995-02-18"
    },
    "irfankahveci": {
        "displayName": "İrfan Kahveci",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1995-07-15"
    },
    "muldur": {
        "displayName": "Mert Müldür",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1999-04-03"
    },
    "vedatmuriqi": {
        "displayName": "Vedat Muriqi",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Kosovo",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1994-04-24"
    },
    "kojooppong": {
        "displayName": "Kojo Peprah Oppong",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Ghana",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2004-06-04"
    },
    "leventmercan": {
        "displayName": "Levent Mercan",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2000-12-10"
    },
    "oosterwolde": {
        "displayName": "Jayden Oosterwolde",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Netherlands",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-04-26"
    },
    "semedo": {
        "displayName": "Nélson Semedo",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1993-11-16"
    },
    "bartugelmaz": {
        "displayName": "Bartuğ Elmaz",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2003-02-17"
    },
    "gkederson": {
        "displayName": "Ederson",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1993-08-17"
    },
    "mertgunok": {
        "displayName": "Mert Günok",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 34,
        "dateofbirth": "1989-03-01"
    },
    "skriniar": {
        "displayName": "Milan Škriniar",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Slovakia",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1995-02-11"
    },
    "nene": {
        "displayName": "Dorgeles Nene",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Mali",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2002-12-23"
    },
    "oguzaydin": {
        "displayName": "Oğuz Aydın",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2000-10-27"
    },
    "ognjenmimovic": {
        "displayName": "Ognjen Mimović",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Serbia",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "2004-08-17"
    },
    "kante": {
        "displayName": "N'Golo Kanté",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 91,
        "dateofbirth": "1991-03-29"
    },
    "cakir": {
        "displayName": "Uğurcan Çakır",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-04-05"
    },
    "chadaillebitshiabu": {
        "displayName": "Chadaille Bitshiabu",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-05-16"
    },
    "jakobs": {
        "displayName": "Ismail Jakobs",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Senegal",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-17"
    },
    "eyupaydn": {
        "displayName": "Eyüp Aydın",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2004-08-02"
    },
    "davinsonsanchez": {
        "displayName": "Davinson Sánchez",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Colombia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-06-12"
    },
    "sallai": {
        "displayName": "Roland Sallai",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Hungary",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "1997-05-22"
    },
    "gabrielsara": {
        "displayName": "Gabriel Sara",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-06-26"
    },
    "sane": {
        "displayName": "Leroy Sané",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1996-01-11"
    },
    "yunusakgun": {
        "displayName": "Yunus Akgün",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-07-07"
    },
    "erenelmali": {
        "displayName": "Eren Elmalı",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-07-07"
    },
    "lesleyugochukwu": {
        "displayName": "Lesley Ugochukwu",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2004-03-26"
    },
    "guvenc": {
        "displayName": "Günay Güvenç",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 19,
        "dateofbirth": "1991-06-25"
    },
    "gundogan": {
        "displayName": "İlkay Gündoğan",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1990-10-24"
    },
    "denizgul": {
        "displayName": "Deniz Gül",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2004-07-02"
    },
    "kaanayhan": {
        "displayName": "Kaan Ayhan",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1994-11-10"
    },
    "jankatylmaz": {
        "displayName": "Jankat Yılmaz",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "2004-08-16"
    },
    "leao": {
        "displayName": "Rafael Leão",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "1999-06-10"
    },
    "torreira": {
        "displayName": "Lucas Torreira",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "1996-02-11"
    },
    "bardakci": {
        "displayName": "Abdülkerim Bardakcı",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "1994-09-07"
    },
    "osimhen": {
        "displayName": "Victor Osimhen",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "1998-12-29"
    },
    "barsylmaz": {
        "displayName": "Barış Yılmaz",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 53,
        "dateofbirth": "2000-05-23"
    },
    "adayuzgec": {
        "displayName": "Ada Yüzgeç",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 62,
        "dateofbirth": "2009-04-03"
    },
    "beratlus": {
        "displayName": "Berat Luş",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 73,
        "dateofbirth": "2007-04-20"
    },
    "renatonhaga": {
        "displayName": "Renato Nhaga",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Guinea-Bissau",
        "position": "Midfielder",
        "number": 74,
        "dateofbirth": "2007-03-27"
    },
    "alekseybatrakov": {
        "displayName": "Aleksey Batrakov",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Russia",
        "position": "Midfielder",
        "number": 83,
        "dateofbirth": "2005-06-09"
    },
    "karatas": {
        "displayName": "Kazımcan Karataş",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 88,
        "dateofbirth": "2003-01-16"
    },
    "singo": {
        "displayName": "Wilfried Singo",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 90,
        "dateofbirth": "2000-12-25"
    },
    "unyay": {
        "displayName": "Arda Ünyay",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2007-01-18"
    },
    "lemina": {
        "displayName": "Mario Lemina",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Gabon",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "1993-09-01"
    },
    "ahmetyldrm": {
        "displayName": "Ahmet Doğan Yıldırım",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2006-11-01"
    },
    "batistamendy": {
        "displayName": "Batista Mendy",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 3,
        "dateofbirth": "2000-01-12"
    },
    "sametakaydin": {
        "displayName": "Samet Akaydin",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1994-03-13"
    },
    "yokuslu": {
        "displayName": "Okay Yokuşlu",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1994-03-09"
    },
    "fabinho": {
        "displayName": "Fabinho",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1993-10-23"
    },
    "muci": {
        "displayName": "Ernest Muçi",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Albania",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-03-19"
    },
    "bouchouari": {
        "displayName": "Benjamin Bouchouari",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-11-13"
    },
    "franculino": {
        "displayName": "Franculino",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Guinea-Bissau",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-06-28"
    },
    "salah": {
        "displayName": "Mohamed Salah",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Egypt",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1992-06-15"
    },
    "ozantufan": {
        "displayName": "Ozan Tufan",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1995-03-23"
    },
    "umutnayir": {
        "displayName": "Umut Nayir",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-06-28"
    },
    "savic": {
        "displayName": "Stefan Savić",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Montenegro",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1991-01-08"
    },
    "ruslanmalinovskyi": {
        "displayName": "Ruslan Malinovskyi",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1993-05-04"
    },
    "eskihellac": {
        "displayName": "Mustafa Eskihellaç",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1997-05-05"
    },
    "pina": {
        "displayName": "Wagner Pina",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Cape Verde",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-11-03"
    },
    "onana": {
        "displayName": "André Onana",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Cameroon",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1996-04-02"
    },
    "cevikkan": {
        "displayName": "Onuralp Çevikkan",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2006-01-02"
    },
    "jabol_folcarelli": {
        "displayName": "Tim Jabol-Folcarelli",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1999-12-06"
    },
    "chibuikenwaiwu": {
        "displayName": "Chibuike Nwaiwu",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2003-07-23"
    },
    "onuachu": {
        "displayName": "Paul Onuachu",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "1994-05-28"
    },
    "cenkozkacar": {
        "displayName": "Cenk Özkacar",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2000-10-06"
    },
    "arseniybatahov": {
        "displayName": "Arseniy Batahov",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ukraine",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-03-05"
    },
    "sidnycabral": {
        "displayName": "Sidny Lopes Cabral",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Cape Verde",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "2002-09-18"
    },
    "melihkabasakal": {
        "displayName": "Melih Kabasakal",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 57,
        "dateofbirth": "1996-02-18"
    },
    "aralsimsir": {
        "displayName": "Aral Şimşir",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 58,
        "dateofbirth": "2002-06-19"
    },
    "canak": {
        "displayName": "Cihan Çanak",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 61,
        "dateofbirth": "2005-01-24"
    },
    "noahsaviolo": {
        "displayName": "Noah Saviolo",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2004-03-07"
    },
    "erols_colak": {
        "displayName": "Erol Can Çolak",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2006-04-10"
    },
    "tete": {
        "displayName": "Tetê",
        "club": "Grêmio",
        "league": "Brasileiro",
        "country": "Brasil",
        "position": "Attacker",
        "number": 11,
        "dateofbirth": "2000-02-15"
    },
    "chrisbrady": {
        "displayName": "Chris Brady",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2004-03-03"
    },
    "jeffgal": {
        "displayName": "Jeff Gal",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1993-04-06"
    },
    "joshcohen": {
        "displayName": "Josh Cohen",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "1992-08-19"
    },
    "leonardobarroso": {
        "displayName": "Leonardo Barroso",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-06-16"
    },
    "jackelliott": {
        "displayName": "Jack Elliott",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1995-08-25"
    },
    "mbekezelimbokazi": {
        "displayName": "Mbekezeli Mbokazi",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "South Africa",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2005-09-19"
    },
    "samrogers": {
        "displayName": "Sam Rogers",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-05-17"
    },
    "viktorradojevic": {
        "displayName": "Viktor Radojević",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Serbia",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2004-07-14"
    },
    "andrewgutman": {
        "displayName": "Andrew Gutman",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1996-10-02"
    },
    "joelwaterman": {
        "displayName": "Joel Waterman",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1996-01-24"
    },
    "andreashancheolsen": {
        "displayName": "Andreas Hanche-Olsen",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Norway",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1997-01-17"
    },
    "mauriciopineda": {
        "displayName": "Mauricio Pineda",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1997-10-17"
    },
    "jonathandean": {
        "displayName": "Jonathan Dean",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1997-05-15"
    },
    "djedavilla": {
        "displayName": "Djé D'Avilla",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2003-05-05"
    },
    "antonsaletros": {
        "displayName": "Anton Salétros",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-04-12"
    },
    "marennaileselassie": {
        "displayName": "Maren Haile-Selassie",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-03-13"
    },
    "chrismueller": {
        "displayName": "Chris Mueller",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-08-29"
    },
    "andrefranco": {
        "displayName": "André Franco",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-04-12"
    },
    "robinlod": {
        "displayName": "Robin Lod",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Finland",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1993-04-17"
    },
    "anzormekvabishvili": {
        "displayName": "Anzor Mekvabishvili",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-06-05"
    },
    "davidporeba": {
        "displayName": "David Poreba",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2002-12-01"
    },
    "sergiooregel": {
        "displayName": "Sergio Oregel",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2005-05-16"
    },
    "robertturdean": {
        "displayName": "Robert Turdean",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2010-01-14"
    },
    "robertlewandowski": {
        "displayName": "Robert Lewandowski",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Poland",
        "position": "Attacker",
        "number": 9,
        "dateofbirth": "1988-08-21"
    },
    "philipzinckernagel": {
        "displayName": "Philip Zinckernagel",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Denmark",
        "position": "Attacker",
        "number": 11,
        "dateofbirth": "1994-12-16"
    },
    "pusodithejane": {
        "displayName": "Puso Dithejane",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "South Africa",
        "position": "Attacker",
        "number": 12,
        "dateofbirth": "2004-06-24"
    },
    "johangomez": {
        "displayName": "Johan Gomez",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Attacker",
        "number": 18,
        "dateofbirth": "2001-07-23"
    },
    "jonathanbamba": {
        "displayName": "Jonathan Bamba",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "Ivory Coast",
        "position": "Attacker",
        "number": 19,
        "dateofbirth": "1996-03-26"
    },
    "deanboltz": {
        "displayName": "Dean Boltz",
        "club": "Chicago Fire",
        "league": "MLS",
        "country": "United States",
        "position": "Attacker",
        "number": 28,
        "dateofbirth": "2006-06-07"
    },
    "emilaudero": {
        "displayName": "Emil Audero",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-01-18"
    },
    "pepereina": {
        "displayName": "Pepe Reina",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1982-08-31"
    },
    "maurovigorito": {
        "displayName": "Mauro Vigorito",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1990-05-22"
    },
    "marcgassama": {
        "displayName": "Marc Gassama",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2002-04-12"
    },
    "marcgoltz": {
        "displayName": "Marc-Oliver Kempf",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Germany",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-01-28"
    },
    "marcodossena": {
        "displayName": "Alberto Dossena",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-10-13"
    },
    "edoardogoldaniga": {
        "displayName": "Edoardo Goldaniga",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1993-11-02"
    },
    "ignacabarba": {
        "displayName": "Ignace Van der Brempt",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2002-04-01"
    },
    "albertomoreno": {
        "displayName": "Alberto Moreno",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1992-07-05"
    },
    "felipejack": {
        "displayName": "Felipe Jack",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 93,
        "dateofbirth": "2006-01-12"
    },
    "mergimvojvoda": {
        "displayName": "Mërgim Vojvoda",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Kosovo",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1995-02-01"
    },
    "marcosenna": {
        "displayName": "Marco Sala",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-06-04"
    },
    "maximoesperon": {
        "displayName": "MMáximo Perrone",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-01-07"
    },
    "gabriellelloni": {
        "displayName": "Gabriele Mazzitelli",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "1995-10-14"
    },
    "lucasdacunha": {
        "displayName": "Lucas Da Cunha",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2001-06-09"
    },
    "yannikengels": {
        "displayName": "Yannik Engelhardt",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Germany",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2001-02-07"
    },
    "matthiasbraunoder": {
        "displayName": "Matthias Braunöder",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Austria",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2002-03-27"
    },
    "danielebaselli": {
        "displayName": "Daniele Baselli",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1992-03-12"
    },
    "nicopaz": {
        "displayName": "Nico Paz",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 79,
        "dateofbirth": "2004-09-08"
    },
    "gabrielstrefezza": {
        "displayName": "Gabriel Strefezza",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Attacker",
        "number": 7,
        "dateofbirth": "1997-04-18"
    },
    "patrickcutrone": {
        "displayName": "Patrick Cutrone",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Attacker",
        "number": 9,
        "dateofbirth": "1998-01-03"
    },
    "andreabelotti": {
        "displayName": "Andrea Belotti",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Attacker",
        "number": 11,
        "dateofbirth": "1993-12-20"
    },
    "alieufadera": {
        "displayName": "Alieu Fadera",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Gambia",
        "position": "Attacker",
        "number": 16,
        "dateofbirth": "2001-11-03"
    },
    "albertocerri": {
        "displayName": "Alberto Cerri",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Italy",
        "position": "Attacker",
        "number": 17,
        "dateofbirth": "1996-04-16"
    },
    "alijasim": {
        "displayName": "Ali Jasim",
        "club": "Como 1907",
        "league": "Serie A",
        "country": "Iraq",
        "position": "Attacker",
        "number": 14,
        "dateofbirth": "2004-01-20"
    }
};
